/* AE Delivery Promise Widget — v3 (header inline + EN/VI i18n).
 *
 * BACKEND LOGIC (haversine, 5-tier, cutoff, federal holidays, weekend skip,
 * localStorage 'ae_zip_code') — UNCHANGED from build #2 (trừ lịch nghỉ: từ 24/10/2026
 * xe nhà làm T2–T7, gửi hãng T2–T6, bảng lễ = ngày UPS/USPS không lấy hàng — xem
 * khối "ngày lễ + hai lịch làm việc"). Only UI text now
 * routes through an i18n translation system so EN/VI can be switched at runtime.
 *
 * Origin = ORIGIN_ZIP bên dưới (kho ở Arlington TX — location của Shopify; ZIP
 * chỉ ghi ở MỘT chỗ đó, đừng chép vào chú thích); tier cutoff = 12 (tier1) /
 * 14 (tier2-5), CT. Đổi ORIGIN_ZIP ⇒ node scripts/build-zip-tiers.js.
 */
(function () {
  'use strict';

  // ═══════════════════════════════════════════════════════════════════
  // i18n
  // ═══════════════════════════════════════════════════════════════════
  var STORAGE_LANG = 'ae_lang';
  var DEFAULT_LANG = 'en';

  var I18N = {
    en: {
      'logo.tagline':         'DFW LOCAL DELIVERY',
      'search.placeholder':   'Search products...',
      'contact.text_only':    "Text only — please don't call",
      /* Biểu mẫu trang /pages/contact. Chữ vẽ lần đầu vẫn do `| t` lo (locales/
         en.default.json), năm khoá này chỉ để nút VI với tới được — `| t` bị Liquid
         đóng băng lúc render nên tự nó không bao giờ đổi tiếng. GIÁ TRỊ EN PHẢI
         TRÙNG ĐÚNG en.default.json, lệch một chữ là lặng lẽ đổi lời tiếng Anh. */
      'contact.f_name':       'Name',
      'contact.f_email':      'Email',
      'contact.f_phone':      'Phone number',
      'contact.f_comment':    'Comment',
      'contact.f_send':       'Send',
      'contact.page_title':   'Contact – A&E Foodstore',
      /* Chép ĐÚNG locales/en.default.json:225-226 — lệch một chữ là lặng lẽ đổi
         lời tiếng Anh của khách EN (nút VI ghi đè cả hai chiều). */
      'contact.msg_ok':       "Thanks for contacting us. We'll get back to you as soon as possible.",
      'contact.msg_err':      'Please adjust the following:',
      'header.signin':        'Log in',
      'header.signup':        'Sign up',
      'header.account':       'Account',
      'cart.label':           'Cart',
      'nav.cuisine':          'Shop by Cuisine',
      'nav.category':         'Shop by Category',
      'nav.new':              'New Arrivals',
      'nav.bestsellers':      'Bestsellers',
      'nav.deals':            '🔥 Deals',
      'nav.refer':            'Refer & Save 10%',
      'minicart.aria':        'Shopping cart preview',
      'minicart.close':       'Close cart preview',
      'minicart.delivery':    'Delivery',
      'minicart.go_to_cart':  'Go to cart',
      'recipe.free_ship':        'free shipping on orders over {zone_amount}',
      'recipe.free_ship_remote': 'shipping calculated at checkout for your area',
      'recipe.oos':              'Out of stock',
      /* 30/10/2026 — nhãn dòng tổng bộ nguyên liệu trong thân bài công thức (body_html:
         <span data-i18n="recipe.total">Tổng:</span>). Trước đây "Tổng:" gõ cứng ⇒ khách EN đọc
         "Tổng: $35.95 — your cart shows shipping…" (nửa Việt nửa Anh). */
      'recipe.total':            'Total:',
      /* 🔴 20/8/2026 vòng 23 — câu tình trạng bộ nguyên liệu của bài công thức.
         Thân bài ghi CỨNG "Bộ nguyên liệu hand-picked có sẵn tại AE Foodstore" trên cả
         20 bài. Đo được: 16/37 mã hàng trong các bộ đó đã hết sạch ⇒ 19/20 bài đang hứa
         một thứ không đúng. Bài Bún Bò Huế hứa "có sẵn" trong khi 5/6 món HẾT.
         Không sửa được bằng cách viết lại 20 bài: tồn kho đổi mỗi ngày, chữ cứng thì
         không. Nên câu này do JS ghi theo tồn kho THẬT lúc khách mở trang. */
      'recipe.kit_all':          'Hand-picked ingredients — all {n} in stock today.',
      'recipe.kit_some':         '{n} of {m} ingredients in stock today.',
      'recipe.kit_none':         'This kit is out of stock right now.',
      /* Hộp nổi ĐẦU bài — lời hứa thứ hai, mạnh hơn ("Tất cả") và nằm chỗ ai cũng đọc.
         Cả 20 bài đều có. Không có {n}/{m} thì không nói thật được. */
      'recipe.kit_top_all':      'All {m} ingredients below are in stock',
      'recipe.kit_top_some':     '{n} of {m} ingredients below are in stock today',
      'recipe.kit_top_none':     'The ingredients below are out of stock right now',
      /* Chữ trên các nút do JS của bài công thức dựng ra — applyTranslations()
         không với tới innerHTML dựng bằng JS, nên chúng phải tự tra từ điển. */
      'recipe.add_to_cart':      'Add to cart',
      'recipe.added':            'Added to cart',
      'recipe.add_all':          'Add all {n} essentials to cart',
      'recipe.adding':           'Adding…',
      'recipe.added_open':       '✓ Added — opening cart…',
      'recipe.swap':             'Try instead',
      /* Nhãn cho TRÌNH ĐỌC MÀN HÌNH ở header (20/8/2026, vòng 24). Trước đây 11
         thuộc tính `aria-label` trong sections/header.liquid gõ cứng tiếng Anh —
         khách mù đã chọn tiếng Việt vẫn nghe máy đọc "Open menu", "View cart".
         Chữ NHÌN THẤY thì đã dịch từ lâu; chỉ chữ NGHE ĐƯỢC là bị bỏ quên, và đó
         đúng là thứ không ai phát hiện ra bằng mắt. */
      'aria.open_menu':       'Open menu',
      'aria.language':        'Language',
      'aria.change_zip':      'Change delivery ZIP',
      'aria.search':          'Search',
      'aria.account':         'Account',
      'aria.view_cart':       'View cart',
      'aria.primary_nav':     'Primary navigation',
      'aria.category_tabs':   'Category tabs',
      'aria.close':           'Close',
      'nav.menu_title':       'Menu',
      'nav.menu_close':       'Close menu',
      'nav.home':             'Home',
      'nav.deals_short':      'Deals',
      'nav.recipes':          'Recipes',
      'cuisine.vietnamese':   'Vietnamese',
      'cuisine.korean':       'Korean',
      'cuisine.chinese':      'Chinese',
      'cuisine.japanese':     'Japanese',
      'cuisine.thai':         'Thai',
      'cuisine.filipino':     'Filipino',
      'cuisine.indian':       'Indian',
      'delivery.choose_zip':  'Enter ZIP',
      /* 🔴 8/9/2026 (vòng 45) — KHOÁ NÀY ĐỨNG NGAY SAU 'delivery.choose_zip'
         TRÊN CÙNG MỘT DÒNG CHỮ. Trước đây nó là "Enter ZIP to see", nên thanh
         header điện thoại đọc thành: "📍 Enter ZIP · Enter ZIP to see" —
         lặp một lần rồi đứt câu giữa chừng. Hiện trên MỌI trang di động (bộ soi
         ảnh bắt được cụm này ở 13 tổ hợp). Nay là một vế TỰ ĐỦ NGHĨA để ghép
         với vế trước: "📍 Enter ZIP · see delivery date". */
      'delivery.placeholder': 'see delivery date',
      'sheet.title':          '📍 Enter your ZIP code',
      'sheet.subtitle':       'See exact delivery date for your address',
      'action.confirm':       'Confirm',
      'card.add_to_cart':     'Add to cart',
      'card.max_tooltip':     'Max reached',
      'card.stock_tooltip':   'Only {n} in stock',
      'card.min_hint':        'Min order:',
      /* Nhãn giảm giá trên thẻ. {n} do data-i18n-n điền — cần vậy vì trật tự
         từ hai thứ tiếng khác nhau ("15% OFF" ↔ "GIẢM 15%"). "Giá tốt mỗi ngày"
         dùng cho mức giảm DƯỚI 15%: 44% hàng trong on-sale giảm dưới 5%, gọi hết
         là deal thì lần sau giảm 30% thật cũng không ai tin. */
      'card.off':             '{n}% OFF',
      'card.off_short':       '-{n}%',
      'card.everyday':        'Everyday low price',
      'card.sold_out':        'Sold out',
      /* KHÁC 'card.sold_out'. "Hết hàng" = có món này, tạm hết. Khoá dưới đây là
         tổ hợp quy cách KHÔNG TỒN TẠI (khách chọn cỡ × vị mà tiệm không làm) —
         VariantSelects.setUnavailable() dựng nhãn ấy. Bản EN phải trùng đúng
         `products.product.unavailable` của locales/en.default.json, vì chuỗi
         Shopify chính là đường lui khi từ điển chưa nạp. */
      'card.unavailable':     'Unavailable',
      /* ĐẶT TRƯỚC (S1, 5/9/2026). Chỉ hiện trên gói ĐÃ hết hàng mà Boss bật cho
         bán tiếp — tiền vào ngay, tiệm đi gom hàng, gom không được thì hoàn.
         `{n}` đi qua data-i18n-n vì trật tự hai thứ tiếng khác nhau
         ("within 30 days" ↔ "trong 30 ngày"), y khuôn 'card.off' và 'gap.title'.
         ⚖️ Câu này là LỜI HỨA PHÁP LÝ, không phải chữ trang trí: luật đặt hàng
         qua bưu điện của FTC buộc giao trong khung đã ghi, quá khung thì phải
         cho huỷ + hoàn tiền ngay. Sửa chữ thì đừng bỏ vế hoàn tiền. */
      'preorder.button':      'Pre-order',
      /* 'preorder.badge' PHẢI GIỐNG HỆT 'preorder.button' — chip trên thẻ và nhãn
         trên nút nói CÙNG MỘT khái niệm, hai chữ khác nhau là khách tưởng hai
         chuyện khác nhau. Cùng nếp với card.sold / bflav.sold / seasonal.sold.
         Người gác test-dat-truoc-mot-nguon.js có mệnh đề canh đúng chuyện này. */
      'preorder.badge':       'Pre-order',
      'preorder.note':        'Pre-order: this item is not in stock yet. We buy it in for you — estimated delivery within {n} days, and a full refund if we cannot get it.',
      /* Bản NGẮN cho ngăn giỏ và trang /cart — chỗ chật, nhưng vẫn phải chở đủ hai
         điều kiện: bao lâu, và hoàn tiền. Bỏ vế nào cũng là thu tiền mà giấu điều
         kiện ở bước cuối trước khi khách bấm thanh toán. */
      'preorder.cart_note':   'Pre-order — about {n} days, full refund if we cannot get it.',
      /* ── khoá gộp từ i18n-pending (merge-i18n-pending.js) ── */
      'a11y.collection_label': 'Collection',
      'a11y.skip_content': 'Skip to content',
      'a11y.skip_product': 'Skip to product information',
      'a11y.slider_of': 'of',
      'a11y.zip_label': 'ZIP code',
      /* Nhãn NGHE ĐƯỢC ngoài giỏ (aria-label / title) — 25/9/2026, vòng 53 i18n#7.
         Liquid in chúng bằng `| t` hoặc gõ thẳng ⇒ ĐÓNG BĂNG tiếng Anh lúc render,
         nút VI không với tới, mà setLang đã đặt <html lang="vi"> nên máy đọc đọc
         chữ Anh bằng giọng Việt. Bản EN phải TRÙNG từng chữ bản Liquid đang render
         (locales/en.default.json hoặc chữ gõ thẳng), vì applyTranslations cũng chạy
         ở chiều EN. {n} = data-i18n-n trên cùng thẻ (số trang, số thứ tự ảnh).
         Gác: scripts/test-nhan-nghe-duoc-ngoai-gio-doi-tieng.js */
      'a11y.announcement':   'Announcement',
      'a11y.breadcrumbs':    'breadcrumbs',
      'a11y.breadcrumb':     'Breadcrumb',
      'a11y.pagination':     'Pagination',
      'a11y.page_prev':      'Previous page',
      'a11y.page_next':      'Next page',
      'a11y.page_n':         'Page {n}',
      'a11y.gallery':        'Gallery Viewer',
      'a11y.slide_prev':     'Slide left',
      'a11y.slide_next':     'Slide right',
      'a11y.load_image':     'Load image {n} in gallery view',
      'a11y.load_model':     'Load 3D Model {n} in gallery view',
      'a11y.load_video':     'Load video {n} in gallery view',
      'a11y.xr':             'View in your space, loads item in augmented reality window',
      'a11y.media_gallery':  'Media gallery',
      'a11y.quantity':       'Quantity',
      'a11y.banners':        'Banners',
      'badge.hot': 'HOT',
      'banner.btn_best': 'Shop top 50',
      'banner.btn_deals': 'Shop deals',
      'banner.btn_swan': 'Shop Swan',
      'banner.btn_trend': 'See trending',
      'banner.desc_best': 'Ranked by what actually leaves the shelf.',
      'banner.desc_deals': 'Restocked Monday, gone by Friday.',
      'banner.desc_swan': 'Our exclusive label — rice, noodles, sauces, pickles.',
      'banner.desc_trend': 'What the neighbourhood is cooking this week.',
      'banner.sub_best': 'What everyone buys',
      'banner.sub_deals': 'New markdowns every week',
      'banner.sub_swan': 'Only at A&E',
      'banner.sub_trend': 'Moving fast right now',
      'banner.title_best': 'Best Sellers',
      'banner.title_deals': 'This Week\'s Deals',
      'banner.title_swan': 'Swan Brand',
      'banner.title_trend': 'Trending Now',
      'card.added_ok': 'Your item is successfully added to the Cart!!',
      'card.on_sale': 'Sale',
      'card.qty': 'Qty',
      'facets.apply': 'Apply',
      'facets.clear': 'Clear',
      'facets.clear_all': 'Clear all',
      'facets.clear_all_link': 'clear all',
      'facets.clear_filter': 'Clear filter',
      'facets.empty_title': 'No products found',
      'facets.filter_and_sort': 'Filter and sort',
      'facets.filter_button': 'Filter',
      'facets.from': 'From',
      'facets.max_price': 'The highest price is {n}',
      'facets.of': 'of',
      'facets.page_missing_link': 'Go to page 1',
      'facets.page_missing_title': 'This page doesn\'t exist',
      'facets.product_one': 'product',
      'facets.products': 'products',
      'facets.reset': 'Reset',
      'facets.result_one': 'result',
      'facets.results': 'results',
      'facets.selected': '{n} selected',
      'facets.sort_button': 'Sort',
      'facets.sort_by': 'Sort by:',
      'facets.to': 'To',
      'facets.use_fewer': 'Use fewer filters or',
      'filter.availability': 'Availability',
      'filter.brand': 'Brand',
      'filter.color': 'Color',
      'filter.in_stock': 'In stock',
      'filter.out_of_stock': 'Out of stock',
      'filter.price': 'Price',
      'filter.product_type': 'Product type',
      'filter.size': 'Size',
      'filter.vendor': 'Vendor',
      /* 14/9/2026, vòng 48 — hai nút đổi kiểu xem lưới/danh sách ở trang danh mục
         (sections/main-collection-product-grid.liquid:210-211). Trước đó cả hai là
         <button> TRẦN chứa mỗi một <svg>, nên tên khả truy cập của chúng là chuỗi
         RỖNG: NVDA/VoiceOver đọc đúng hai chữ "button" … "button". Nay có
         aria-label + aria-pressed, và nhãn đi qua data-i18n-aria-label. */
      'view.grid': 'Grid view',
      'view.list': 'List view',
      'footer.col_contact': 'Contact us',
      'footer.col_policies': 'Our Policies',
      'footer.col_products': 'Products',
      'footer.email_label': 'Email',
      'footer.link_bestsellers': 'Best-Sellers',
      'footer.link_blog': 'Blog',
      'footer.link_categories': 'Categories',
      'footer.link_contact': 'Contact us',
      'footer.link_faq': 'FAQ',
      'footer.link_onsale': 'On sale',
      'footer.link_privacy': 'Privacy Policy',
      'footer.link_recipes': 'Recipes',
      'footer.link_refund': 'Refund Policy',
      'footer.link_shipping': 'Shipping Policy',
      'footer.link_terms': 'Terms of Service',
      'footer.link_trending': 'Trending',
      /* ten.* — tên DỮ LIỆU (tiêu đề danh mục/trang/blog Boss đặt trong Shopify) mà
         applyTenDuLieuI18n tra NGƯỢC theo chữ EN (crumb · H1 · chip danh mục liên quan).
         · Chỗ có khoá MENU trỏ tới ⇒ KHÔNG khai ở đây: TEN_DU_LIEU_MUON ngay dưới khối
           I18N MƯỢN chữ VI của khoá menu (đổi chữ menu là crumb đi theo — người gác F).
         · Chỗ KHÔNG khoá menu nào trỏ tới (18/10/2026, vòng 53 đợt 5: 35 tên — người soi
           kiem-song-ngu đo ra 37 tên không phải nhãn hiệu còn tiếng Anh ở VI; 2 chỗ còn
           lại MIỄN có tên trong test-ten-du-lieu-crumb-h1-doi-tieng.js, chờ Boss chốt) ⇒
           khai THẲNG dưới đây: không có chữ menu nào để mượn, nên đây là nguồn DUY NHẤT.
         Chữ EN = ĐÚNG tiêu đề cửa hàng (Admin API 18/10) — chỉ để tra; khách EN luôn đọc
         chữ gốc của dữ liệu. Boss đổi tên danh mục ⇒ dòng đó thôi khớp ⇒ giữ EN (hỏng an
         toàn). Nhãn hiệu (Nongshim, MAMA, Swan Brand…) KHÔNG dịch.
         Người gác: scripts/test-chip-danh-muc-noi-tieng-viet.js */
      'ten.fish_sauce':             'Fish sauce',   // collections/fish-sauce
      'ten.crackers_cookies':       'Crackers & Cookies',   // collections/crackers-cookies
      'ten.cakes':                  'Cakes',   // collections/cakes
      'ten.dried_fruits':           'Dried fruits',   // collections/dried-fruits
      'ten.jerkies':                'Jerkies',   // collections/jerkies
      'ten.dried_seafood':          'Dried seafood',   // collections/dried-seafood
      'ten.seaweed':                'Seaweed',   // collections/seaweed
      'ten.breakfast_foods':        'Breakfast Foods',   // collections/breakfast-foods
      'ten.household_appliances':   'Household Appliances',   // collections/household-aplliances
      'ten.canned':                 'Canned',   // collections/canned
      'ten.best_sellers':           'Best Sellers',   // collections/best-seller
      'ten.air_fresheners':         'Air Fresheners',   // collections/air-fresheners
      'ten.eggs':                   'Eggs',   // collections/eggs
      'ten.milk_cream':             'Milk & Cream',   // collections/milk-cream
      'ten.hair_care':              'Hair Color & Treatment, Shampoo, Shower Gel, Conditioner',   // collections/hair-color-treatment
      'ten.milk_tea':               'Milk Tea',   // collections/milk-tea
      'ten.milk_drink':             'Milk Drink',   // collections/milk-drink
      'ten.moon_cake':              'Moon Cake',   // collections/moon-cake
      'ten.halloween':              'Halloween',   // collections/halloween
      'ten.convenient_meals':       '🏕️ Convenient Meals – 🚀 Your Perfect Companion For Every Journey!',   // collections/convenient-meals
      'ten.instant_refreshment':    '🥤 Instant Refreshment – 😊 🍹 Pick Your Favorite Drink!',   // collections/instant-refreshment
      'ten.awaken_coffee':          '☕ Awaken Your Senses – 🌟 Irresistibly Delicious Coffee!',   // collections/awaken-your-senses-coffee
      'ten.snack_freely':           '🍿 Snack Freely – 😋 Enjoy Every Bite!',   // collections/snack-freely
      'ten.sweetness':              '🍯 The Perfect Sweetness – 🍪 Delicious Treats Just For You!',   // collections/perfect-sweetness
      'ten.candies':                '🍭 Delicious Candies In Every Flavor – 🌈 Pick Your Favorite Taste!',   // collections/delicious-candies
      'ten.essential_spices':       '🥢 The Secret To Rich Flavors – 🍛 Essential Spices For Every Kitchen!',   // collections/essential-spices
      'ten.rich_sauce':             '🍯 Rich & Flavorful Sauce – 🍽️ Enhance Every Dish!',   // collections/rich-flavorful-sauce
      'ten.moonlit_mooncake':       '🌕✨Moonlit Moments – Mooncake Festival🏮🥮',   // collections/moonlit-moments-mooncake-festival
      'ten.top_bestsellers_auto':   'Top Bestsellers Auto',   // collections/top-bestsellers-auto
      'ten.customer_favorites':     'Customer Favorites',   // collections/customer-favorites
      'ten.bundles':                'Bundles & Combos',   // collections/bundles
      'ten.privacy_choices':        'Your Privacy Choices',   // pages/data-sharing-opt-out
      'ten.same_day_dfw':           'Same-day DFW',   // pages/same-day-dfw
      'ten.collabs':                'Collabs',   // pages/collab
      'ten.news':                   'News',   // blogs/news
      'footer.newsletter_desc': 'Thank you for choosing A&E Foodstore. We value your business and can\'t wait to serve you again. Your satisfaction is our priority!',
      'footer.newsletter_heading': 'Join us for exclusive offers and updates. Sign up now and don\'t miss out!',
      'footer.payment_sr': 'Payment methods',
      'footer.area_line': 'Arlington, TX — local delivery within 30\u00A0miles',
      'footer.rights': '· All rights reserved.',
      'footer.subscribe': 'Subscribe',
      'footer.subscribed': 'Thanks for subscribing',
      'price.from': 'From',
      'price.regular_sr': 'Regular price',
      'price.sale_sr': 'Sale price',
      'price.unit_sr': 'Unit price',
      'search.label': 'Search',
      'search.no_hit_post': 'Check the spelling or use a different word or phrase.',
      'search.no_hit_best': 'Best sellers',
      'search.no_hit_pre': 'No results found for',
      'search.result_for': '{n} result found for',
      'search.results_for': '{n} results found for',
      'search.title': 'Search results',
      'strip.cta_brand': 'Shop Swan',
      'strip.cta_bundle': 'Shop Bundles',
      'strip.desc_brand': 'Authentic flavors — only at AE Foodstore',
      'strip.desc_bundle': 'Ready-to-cook combos — buy together, save up to 15%',
      'strip.tag_brand': '✨ Exclusive Brand',
      'strip.tag_bundle': '💰 Bundle & Save',
      'strip.tag_recipe': '🍳 Recipe of the Week',
      'strip.title_brand': 'Swan Brand',
      'strip.title_bundle': 'Bundles & Combos',
      /* Bằng chứng xã hội trên THẺ sản phẩm (custom.units_sold, ngưỡng ≥25).
         CHUỖI NÀY PHẢI GIỐNG HỆT 'bflav.sold' và 'seasonal.sold' — cùng một
         khái niệm thì phải cùng một câu; ba bề mặt mà đọc ra ba câu khác nhau
         là khách thấy tiệm nói năng lộn xộn. Sửa một cái thì sửa cả ba.
         {n} đi qua data-i18n-n vì trật tự từ hai thứ tiếng ngược nhau:
         "1K+ sold" ↔ "Đã bán 1K+". */
      'card.sold':            '{n} sold',
      /* ── khoá gộp từ i18n-pending (merge-i18n-pending.js) ── */
      'bflav.add_n': 'Add {n} flavors',
      'bflav.add_one': 'Add 1 flavor',
      'bflav.added': 'Added ✓',
      'bflav.affinity': '{n}% of shoppers who buy this brand take 2+ flavors',
      'bflav.clears_ship': 'This set unlocks free shipping',
      'bflav.heading': 'Same brand, different flavor',
      'bflav.moq': 'Min {n}',
      'bflav.see_all': 'See all',
      'bflav.sold': '{n} sold',
      'bflav.sub': '96% of our strongest pairs are two flavors of one brand',
      'bflav.total': 'Set total',
      'gap.chip_aria': 'Add {name} — {price}',
      'gap.fee_sub': 'Telling you now so checkout holds no surprises.',
      'gap.fee_title': 'Shipping on this order',
      'gap.progress_aria': 'Progress toward free delivery',
      'gap.section_aria': 'Free delivery progress',
      'gap.sold': '{n} sold',
      'gap.sub': 'Add any one of these to cover it',
      'gap.title': 'You\'re {n} from free delivery',
      'rail.heading': 'Browse our aisles',
      'rail.load_error': 'We couldn\'t load this list.',
      'rail.loading': 'Loading…',
      'rail.new_window': 'Added in the last {n} days',
      'rail.open_collection': 'Open the full collection',
      'rail.proof_orders': '{n} orders delivered',
      'rail.retry': 'Try again',
      'rail.tab_bestsellers': 'Best sellers',
      'rail.tab_exclusive': 'Only at A&E',
      'rail.tab_favorites': 'Customer Favorites',
      'rail.tab_new': 'Just arrived',
      'rail.tablist_label': 'Product lists',
      'rail.prev_aria': 'Previous products',
      'rail.next_aria': 'Next products',
      'banner.prev_aria': 'Previous banners',
      'banner.next_aria': 'Next banners',
      'seasonal.add': 'Add',
      'seasonal.added': 'Added ✓',
      'seasonal.cta': 'Shop all mooncakes',
      'seasonal.days_left': '{n} days to Mid-Autumn',
      'seasonal.editor_bad_date': 'Hidden: festival date not recognised. Use YYYY-MM-DD, e.g. 2026-09-25.',
      'seasonal.editor_cutoff': 'Hidden: past the order cut-off set below, though the festival has not arrived yet.',
      'seasonal.editor_no_products': 'Hidden: fewer buyable products than the minimum set below.',
      'seasonal.editor_season_over': 'Hidden: the festival date has passed. Set next year to bring it back.',
      'seasonal.low_stock': 'Only {n} left',
      'seasonal.one_day': 'Tomorrow is Mid-Autumn',
      'seasonal.sold': '{n} sold',
      'seasonal.sub': 'Boxes from Ba Nam and Happy Elephant',
      'seasonal.title': 'Mooncakes — in season now',
      'seasonal.today': 'Today is Mid-Autumn',
      'seasonal.video_alt': 'Mooncake boxes',
      'seasonal.was': 'Was',
      'banner.upto':          'Up to {n}% off',
      /* Chỉ dùng trên thẻ COMBO (tag `bundle`). Cả câu nằm trong từ điển, số
         tiền vào chỗ {n} qua data-i18n-n — không tách "Save" ra một span rồi
         nối chuỗi, vì tách như vậy là khoá cứng trật tự "chữ trước số sau" cho
         mọi thứ tiếng sau này. */
      'card.save_amount':     'Save {n}',
      'pdp.in_cart':          'In cart — adjust quantity above',
      /* Câu cho THANH DÍNH ĐÁY (20/8/2026). Phải khác câu trên vì thanh dính là
         chỗ khách CHẠM ĐƯỢC — nó phải nói rõ chạm vào thì chuyện gì xảy ra, và
         phải nêu SỐ LƯỢNG, thứ mà nút "Thêm vào giỏ" cũ giấu hoàn toàn.
         `{n}` do applyTranslations thay từ thuộc tính data-i18n-n. */
      'pdp.satc_in_cart':     'In cart: {n} — edit',
      'pdp.save':             'Save',
      'pdp.tax_included':     'Tax included.',
      'pdp.ship_checkout':    'Shipping calculated at checkout.',
      'pdp.tab_details':      'Product details',
      'pdp.tab_shipping':     'Shipping & returns',
      'pdp.ship_sameday':     'Same-day delivery within 20 miles of our Arlington, TX fulfillment center — order before 12 PM CT and choose Local Delivery at checkout. Farther out: next business day or later.',
      'pdp.ship_zones':       'Free-shipping threshold depends on your area — enter your ZIP in the header to see your delivery date.',
      'pdp.ship_policy':      'See full shipping policy',
      'pdp.trust_fresh':      '7-day returns on unopened pantry items — full refund if damaged or wrong',
      'pdp.trust_authentic':  '100% authentic — Vietnamese-owned DFW Asian grocery',
      'pdp.trust_freeship':   'Free shipping over',
      /* Đổi trả + thanh toán, cạnh nút mua (Phase 5, 17/8). Từng chữ ở đây bám
         NGUYÊN VĂN /policies/refund-policy — đã đọc lại trang thật hôm nay, không
         viết theo trí nhớ. Chính sách chỉ có bản tiếng Anh (Shopify policy là đơn
         ngữ), nên bản VI dưới đây là DIỄN ĐẠT LẠI cho khách hiểu, và luôn kèm link
         sang bản gốc — chứ không nhúng thân chính sách vào trang. */
      'pdp.ret_window':       'Damaged, defective or wrong item? Tell us within 7 days — send it back, even if opened, and we pay the return shipping and refund in full',
      'pdp.ret_change':       'Changed your mind? Unopened pantry items (shelf-stable) still in their sealed packaging can be returned within 7 days — you pay the return shipping, and the original shipping charge is not refunded',
      'pdp.ret_perishable':   'Fresh, refrigerated, frozen and fresh-baked items cannot be returned for a change of mind. If one arrives damaged, defective or wrong, tell us within 7 days for a full refund — nothing to send back',
      'pdp.ret_speed':        'Money back to your original payment method within 5 business days — your bank may add a few more days.',
      'pdp.ret_link':         'Full return policy',
      'pdp.pay_secure':       'Secure checkout — encrypted. We never see or store your card number',
      // Welcome popup — câu đầu tiên một khách SEO mới nhìn thấy. Trước đây hardcode
      // "same-day in DFW"; số thật là TX chỉ 8.7% đơn web, nên ~91% người đọc câu đó
      // được hứa một thứ không áp dụng cho họ. {zone_amount} thay theo vùng, xem fillAmount().
      'wpop.hook':             'Authentic Asian groceries — delivered across the US.',
      'wpop.perk_ship':        'Delivered nationwide',
      'wpop.perk_cutoff':      'Processed same business day — before 2 PM CT',
      'wpop.perk_free':        'Free shipping over {zone_amount}',
      'wpop.perk_free_remote': 'Shipping calculated at checkout',
      // Lưới an toàn cho MỌI câu có {zone_amount} mà quên làm bản _remote.
      'zone.no_threshold':     'Shipping calculated at checkout',
      // 28/9/2026 — vùng KHÔNG GIAO (cờ `giao: false` của assets/zone-detection.js):
      // USVI · Guam · Bắc Marianas · American Samoa · APO/FPO/DPO — checkout ra 0 cách giao.
      // MỘT câu cho viên giao hàng, thanh free-ship, ô kiểm ZIP trang same-day.
      'zone.khong_giao':       "We don't ship to your area yet",
      // 10/10/2026 — ĐƠN VỊ số ngày của Shopify (transit time) — PHẢI khớp hằng DON_VI_NGAY_HANG (khối "CHỈ XE
      // NHÀ" ở dưới): 'lam_viec' ⇒ "business days" / "ngày làm việc"; 'lich' ⇒ "days" / "ngày". Người gác
      // scripts/test-chu-chinh-sach-khop-so-ngay.js CA 1 đòi hai bên khớp và trang chính sách in đúng chữ này.
      'ship.don_vi_ngay':      'business days',
      'wpop.perk_authentic':   '100% authentic brands',
      'wpop.deal':             '$10 OFF',
      'wpop.dealsub':          'your first order',
      'wpop.badge':            '🔥 Welcome deal',
      'wpop.email_ph':         'Your email',
      'wpop.cta':              'Claim my $10',
      // Ngõ cụt ở trang tìm kiếm — trước đây mấy chỗ này là khoảng trắng câm.
      'search.none_here':      'No products on this page.',
      /* Lọc/sắp xếp hỏng giữa chừng. Trước đây im lặng hoàn toàn: lưới đứng ở
         trạng thái đang tải, khách không biết là hỏng hay là chậm. */
      'facets.err_load':       "Couldn't load — please try again",
      'search.back_first':     'Back to the first page',
      'search.none_match':     'No products matched your search.',
      'search.try_browse':     'Try one of these instead:',
      'search.all_products':   'All products',
      /* Trang đã LUI về câu trần (aef_raw=1) — search#5, 25/9/2026. Kết quả bên
         dưới là GẦN ĐÚNG, không phải khớp đủ chữ. Khối ẩn sẵn, JS gỡ ẩn. */
      'search.gan_dung_pre':   'Nothing in stock exactly matches',
      'search.gan_dung_post':  'Closest results are below — or browse:',
      /* Ô gợi ý khi đang gõ. Trước 17/8 cả khối này đi bằng `| t` của Shopify,
         tức bám locale storefront chứ không bám `ae_lang` — khách bật tiếng
         Việt vẫn đọc "Products" / "Search for". Xem project_i18n_mechanism. */
      'psearch.products':      'Products',
      'psearch.search_for':    'Search for',
      'psearch.no_results':    'No quick suggestions for',
      'psearch.try_full':      'Press Enter — full search also looks inside product descriptions',
      /* Hai khoá dưới CHỈ dùng cho vùng trình đọc màn hình (span .hidden). Chữ
         phải là một câu ĐỦ NGHĨA khi đọc lên, không phải nhãn cụt như trên. */
      'psearch.aria_count':    '{n} products found for',
      'psearch.loading':       'Loading search results',
      // Blog rỗng / trang blog vượt quá — trước đây cũng là khoảng trắng câm.
      'blog.none_here':        'No posts on this page.',
      'blog.back_first':       'Back to the first page',
      'blog.none_yet':         'No posts here yet.',
      'blog.go_recipes':       'See our recipes',
      /* Chân bài viết (sections/main-article.liquid) — 25/9/2026, vòng 53 i18n#3.
         Trước đó chỉ có `| t` / chữ cài đặt ⇒ nút VI không với tới. Bản EN phải
         TRÙNG từng chữ bản Liquid đang render (locales/en.default.json +
         templates/article.json), không thì khách EN thấy chữ nhảy khi JS chạy.
         share.* đặt tên chung vì nút chia sẻ dùng ở 4 section; share.copied do
         assets/share.js đọc qua aefTFb. Gác: scripts/test-chan-bai-viet-song-ngu.js */
      'blog.tag':              'Tag:',
      'blog.back_to_blog':     'Back to blog',
      'share.label':           'Share',
      'share.link':            'Link',
      'share.copied':          'Link copied to clipboard',
      // Khối lối ra dùng chung (snippets/aef-dead-end.liquid) — hiện ở trang 404.
      'deadend.search_label':  'Search',
      'deadend.search_ph':     'Search for a product…',
      'deadend.search_go':     'Search',
      'deadend.browse':        'Or browse:',
      // Điều kiện THẬT của WELCOME10, đọc từ Admin API 14/8/2026: subtotal >= $100,
      // mỗi khách một lần. Đừng đổi thành "first-time customers only" — cấu hình là
      // DiscountCustomerAll, ai cũng dùng được, chỉ giới hạn MỘT LẦN mỗi người.
      'wpop.terms':            'Minimum order $100 · one use per customer.',
      'wpop.err_email':        'Please enter a valid email.',
      'wpop.sending':          'Sending…',
      'wpop.ok_inbox':         '🎉 Check your inbox — your $10-off code is on the way!',
      // Nói thật khi máy chủ từ chối. Trước đây mọi kết cục đều báo "check your
      // inbox", kể cả khi worker sập — khách ngồi chờ một cái mã không tồn tại.
      'wpop.err_send':         'Couldn’t send just now — please try again.',
      'wpop.fine':             'No spam — unsubscribe anytime.',
      /* 18/10/2026 (vòng 53, đợt 5) — chữ CỨNG của trang đích /pages/same-day-dfw
         (sections/lp-sameday.liquid). Bản EN TRÙNG ĐÚNG chữ đang in trong markup:
         nút VI ghi đè cả hai chiều, lệch một chữ là đổi lời khách EN. Chữ lấy từ CÀI
         ĐẶT section không ở đây — chúng đi cặp data-aef-lang-block + ô *_vi. */
      'lpsd.zip_ph':           'Enter ZIP for same-day',
      'lpsd.zip_btn':          'Check',
      'lpsd.offer_btn':        'Get my code',
      'lpsd.trust_sameday':    'Same-day within 20 mi of Arlington TX',
      'pdp.promo_hot':        'Hot deals — shop the on-sale collection',
      'pdp.promo_bestseller': 'Top',
      'pdp.promo_bestseller2': 'bestseller over the last 30 days',
      'pdp.sold':             'sold',
      'pdp.sold_all':         'all sizes',
      'pdp.alts_title':       'Similar items in stock',
      'form.email_invalid':   'Please enter a valid email — e.g. you@example.com',
      'form.email_hint_tld':  'Missing the ending? e.g. .com',
      'pdp.crumb_home':       'Home',
      'pdp.tab_ingredients':  'Ingredients',
      'pdp.ingredients_fallback': 'Please see the product packaging for the full ingredient and allergen list.',
      'pdp.ingredients_note': 'Always check the physical package for the most current allergen and nutrition information.',
      'pdp.spec_brand':       'Brand',
      'pdp.spec_type':        'Category',
      'pdp.spec_cuisine':     'Cuisine',
      /* GIÁ TRỊ dòng Danh mục trên PDP (product.type) — bản EN phải TRÙNG ĐÚNG chữ
         product.type đang in, không thì khách EN thấy chữ nháy. 'Snacks'/'Beverages'
         dùng lại dept.snacks/dept.beverages; dept.seasoning là "Sauces & Seasoning"
         nên loại 'Seasoning' cần khoá riêng. Ánh xạ nằm ở sections/main-product.liquid. */
      'pdp.type_seasoning':   'Seasoning',
      'pdp.type_canned':      'Canned',
      'section.view_all':     'View all',
      'foryou.title':         '✨ For You',
      'recentlyviewed.title': '👀 Recently viewed',
      'recommend.title':      'You may also like',
      'dept.vietnam':         'Vietnam Market',
      'dept.snacks':          'Snacks',
      'dept.noodles':         'Noodles & Wraps',
      'dept.instant':         'Instant Meals',
      'dept.beverages':       'Beverages',
      'dept.seasoning':       'Sauces & Seasoning',
      'dept.candy':           'Candy',
      'dept.coffee':          'Coffee',
      'dept.tea':             'Tea',
      'dept.rice':            'Rice',
      'dept.household':       'Household',
      'dept.swan':            'Swan Brand',
      'drawer.title':         'Cart',
      'drawer.item':          'item',
      'drawer.items':         'items',
      'drawer.deliver_to':    'Deliver to',
      'drawer.deliver_prompt':'Enter ZIP to see delivery date',
      'drawer.empty':         'Your cart is empty',
      'drawer.continue':      'Continue shopping',
      /* Khối "đã có tài khoản?" ở trang /cart lúc giỏ RỖNG. Trước 5/9 nó chỉ có
         `| t` nên nút đổi tiếng không với tới (xem chú thích dài ở
         sections/main-cart-items.liquid). login_rest CỐ Ý bắt đầu bằng một dấu
         cách: nó nối ngay sau thẻ <a>, không có khoảng trắng nào trong markup. */
      'cart.login_title':     'Have an account?',
      'cart.login_link':      'Log in',
      'cart.login_rest':      ' to check out faster.',
      /* snippets/aef-review-list.liquid — bộ hiển thị review Weee. Snippet CỐ Ý
         chưa nối vào trang nào và chưa đẩy lên theme (xem khai báo trong
         scripts/audit-theme-sync.js), nhưng khoá thì phải có sẵn: bộ gác i18n
         quét khoá trong REPO, và một khoá không có từ điển là chỗ đổi ngôn ngữ
         chết câm — sửa trước lúc ship rẻ hơn sửa sau. {n} qua data-i18n-n. */
      'review.heading':       'Customer reviews',
      'review.count_one':     '1 review',
      'review.count':         '{n} reviews',
      'review.source_note':   'Reviews written by shoppers on',
      'review.source_prefix': 'Review from',
      'review.show_more':     'Show {n} more',
      'review.show_less':     'Show fewer',
      /* 18/10/2026 (vòng 53, đợt 5) — section testimonial (trang same-day). Bản EN TRÙNG
         từng chữ "default" của schema: section chỉ gắn khoá khi ô đang ở chữ mặc định. */
      'review.src_customer':  'Customer review',
      'review.stars_5':       '5 out of 5 stars',
      'testi.eyebrow':        '★ Trusted nationwide ★',
      'testi.heading':        'Loved by thousands of Asian-food lovers',
      'testi.stat_orders':    'Orders',
      'testi.stat_social':    'Social followers',
      'testi.follow':         'Follow us',
      'drawer.only_left_pre': 'Only',
      'drawer.only_left_post':'in stock',
      'drawer.subtotal':      'Subtotal',
      'drawer.savings':       'You save',
      'drawer.total':         'Total',
      'drawer.tax_note':      'Tax included · shipping calculated at checkout',
      'drawer.checkout':      'Checkout',
      /* vòng 53 (cart-api#3) — câu giải thích vì sao nút Thanh toán của ngăn giỏ
         đang khoá: có dòng dưới sàn mua tối thiểu (sections/aef-cart-drawer.liquid). */
      'drawer.below_min':     'Some items are below their minimum order. Add more or remove them to check out.',
      'drawer.view_full':     'View full cart',
      'drawer.trust':         '🛡️ Freshness guaranteed · 100% authentic · shipped nationwide',
      'drawer.zip_unset':     'your area',
      'drawer.cross_sell':    'Customers also bought',
      /* Nhãn LÙI khi Search & Discovery chưa có danh sách "mua chung": dữ liệu
         lúc đó là hàng TƯƠNG TỰ, gọi nó là "khách thường mua chung" là mượn uy
         tín của dữ liệu mình không có. */
      'drawer.cs_related':    'You might also need',
      'drawer.chips_title':   'Add one of these — free shipping unlocked',
      'drawer.add':           'Add',
      'drawer.save_later':    'Save for later',
      /* 🎁 Thanh báo quà tặng — {x} tiền còn thiếu, {ten} tên sản phẩm quà (đọc từ cấu hình, không gõ ở đây). */
      'qua.moi':              'Add {x} more for a FREE {ten}',
      'qua.du':               'You qualify for a FREE {ten} (mainland US)',
      'qua.co':               'Your FREE {ten} is in your cart',
      'qua.nhan':             'Free gift',
      'qua.mien_phi':         'FREE',
      'qua.trang_mo_ta':      'This item is a free gift with qualifying orders and is not sold separately.',
      'drawer.saved':         'Saved for later',
      'drawer.reorder':       'Buy again',
      /* Hai câu phụ khác nhau vì HAI NGUỒN khác nhau: khách đăng nhập thì đó là
         hàng đã MUA thật; khách vãng lai thì tiệm chỉ biết món họ từng CHO VÀO
         GIỎ ở máy này. Ghi chung một câu là nói quá thứ mình biết. */
      'drawer.reorder_sub_orders': 'from your last order',
      'drawer.reorder_sub_local':  'you added these before',
      'drawer.gift':          'Add gift & message',
      'drawer.gift_wrap':     'This is a gift — hide prices on the packing slip',
      'drawer.gift_ph':       'Gift message (optional)',
      /* vòng 53 (i18n#7) — nhãn cho MÁY ĐỌC MÀN HÌNH của ngăn giỏ (data-i18n-aria-label ở
         sections/aef-cart-drawer.liquid). Bản EN phải TRÙNG ĐÚNG chữ gõ sẵn trong markup:
         applyTranslations chạy cả ở chế độ EN, lệch một chữ là đổi nhãn của khách EN.
         Người gác: scripts/test-nhan-doc-man-hinh-gio-co-dich.js */
      'drawer.aria':          'Shopping cart',
      'drawer.close_aria':    'Close cart',
      'drawer.remove_aria':   'Remove item',
      'drawer.gift_aria':     'Gift message',
      'drawer.gift_save':     'Save',
      'drawer.gift_saved':    'Saved ✓',
      'drawer.gift_err':      "Couldn't save — try again",
      'drawer.auto_coupon':   'Auto-applied',
      'drawer.toast_added':   'Added',
      'drawer.toast_items':   '{n} items',
      'drawer.toast_view':    'View cart',
      /* Máy chủ TỪ CHỐI thêm hàng. Trước 14/8/2026 những ca này im lặng tuyệt
         đối trong khi hiệu ứng bay-vào-giỏ + "+1" vẫn chạy → khách tưởng đã thêm.
         Chữ cố ý gộp "hết giới hạn" và "hết hàng" vì Shopify trả 422 cho cả hai
         và câu mô tả của họ chỉ có tiếng Anh — nói gộp thì đúng, dịch được, và
         không bao giờ đoán sai lý do. */
      'drawer.toast_err_limit':   "Couldn't add — item limit reached or out of stock",
      'drawer.toast_err_generic': "Couldn't add to cart — please try again",
      /* Câu của việc XOÁ hỏng (20/8/2026). Phải nói rõ MÓN VẪN CÒN, vì lúc đó
         dòng hàng đang mờ đi trông y như đã bị bỏ — khách cần biết để bấm lại. */
      'drawer.toast_err_remove':  "Couldn't remove it — the item is still in your cart",
      /* Câu của việc BỚT số lượng hỏng (25/9/2026, vòng 53). Trước hôm nay nút
         "−" trên stepper và ô số lượng trang /cart hỏng lượt ghi thì mượn câu
         của đường THÊM ("Couldn't add to cart") — nói ngược ý khách vừa bấm. */
      'drawer.toast_err_update':  "Couldn't change the quantity — please try again",
      'drawer.points_pre':    'This order earns',
      'drawer.points_post':   'points',
      'drawer.or':            'or',
      'drawer.secure_pay':    'Secure checkout',
      'drawer.combo_pre':     'Buy',
      'drawer.combo_for':     'for',
      'drawer.combo_more':    '(add {n} more)',
      'drawer.combo_ok':      '✓ combo applies',
      'fsb.calculating':      'Calculating shipping…',
      'fsb.remote':           'Shipping calculated at checkout (USPS rate)',
      'fsb.add_progress':     'Add {amount} to cart for {label}',
      'fsb.unlocked':         "🎉 You've unlocked {label}!",
      /* Phí giao THẬT lấy từ giỏ phụ Storefront (assets/aef-fsb.js; trước
         27/9/2026 là /cart/shipping_rates.json) (Phase 4+5). Chỉ hiện khi đã
         có số thật — không bao giờ in một con số đoán. */
      'fsb.rate_to':          'Delivery to {zip}: {price}',
      'fsb.rate_days':        '· ~{n} business days',
      'fsb.rate_free_at':     '· free at {amount}',
      'fsb.label_free':       'FREE shipping',
      'fsb.label_local':      'FREE local delivery',
      'fsb.label_usps':       'USPS calculated rate',
      'fsb.sub_sameday':      'Same-day delivery',
      'cart.breadcrumb':      'Your Shopping Cart',
      'cart.title':           'Your cart',
      'cart.head_product':    'Product',
      'cart.head_quantity':   'Quantity',
      'cart.head_total':      'Total',
      'cart.note':            'Order special instructions',
      'cart.subtotal':        'Subtotal:',
      'cart.tax_note_html':   'Tax included. <a href="/pages/shipping-policy">Shipping</a> calculated at checkout.',
      'cart.checkout':        'Check out',
      'cart.max_reached':     'Max reached ({n})',
      /* vòng 53 (i18n#7) — nhãn cho máy đọc màn hình ở trang /cart
         (sections/main-cart-items.liquid). Các khoá cart.sr_qty_* / cart.sr_remove chỉ là
         ĐỘNG TỪ: tên món là node anh em do Liquid in ngay sau (khuôn BUG-J), nên câu
         không được mang tên món hay chữ nối nào khác. EN = đúng chữ đệm trong markup. */
      'cart.discount_aria':   'Discount',
      'cart.sr_qty_for':      'Quantity for',
      'cart.sr_qty_down':     'Decrease quantity for',
      'cart.sr_qty_up':       'Increase quantity for',
      'cart.sr_remove':       'Remove',
      'cart.sr_unit_per':     'per',
      'cart.sr_loading':      'Loading...',
      'footer.also_shop':     'Also shop us on',
      'footer.secure_pay':    'Secure Payment Options',
      'footer.scroll_top':    'Back to top',
      'reorder.title':        'Buy it again',
      'reorder.title_local':  'Buy it again',
      'reorder.subtitle':     'Quick re-add from your last order',
      'reorder.add':          'Add again',
      'reorder.add_all':      'Re-add entire order',
      'reorder.guest':        'Sign in to reorder in one tap',
      'fbt.heading':          'Frequently bought together',
      'fbt.this_item':        'This item:',
      'fbt.total':            'Total price:',
      'fbt.add_all_prefix':   'Add all',
      'fbt.add_all_suffix':   'to cart',
      'fbt.added':            'Added ✓',
      // Phase 3 — khối nội dung SEO (collection + PDP). Chỉ TIÊU ĐỀ đi qua từ điển;
      // ruột FAQ do Boss viết trong metafield nên dịch bằng cách viết, không map ở đây.
      'faq.heading':          'Frequently asked questions',
      'related.heading':      'Related collections',
      // Phase 3 — trang THƯƠNG HIỆU. Tên hãng là giá trị động nên KHÔNG nằm trong
      // khoá nào: câu H1 tách làm ba mảnh (vế trước — tên hãng — vế sau), chỉ hai
      // vế đi qua từ điển. applyTranslations ghi đè textContent nên tên hãng phải
      // là nút anh em, không phải con của [data-i18n] — cùng luật với card.min_hint.
      'brand.h1_prefix':      'Where to buy',
      'brand.h1_suffix':      'near me?',
      'brand.top_heading':    'Top picks from',
      'brand.price_from':     'from',
      'brand.shop_now':       'Shop now',
      'brand.sold_out':       'Out of stock',
      // Phase 3 — dải công thức, chiều ngược của phễu recipe (collection -> bài).
      'recipes.heading':      'Cook with these ingredients',
      /* 15/9/2026, vòng 49 — dải công thức ở sections/recipes-strip.liquid.
         Tiêu đề dải KHÔNG có khoá riêng: nó dùng lại 'strip.tag_recipe' ở trên,
         vì đó cùng một khái niệm với thẻ công thức của featured-content-strip —
         một khái niệm thì một câu, hai bề mặt đọc ra hai câu là tiệm nói lộn xộn.
         'recipes.strip_sub' mang {n} = SỐ BÀI THẬT của /blogs/recipes, do
         data-i18n-n điền từ recipes_blog.articles_count. Đừng thay {n} bằng con
         số: số viết cứng là nguồn dữ liệu thứ hai, Boss đăng bài mới là câu này
         hoá nói dối mà không ai báo. {n} nằm GIỮA câu nên bản VI đảo được trật tự. */
      'recipes.strip_sub':    '{n} Asian recipes — how to cook them, and every ingredient in one click',
      'recipes.card_cta':     'View recipe →',
      'recipes.view_all':     'View all recipes →',
      // Phase 5 — quiz chọn combo (sections/aef-quiz.liquid). Câu hỏi và bảng
      // điểm là của Boss (Artifacts/aef-quiz-preview.html) — bản VI dưới đây là
      // NGUYÊN VĂN chữ Boss viết, bản EN là bản dịch.
      // 'quiz.step' mang {n} nên phải đi kèm data-i18n-n: trật tự từ hai thứ
      // tiếng khác nhau ("Question 2 of 4" ↔ "Câu 2/4").
      'quiz.heading':         'Which combo fits you?',
      'quiz.sub':             "4 quick questions — we'll pick tonight's combo for you",
      'quiz.intro':           "Answer 4 questions and we'll suggest the combo that fits you best — with the live price and a link to buy.",
      'quiz.start':           'Start 🎯',
      'quiz.step':            'Question {n} of 4',
      'quiz.back':            '← Back',
      'quiz.result_tag':      'Best match for you',
      'quiz.save':            'You save',
      'quiz.add':             'Add to cart',
      'quiz.adding':          'Adding…',
      'quiz.added':           'Added ✓',
      'quiz.view':            'View combo',
      'quiz.again':           'Retake quiz ↺',
      // Đường thật thà: combo hợp gu hết hàng thì NÓI THẲNG, không đôn combo
      // khác lên làm "hợp bạn nhất".
      'quiz.oos_title':       'Your best match is sold out right now',
      'quiz.oos_sub':         "We won't point you at something you can't buy. Here's what's in stock today.",
      'quiz.instock':         'In stock today',
      'quiz.browse':          'See all combos',
      'quiz.q1':              'What are you craving today?',
      'quiz.q1a1':            'A hot noodle soup (pho/bun)',
      'quiz.q1a2':            'Bold, saucy noodles',
      'quiz.q1a3':            'Hot rice, home cooking',
      'quiz.q1a4':            'Coffee & drinks',
      'quiz.q1a5':            'Snacks to nibble on',
      'quiz.q2':              'How spicy do you like it?',
      'quiz.q2a1':            'The hotter the better',
      'quiz.q2a2':            'Mild / easy going',
      'quiz.q3':              'How do you like to cook?',
      'quiz.q3a1':            'From scratch, properly',
      'quiz.q3a2':            'Quick and ready to eat',
      'quiz.q4':              'Who are you eating with?',
      'quiz.q4a1':            'Just me / 1–2 people',
      'quiz.q4a2':            'A group / the family'
    },
    vi: {
      'logo.tagline':         'GIAO NỘI THÀNH DFW',
      'search.placeholder':   'Tìm sản phẩm...',
      'contact.text_only':    'Chỉ nhắn tin — xin đừng gọi',
      /* Bản dịch lấy nguyên từ locales/vi.json — file đó KHÔNG BAO GIỜ được
         storefront dùng, nên đây mới là đường duy nhất chữ tới được khách. */
      'contact.f_name':       'Tên',
      'contact.f_email':      'Email',
      'contact.f_phone':      'Số điện thoại',
      'contact.f_comment':    'Bình luận',
      'contact.f_send':       'Gửi',
      'contact.page_title':   'Liên hệ – A&E Foodstore',
      'contact.msg_ok':       'Cảm ơn đã liên hệ với chúng tôi. Chúng tôi sẽ liên hệ lại với bạn trong thời gian sớm nhất.',
      'contact.msg_err':      'Vui lòng điều chỉnh các mục sau:',
      'header.signin':        'Đăng nhập',
      'header.signup':        'Đăng ký',
      'header.account':       'Tài khoản',
      'cart.label':           'Giỏ hàng',
      'nav.cuisine':          'Mua theo ẩm thực',
      'nav.category':         'Mua theo danh mục',
      'nav.new':              'Hàng mới',
      'nav.bestsellers':      'Bán chạy',
      'nav.deals':            '🔥 Giảm giá',
      'nav.refer':            'Giới thiệu, giảm 10%',
      'minicart.aria':        'Xem nhanh giỏ hàng',
      'minicart.close':       'Đóng xem nhanh giỏ',
      'minicart.delivery':    'Giao hàng',
      'minicart.go_to_cart':  'Xem giỏ hàng',
      'recipe.free_ship':        'miễn phí giao cho đơn từ {zone_amount}',
      'recipe.free_ship_remote': 'phí giao tính khi thanh toán cho khu vực của bạn',
      'recipe.oos':              'Tạm hết',
      'recipe.total':            'Tổng:',
      'recipe.kit_all':          'Bộ nguyên liệu chọn sẵn — cả {n} món đều còn hàng hôm nay.',
      'recipe.kit_some':         '{n}/{m} món trong bộ còn hàng hôm nay.',
      'recipe.kit_none':         'Bộ này đang tạm hết hàng.',
      'recipe.kit_top_all':      'Cả {m} nguyên liệu phía dưới đều còn hàng',
      'recipe.kit_top_some':     '{n}/{m} nguyên liệu phía dưới còn hàng hôm nay',
      'recipe.kit_top_none':     'Nguyên liệu phía dưới đang tạm hết hàng',
      'recipe.add_to_cart':      'Thêm vào giỏ',
      'recipe.added':            'Đã thêm vào giỏ',
      'recipe.add_all':          'Thêm cả bộ {n} nguyên liệu vào giỏ',
      'recipe.adding':           'Đang thêm…',
      'recipe.added_open':       '✓ Đã thêm — đang mở giỏ…',
      'recipe.swap':             'Thay bằng',
      'aria.open_menu':       'Mở danh mục',
      'aria.language':        'Ngôn ngữ',
      'aria.change_zip':      'Đổi mã ZIP giao hàng',
      'aria.search':          'Tìm kiếm',
      'aria.account':         'Tài khoản',
      'aria.view_cart':       'Xem giỏ hàng',
      'aria.primary_nav':     'Menu chính',
      'aria.category_tabs':   'Thanh danh mục',
      'aria.close':           'Đóng',
      'nav.menu_title':       'Danh mục',
      'nav.menu_close':       'Đóng danh mục',
      'nav.home':             'Trang chủ',
      'nav.deals_short':      'Giảm giá',
      'nav.recipes':          'Công thức nấu ăn',
      'cuisine.vietnamese':   'Việt Nam',
      'cuisine.korean':       'Hàn Quốc',
      'cuisine.chinese':      'Trung Quốc',
      'cuisine.japanese':     'Nhật Bản',
      'cuisine.thai':         'Thái Lan',
      'cuisine.filipino':     'Philippines',
      'cuisine.indian':       'Ấn Độ',
      'delivery.choose_zip':  'Nhập ZIP',
      'delivery.placeholder': 'xem ngày giao',
      'sheet.title':          '📍 Nhập ZIP để xem ngày giao',
      'sheet.subtitle':       'Xem chính xác ngày giao đến địa chỉ của bạn',
      'action.confirm':       'Xác nhận',
      'card.add_to_cart':     'Thêm vào giỏ',
      'card.max_tooltip':     'Đã đạt giới hạn mua',
      'card.stock_tooltip':   'Chỉ còn {n} trong kho',
      'card.min_hint':        'Mua tối thiểu',
      'card.off':             'GIẢM {n}%',
      'card.off_short':       '-{n}%',
      'card.everyday':        'Giá tốt mỗi ngày',
      'card.sold_out':        'Hết hàng',
      /* Xem chú thích ở nhánh `en`: đây KHÔNG phải "hết hàng". Giữ đúng 12 ký tự
         như 'card.add_to_cart' để nhãn không tràn xuống hai hàng trên nút thẻ. */
      'card.unavailable':     'Không có sẵn',
      /* Xem chú thích dài ở nhánh `en`. Giữ nguyên vế hoàn tiền khi sửa chữ. */
      'preorder.button':      'Đặt trước',
      /* PHẢI GIỐNG HỆT 'preorder.button' — xem chú thích ở nhánh en. */
      'preorder.badge':       'Đặt trước',
      'preorder.note':        'Đặt trước: món này chưa có sẵn. Tiệm gom hàng giúp bạn — dự kiến giao trong {n} ngày, gom không được thì hoàn tiền đầy đủ.',
      'preorder.cart_note':   'Đặt trước — khoảng {n} ngày, gom không được thì hoàn tiền đầy đủ.',
      /* ── khoá gộp từ i18n-pending ── */
      'a11y.collection_label': 'Danh mục',
      'a11y.skip_content': 'Bỏ qua, tới nội dung chính',
      'a11y.skip_product': 'Bỏ qua, tới phần thông tin sản phẩm',
      'a11y.slider_of': 'trên',
      'a11y.zip_label': 'Mã ZIP',
      'a11y.announcement':   'Thông báo',
      'a11y.breadcrumbs':    'Đường dẫn trang',
      'a11y.breadcrumb':     'Đường dẫn trang',
      'a11y.pagination':     'Phân trang',
      'a11y.page_prev':      'Trang trước',
      'a11y.page_next':      'Trang sau',
      'a11y.page_n':         'Trang {n}',
      'a11y.gallery':        'Khung xem ảnh sản phẩm',
      'a11y.slide_prev':     'Ảnh trước',
      'a11y.slide_next':     'Ảnh sau',
      'a11y.load_image':     'Xem ảnh {n} trong khung ảnh',
      'a11y.load_model':     'Xem mô hình 3D {n} trong khung ảnh',
      'a11y.load_video':     'Xem video {n} trong khung ảnh',
      'a11y.xr':             'Xem trong không gian của bạn, mở sản phẩm bằng thực tế tăng cường',
      'a11y.media_gallery':  'Thư viện ảnh',
      'a11y.quantity':       'Số lượng',
      'a11y.banners':        'Băng quảng cáo',
      'badge.hot': 'HOT',
      'banner.btn_best': 'Xem top 50',
      'banner.btn_deals': 'Xem ưu đãi',
      'banner.btn_swan': 'Xem Swan',
      'banner.btn_trend': 'Xem hàng hot',
      'banner.desc_best': 'Xếp theo món thật sự bán hết kệ.',
      'banner.desc_deals': 'Thứ Hai về hàng, thứ Sáu là hết.',
      'banner.desc_swan': 'Nhãn riêng của tiệm — gạo, mì, nước chấm, đồ muối.',
      'banner.desc_trend': 'Tuần này cả xóm đang nấu món gì.',
      'banner.sub_best': 'Ai cũng mua',
      'banner.sub_deals': 'Tuần nào cũng có hàng giảm mới',
      'banner.sub_swan': 'Chỉ có tại A&E',
      'banner.sub_trend': 'Đang bán rất chạy',
      'banner.title_best': 'Bán chạy nhất',
      'banner.title_deals': 'Ưu đãi tuần này',
      'banner.title_swan': 'Thương hiệu Swan',
      'banner.title_trend': 'Đang hot',
      'card.added_ok': 'Đã thêm vào giỏ!',
      'card.on_sale': 'Giảm giá',
      'card.qty': 'Số lượng',
      'facets.apply': 'Áp dụng',
      'facets.clear': 'Xoá',
      'facets.clear_all': 'Xoá hết',
      'facets.clear_all_link': 'xoá hết bộ lọc',
      'facets.clear_filter': 'Bỏ bộ lọc này',
      'facets.empty_title': 'Không tìm thấy sản phẩm nào',
      'facets.filter_and_sort': 'Lọc và sắp xếp',
      'facets.filter_button': 'Lọc',
      'facets.from': 'Từ',
      'facets.max_price': 'Giá cao nhất là {n}',
      'facets.of': 'trên',
      'facets.page_missing_link': 'Về trang 1',
      'facets.page_missing_title': 'Trang này không tồn tại',
      'facets.product_one': 'sản phẩm',
      'facets.products': 'sản phẩm',
      'facets.reset': 'Đặt lại',
      'facets.result_one': 'kết quả',
      'facets.results': 'kết quả',
      'facets.selected': 'Đã chọn {n}',
      'facets.sort_button': 'Sắp xếp',
      'facets.sort_by': 'Sắp xếp:',
      'facets.to': 'Đến',
      'facets.use_fewer': 'Bớt bộ lọc lại, hoặc',
      'filter.availability': 'Tình trạng hàng',
      'filter.brand': 'Thương hiệu',
      'filter.color': 'Màu',
      'filter.in_stock': 'Còn hàng',
      'filter.out_of_stock': 'Hết hàng',
      'filter.price': 'Giá',
      'filter.product_type': 'Loại sản phẩm',
      'filter.size': 'Kích cỡ',
      'filter.vendor': 'Nhà cung cấp',
      /* 14/9/2026, vòng 48 — cặp EN ở trên (view.grid / view.list). */
      'view.grid': 'Xem dạng lưới',
      'view.list': 'Xem dạng danh sách',
      'footer.col_contact': 'Liên hệ',
      'footer.col_policies': 'Chính sách',
      'footer.col_products': 'Sản phẩm',
      'footer.email_label': 'Email',
      'footer.link_bestsellers': 'Bán chạy',
      'footer.link_blog': 'Bài viết',
      'footer.link_categories': 'Danh mục',
      'footer.link_contact': 'Liên hệ',
      'footer.link_faq': 'Hỏi đáp',
      'footer.link_onsale': 'Đang giảm giá',
      'footer.link_privacy': 'Chính sách bảo mật',
      'footer.link_recipes': 'Công thức nấu ăn',
      'footer.link_refund': 'Chính sách hoàn tiền',
      'footer.link_shipping': 'Chính sách giao hàng',
      'footer.link_terms': 'Điều khoản dịch vụ',
      'footer.link_trending': 'Đang hot',
      'ten.fish_sauce':             'Nước mắm',
      'ten.crackers_cookies':       'Bánh quy & Bánh giòn',
      'ten.cakes':                  'Bánh ngọt',
      'ten.dried_fruits':           'Trái cây sấy',
      'ten.jerkies':                'Thịt khô',
      'ten.dried_seafood':          'Hải sản khô',
      'ten.seaweed':                'Rong biển',
      'ten.breakfast_foods':        'Đồ ăn sáng',
      'ten.household_appliances':   'Đồ điện gia dụng',
      'ten.canned':                 'Đồ hộp',
      'ten.best_sellers':           'Hàng bán chạy',
      'ten.air_fresheners':         'Khử mùi phòng',
      'ten.eggs':                   'Trứng',
      'ten.milk_cream':             'Sữa & Kem',
      'ten.hair_care':              'Nhuộm & dưỡng tóc, dầu gội, sữa tắm, dầu xả',
      'ten.milk_tea':               'Trà sữa',
      'ten.milk_drink':             'Thức uống từ sữa',
      'ten.moon_cake':              'Bánh trung thu',
      'ten.halloween':              'Lễ hội Halloween',
      'ten.convenient_meals':       '🏕️ Bữa ăn tiện lợi – 🚀 Bạn đồng hành trên mọi chuyến đi!',
      'ten.instant_refreshment':    '🥤 Giải khát tức thì – 😊 🍹 Chọn thức uống bạn thích!',
      'ten.awaken_coffee':          '☕ Đánh thức giác quan – 🌟 Cà phê thơm ngon khó cưỡng!',
      'ten.snack_freely':           '🍿 Ăn vặt thả ga – 😋 Ngon từng miếng!',
      'ten.sweetness':              '🍯 Ngọt vừa ý – 🍪 Món ngon dành riêng cho bạn!',
      'ten.candies':                '🍭 Kẹo ngon đủ vị – 🌈 Chọn vị bạn thích!',
      'ten.essential_spices':       '🥢 Bí quyết đậm đà – 🍛 Gia vị không thể thiếu cho mọi gian bếp!',
      'ten.rich_sauce':             '🍯 Nước sốt đậm đà – 🍽️ Thêm ngon mọi món!',
      'ten.moonlit_mooncake':       '🌕✨Đêm trăng rằm – Tết Trung Thu🏮🥮',
      'ten.top_bestsellers_auto':   'Bán chạy hàng đầu (tự động)',
      'ten.customer_favorites':     'Khách yêu thích nhất',
      'ten.bundles':                'Gói & Combo',
      'ten.privacy_choices':        'Lựa chọn quyền riêng tư của bạn',
      'ten.same_day_dfw':           'Giao trong ngày DFW',
      'ten.collabs':                'Hợp tác',
      'ten.news':                   'Tin tức',
      'footer.newsletter_desc': 'Cảm ơn bạn đã chọn A&E Foodstore. Tiệm quý từng đơn hàng của bạn và mong sớm được phục vụ bạn lần nữa. Bạn hài lòng là tiệm vui!',
      'footer.newsletter_heading': 'Đăng ký để nhận ưu đãi riêng và tin hàng mới về. Đăng ký ngay kẻo lỡ!',
      'footer.payment_sr': 'Các hình thức thanh toán',
      'footer.area_line': 'Arlington, TX — giao nội vùng trong bán kính 30\u00A0dặm',
      'footer.rights': '· Bảo lưu mọi quyền.',
      'footer.subscribe': 'Đăng ký',
      'footer.subscribed': 'Cảm ơn bạn đã đăng ký',
      'price.from': 'Từ',
      'price.regular_sr': 'Giá gốc',
      'price.sale_sr': 'Giá khuyến mãi',
      'price.unit_sr': 'Đơn giá',
      'search.label': 'Tìm kiếm',
      'search.no_hit_post': 'Thử kiểm lại chính tả, hoặc gõ từ khác xem sao.',
      'search.no_hit_best': 'Hàng bán chạy',
      'search.no_hit_pre': 'Không có kết quả nào cho',
      'search.result_for': 'Tìm thấy {n} kết quả cho',
      'search.results_for': 'Tìm thấy {n} kết quả cho',
      'search.title': 'Kết quả tìm kiếm',
      'strip.cta_brand': 'Xem hàng Swan',
      'strip.cta_bundle': 'Xem combo',
      'strip.desc_brand': 'Hương vị chuẩn — chỉ có tại AE Foodstore',
      'strip.desc_bundle': 'Combo nấu là ăn ngay — mua chung, tiết kiệm tới 15%',
      'strip.tag_brand': '✨ Thương hiệu độc quyền',
      'strip.tag_bundle': '💰 Mua combo, tiết kiệm',
      'strip.tag_recipe': '🍳 Món của tuần',
      'strip.title_brand': 'Thương hiệu Swan',
      'strip.title_bundle': 'Combo & Bộ sưu tập',
      /* Xem chú thích ở bảng EN — phải khớp 'bflav.sold' / 'seasonal.sold'. */
      'card.sold':            'Đã bán {n}',
      /* ── khoá gộp từ i18n-pending ── */
      'bflav.add_n': 'Thêm {n} vị',
      'bflav.add_one': 'Thêm 1 vị',
      'bflav.added': 'Đã thêm ✓',
      'bflav.affinity': '{n}% khách mua hãng này lấy từ 2 vị trở lên',
      'bflav.clears_ship': 'Thêm bộ này là đủ ngưỡng miễn phí ship',
      'bflav.heading': 'Cùng thương hiệu, khác vị',
      'bflav.moq': 'Tối thiểu {n}',
      'bflav.see_all': 'Xem tất cả',
      'bflav.sold': 'Đã bán {n}',
      'bflav.sub': '96% cặp mua chung nhiều nhất ở tiệm là hai vị của cùng một hãng',
      'bflav.total': 'Tổng bộ',
      'gap.chip_aria': 'Thêm {name} — {price}',
      'gap.fee_sub': 'Nói trước để bạn khỏi bất ngờ lúc thanh toán.',
      'gap.fee_title': 'Phí giao đơn này',
      'gap.progress_aria': 'Tiến trình tới mức miễn phí giao',
      'gap.section_aria': 'Tiến trình miễn phí giao',
      'gap.sold': 'Đã bán {n}',
      'gap.sub': 'Thêm bất kỳ món nào dưới đây là đủ',
      'gap.title': 'Còn thiếu {n} là được miễn phí giao',
      'rail.heading': 'Dạo quanh gian hàng',
      'rail.load_error': 'Không tải được danh sách này.',
      'rail.loading': 'Đang tải…',
      'rail.new_window': 'Lên kệ trong {n} ngày qua',
      'rail.open_collection': 'Mở cả danh mục',
      'rail.proof_orders': '{n} đơn đã giao',
      'rail.retry': 'Thử lại',
      'rail.tab_bestsellers': 'Bán chạy',
      'rail.tab_exclusive': 'Chỉ có ở A&E',
      'rail.tab_favorites': 'Khách yêu thích',
      'rail.tab_new': 'Mới về',
      'rail.tablist_label': 'Các danh sách sản phẩm',
      'rail.prev_aria': 'Các món trước đó',
      'rail.next_aria': 'Các món tiếp theo',
      'banner.prev_aria': 'Các banner trước',
      'banner.next_aria': 'Các banner tiếp theo',
      'seasonal.add': 'Thêm',
      'seasonal.added': 'Đã thêm ✓',
      'seasonal.cta': 'Xem tất cả bánh Trung Thu',
      'seasonal.days_left': 'Còn {n} ngày tới Rằm Trung Thu',
      'seasonal.editor_bad_date': 'Đang ẩn: không đọc được ngày lễ. Gõ theo dạng YYYY-MM-DD, ví dụ 2026-09-25.',
      'seasonal.editor_cutoff': 'Đang ẩn: đã qua hạn đặt hàng đặt bên dưới, dù chưa tới ngày lễ.',
      'seasonal.editor_no_products': 'Đang ẩn: số sản phẩm còn hàng ít hơn ngưỡng đặt bên dưới.',
      'seasonal.editor_season_over': 'Đang ẩn: đã qua ngày lễ. Đổi sang ngày của năm sau để khối hiện lại.',
      'seasonal.low_stock': 'Chỉ còn {n} hộp',
      'seasonal.one_day': 'Mai là Rằm Trung Thu',
      'seasonal.sold': 'Đã bán {n}',
      'seasonal.sub': 'Bánh của Ba Nam và Happy Elephant',
      'seasonal.title': 'Bánh Trung Thu — mùa đang mở',
      'seasonal.today': 'Hôm nay là Rằm Trung Thu',
      'seasonal.video_alt': 'Bánh Trung Thu',
      'seasonal.was': 'Giá gốc',
      'banner.upto':          'Giảm tới {n}%',
      'card.save_amount':     'Tiết kiệm {n}',
      'pdp.in_cart':          'Đã có trong giỏ — chỉnh số lượng ở trên',
      'pdp.satc_in_cart':     'Trong giỏ: {n} — sửa',
      'pdp.save':             'Tiết kiệm',
      'pdp.tax_included':     'Đã bao gồm thuế.',
      'pdp.ship_checkout':    'Phí giao được tính khi thanh toán.',
      'pdp.tab_details':      'Chi tiết sản phẩm',
      'pdp.tab_shipping':     'Giao hàng & đổi trả',
      'pdp.ship_sameday':     'Giao trong ngày trong bán kính 20 dặm quanh kho Arlington TX — đặt trước 12 giờ trưa (giờ miền Trung, CT) và chọn Giao nội vùng (Local Delivery) ở bước thanh toán. Xa hơn: ngày làm việc kế tiếp trở đi.',
      'pdp.ship_zones':       'Ngưỡng freeship tuỳ khu vực — nhập ZIP trên header để xem ngày giao.',
      'pdp.ship_policy':      'Xem chính sách giao hàng đầy đủ',
      'pdp.trust_fresh':      'Đổi trả 7 ngày với hàng khô chưa mở — hư hoặc giao sai thì hoàn đủ tiền',
      'pdp.trust_authentic':  '100% hàng chuẩn — tiệm đồ Á của người Việt tại DFW',
      'pdp.trust_freeship':   'Freeship cho đơn từ',
      'pdp.ret_window':       'Hàng hư, lỗi hoặc giao sai? Báo tiệm trong 7 ngày — gửi trả về, kể cả đã mở, tiệm chịu phí gửi trả hàng và hoàn đủ tiền',
      'pdp.ret_change':       'Đổi ý? Hàng khô (để được ở nhiệt độ thường), chưa mở, còn nguyên seal thì trả được trong 7 ngày — bạn trả phí gửi trả hàng, phí ship ban đầu không được hoàn',
      'pdp.ret_perishable':   'Hàng tươi, hàng lạnh, đông lạnh và bánh tươi không trả được khi đổi ý. Nếu tới nơi bị hư, lỗi hoặc giao sai, báo tiệm trong 7 ngày để được hoàn đủ tiền — khỏi gửi trả',
      'pdp.ret_speed':        'Tiền hoàn về đúng nguồn thanh toán trong 5 ngày làm việc — ngân hàng có thể cần thêm vài ngày',
      'pdp.ret_link':         'Xem chính sách đổi trả đầy đủ',
      'pdp.pay_secure':       'Thanh toán an toàn — mã hoá. Tiệm không thấy và không lưu số thẻ của bạn',
      'wpop.hook':             'Thực phẩm Á chính gốc — giao đi khắp nước Mỹ.',
      'wpop.perk_ship':        'Giao toàn nước Mỹ',
      'wpop.perk_cutoff':      'Xử lý cùng ngày làm việc — đặt trước 2 giờ chiều CT',
      'wpop.perk_free':        'Miễn phí ship cho đơn từ {zone_amount}',
      'wpop.perk_free_remote': 'Phí ship tính ở bước thanh toán',
      'zone.no_threshold':     'Phí ship tính ở bước thanh toán',
      'zone.khong_giao':       'Tiệm chưa giao tới khu vực của bạn',
      'ship.don_vi_ngay':      'ngày làm việc',
      'wpop.perk_authentic':   '100% thương hiệu chính hãng',
      'wpop.deal':             'GIẢM $10',
      'wpop.dealsub':          'cho đơn đầu tiên',
      'wpop.badge':            '🔥 Ưu đãi chào mừng',
      'wpop.email_ph':         'Email của bạn',
      'wpop.cta':              'Nhận $10 của tôi',
      'search.none_here':      'Trang này không có sản phẩm nào.',
      'facets.err_load':       'Không tải được — vui lòng thử lại',
      'search.back_first':     'Về trang đầu',
      'search.none_match':     'Không tìm thấy sản phẩm nào khớp.',
      'search.try_browse':     'Thử mấy chỗ này xem:',
      'search.all_products':   'Tất cả sản phẩm',
      'search.gan_dung_pre':   'Không có món nào còn hàng khớp đúng',
      'search.gan_dung_post':  'Bên dưới là kết quả gần nhất — hoặc xem:',
      'psearch.products':      'Sản phẩm',
      'psearch.search_for':    'Tìm',
      'psearch.no_results':    'Chưa có gợi ý nhanh cho',
      'psearch.try_full':      'Bấm Enter — tìm đầy đủ soi cả phần mô tả sản phẩm',
      'psearch.aria_count':    'Tìm thấy {n} sản phẩm cho',
      'psearch.loading':       'Đang tải kết quả tìm kiếm',
      'blog.none_here':        'Trang này không có bài nào.',
      'blog.back_first':       'Về trang đầu',
      'blog.none_yet':         'Chỗ này chưa có bài nào.',
      'blog.go_recipes':       'Xem công thức nấu ăn',
      'blog.tag':              'Thẻ:',
      'blog.back_to_blog':     'Quay lại blog',
      'share.label':           'Chia sẻ',
      'share.link':            'Liên kết',
      'share.copied':          'Đã sao chép liên kết',
      'deadend.search_label':  'Tìm kiếm',
      'deadend.search_ph':     'Tìm món bạn cần…',
      'deadend.search_go':     'Tìm',
      'deadend.browse':        'Hoặc xem:',
      'wpop.terms':            'Đơn tối thiểu $100 · mỗi khách dùng một lần.',
      'wpop.err_email':        'Email chưa đúng — kiểm tra lại giúp mình.',
      'wpop.sending':          'Đang gửi…',
      'wpop.ok_inbox':         '🎉 Kiểm tra hộp thư — mã giảm $10 đang trên đường tới!',
      'wpop.err_send':         'Chưa gửi được — bạn thử lại giúp mình nhé.',
      'wpop.fine':             'Không spam — huỷ nhận bất cứ lúc nào.',
      'lpsd.zip_ph':           'Nhập ZIP để kiểm tra',
      'lpsd.zip_btn':          'Kiểm tra',
      'lpsd.offer_btn':        'Nhận mã',
      'lpsd.trust_sameday':    'Giao trong ngày, 20 dặm từ Arlington TX',
      'pdp.promo_hot':        'Deal hot — xem hàng đang giảm giá',
      'pdp.promo_bestseller': 'Top',
      'pdp.promo_bestseller2': 'bán chạy trong 30 ngày qua',
      'pdp.sold':             'đã bán',
      'pdp.sold_all':         'mọi quy cách',
      'pdp.alts_title':       'Món tương tự còn hàng',
      'form.email_invalid':   'Email chưa đúng — ví dụ ban@gmail.com',
      'form.email_hint_tld':  'Thiếu đuôi phải không? ví dụ .com',
      'pdp.crumb_home':       'Trang chủ',
      'pdp.tab_ingredients':  'Thành phần',
      'pdp.ingredients_fallback': 'Vui lòng xem bao bì sản phẩm để biết thành phần và dị ứng đầy đủ.',
      'pdp.ingredients_note': 'Luôn kiểm tra bao bì thực tế để có thông tin dị ứng & dinh dưỡng mới nhất.',
      'pdp.spec_brand':       'Thương hiệu',
      'pdp.spec_type':        'Danh mục',
      'pdp.spec_cuisine':     'Ẩm thực',
      'pdp.type_seasoning':   'Gia vị',
      'pdp.type_canned':      'Đồ hộp',
      'section.view_all':     'Xem tất cả',
      'foryou.title':         '✨ Dành cho bạn',
      'recentlyviewed.title': '👀 Vừa xem gần đây',
      'recommend.title':      'Bạn cũng có thể thích',
      'dept.vietnam':         'Chợ Việt',
      'dept.snacks':          'Đồ ăn vặt',
      'dept.noodles':         'Mì & Bánh tráng',
      'dept.instant':         'Đồ ăn liền',
      'dept.beverages':       'Đồ uống',
      'dept.seasoning':       'Gia vị & Nước chấm',
      'dept.candy':           'Kẹo',
      'dept.coffee':          'Cà phê',
      'dept.tea':             'Trà',
      'dept.rice':            'Gạo',
      'dept.household':       'Đồ gia dụng',
      'dept.swan':            'Swan Brand',
      'drawer.title':         'Giỏ hàng',
      'drawer.item':          'món',
      'drawer.items':         'món',
      'drawer.deliver_to':    'Giao tới',
      'drawer.deliver_prompt':'Nhập ZIP để xem ngày giao',
      'drawer.empty':         'Giỏ hàng đang trống',
      'drawer.continue':      'Tiếp tục mua sắm',
      /* Chữ lấy đúng locales/vi.json:262-263 — bản dịch đã nằm sẵn ở đó từ lâu,
         chỉ chưa bao giờ tới được khách vì storefront không chạy locale vi. */
      'cart.login_title':     'Bạn đã có tài khoản?',
      'cart.login_link':      'Đăng nhập',
      'cart.login_rest':      ' để thanh toán nhanh hơn.',
      /* review.* — xem chú thích ở bản EN. "review" tiếng Việt để là "đánh giá".
         count_one/count tách đôi vì tiếng Anh đổi dạng số nhiều còn tiếng Việt
         thì không — giữ hai khoá cho bên EN dùng, bên VI viết giống nhau là đúng. */
      'review.heading':       'Khách hàng đánh giá',
      'review.count_one':     '1 đánh giá',
      'review.count':         '{n} đánh giá',
      'review.source_note':   'Đánh giá do khách viết trên',
      'review.source_prefix': 'Đánh giá từ',
      'review.show_more':     'Xem thêm {n}',
      'review.show_less':     'Thu gọn',
      'review.src_customer':  'Đánh giá của khách',
      'review.stars_5':       '5 trên 5 sao',
      'testi.eyebrow':        '★ Được tin dùng khắp nước Mỹ ★',
      'testi.heading':        'Được hàng nghìn tín đồ ẩm thực Á yêu thích',
      'testi.stat_orders':    'Đơn hàng',
      'testi.stat_social':    'Người theo dõi',
      'testi.follow':         'Theo dõi tiệm',
      'drawer.only_left_pre': 'Chỉ còn',
      'drawer.only_left_post':'trong kho',
      'drawer.subtotal':      'Tạm tính',
      'drawer.savings':       'Tiết kiệm',
      'drawer.total':         'Tổng',
      'drawer.tax_note':      'Đã gồm thuế · phí giao tính khi thanh toán',
      'drawer.checkout':      'Thanh toán',
      'drawer.below_min':     'Có món chưa đủ số lượng mua tối thiểu. Thêm cho đủ hoặc bỏ món đó để thanh toán.',
      'drawer.view_full':     'Xem giỏ hàng đầy đủ',
      'drawer.trust':         '🛡️ Tươi ngon đảm bảo · 100% hàng chuẩn · giao khắp nước Mỹ',
      'drawer.zip_unset':     'khu vực của bạn',
      'drawer.cross_sell':    'Khách thường mua chung',
      'drawer.cs_related':    'Có thể bạn cần',
      'drawer.chips_title':   'Thêm 1 món này là được miễn phí giao',
      'drawer.add':           'Thêm',
      'drawer.save_later':    'Lưu để mua sau',
      'qua.moi':              'Mua thêm {x} để được TẶNG {ten}',
      'qua.du':               'Đơn này đủ điều kiện nhận {ten} MIỄN PHÍ (nội địa Mỹ)',
      'qua.co':               'Quà tặng {ten} đã có trong giỏ của bạn',
      'qua.nhan':             'Quà tặng',
      'qua.mien_phi':         'MIỄN PHÍ',
      'qua.trang_mo_ta':      'Món này là quà tặng kèm đơn đủ điều kiện, không bán riêng.',
      'drawer.saved':         'Đã lưu để mua sau',
      'drawer.reorder':       'Mua lại nhanh',
      'drawer.reorder_sub_orders': 'từ đơn gần nhất của bạn',
      'drawer.reorder_sub_local':  'món bạn từng cho vào giỏ',
      'drawer.gift':          'Thêm lời nhắn quà tặng',
      'drawer.gift_wrap':     'Đây là quà tặng — không in giá trên phiếu',
      'drawer.gift_ph':       'Lời nhắn (tuỳ chọn)',
      'drawer.aria':          'Giỏ hàng',
      'drawer.close_aria':    'Đóng giỏ hàng',
      'drawer.remove_aria':   'Bỏ món này khỏi giỏ',
      'drawer.gift_aria':     'Lời nhắn quà tặng',
      'drawer.gift_save':     'Lưu',
      'drawer.gift_saved':    'Đã lưu ✓',
      'drawer.gift_err':      'Chưa lưu được — vui lòng thử lại',
      'drawer.auto_coupon':   'Đã tự áp mã',
      'drawer.toast_added':   'Đã thêm',
      'drawer.toast_items':   '{n} món',
      'drawer.toast_view':    'Xem giỏ',
      'drawer.toast_err_limit':   'Không thêm được — món này đã tới giới hạn hoặc hết hàng',
      'drawer.toast_err_generic': 'Không thêm được vào giỏ — vui lòng thử lại',
      'drawer.toast_err_remove':  'Chưa bỏ được món này — nó vẫn còn trong giỏ, thử lại giúp mình nhé',
      'drawer.toast_err_update':  'Chưa đổi được số lượng — vui lòng thử lại',
      'drawer.points_pre':    'Đơn này được',
      'drawer.points_post':   'điểm thưởng',
      'drawer.or':            'hoặc',
      'drawer.secure_pay':    'Thanh toán an toàn',
      'drawer.combo_pre':     'Mua',
      'drawer.combo_for':     'chỉ',
      'drawer.combo_more':    '(thêm {n})',
      'drawer.combo_ok':      '✓ đủ combo',
      'fsb.calculating':      'Đang tính phí giao…',
      'fsb.remote':           'Phí giao tính khi thanh toán (USPS)',
      'fsb.add_progress':     'Mua thêm {amount} để được {label}',
      'fsb.unlocked':         '🎉 Bạn đã được {label}!',
      'fsb.rate_to':          'Giao tới {zip}: {price}',
      'fsb.rate_days':        '· khoảng {n} ngày làm việc',
      'fsb.rate_free_at':     '· miễn phí từ {amount}',
      'fsb.label_free':       'MIỄN PHÍ giao hàng',
      'fsb.label_local':      'MIỄN PHÍ giao nội vùng',
      'fsb.label_usps':       'phí USPS khi thanh toán',
      'fsb.sub_sameday':      'Giao trong ngày',
      'cart.breadcrumb':      'Giỏ hàng của bạn',
      'cart.title':           'Giỏ hàng của bạn',
      'cart.head_product':    'Sản phẩm',
      'cart.head_quantity':   'Số lượng',
      'cart.head_total':      'Thành tiền',
      'cart.note':            'Ghi chú cho đơn hàng',
      'cart.subtotal':        'Tạm tính:',
      'cart.tax_note_html':   'Đã gồm thuế. <a href="/pages/shipping-policy">Phí giao</a> tính khi thanh toán.',
      'cart.checkout':        'Thanh toán',
      'cart.max_reached':     'Đã tối đa ({n})',
      'cart.discount_aria':   'Giảm giá',
      'cart.sr_qty_for':      'Số lượng của',
      'cart.sr_qty_down':     'Giảm số lượng',
      'cart.sr_qty_up':       'Tăng số lượng',
      'cart.sr_remove':       'Xoá',
      'cart.sr_unit_per':     'mỗi',
      'cart.sr_loading':      'Đang tải...',
      'footer.also_shop':     'Mua hàng của tiệm trên',
      'footer.secure_pay':    'Thanh toán an toàn',
      'footer.scroll_top':    'Lên đầu trang',
      'reorder.title':        'Mua lại đơn trước',
      'reorder.title_local':  'Mua lại món quen',
      'reorder.subtitle':     'Thêm nhanh từ đơn gần nhất của bạn',
      'reorder.add':          'Thêm lại',
      'reorder.add_all':      'Thêm lại cả đơn',
      'reorder.guest':        'Đăng nhập để mua lại nhanh',
      'fbt.heading':          'Sản phẩm hay mua kèm',
      'fbt.this_item':        'Sản phẩm này:',
      'fbt.total':            'Tổng cộng:',
      'fbt.add_all_prefix':   'Thêm cả',
      'fbt.add_all_suffix':   'vào giỏ',
      'fbt.added':            'Đã thêm ✓',
      'faq.heading':          'Câu hỏi thường gặp',
      'related.heading':      'Danh mục liên quan',
      // "Mua Nongshim ở đâu?" — trật tự từ tiếng Việt vừa đúng khuôn ba mảnh của
      // tiếng Anh ("Where to buy" · Nongshim · "near me?"), nên không phải chế
      // thêm khoá riêng cho VI.
      'brand.h1_prefix':      'Mua',
      'brand.h1_suffix':      'ở đâu?',
      'brand.top_heading':    'Món đáng mua của',
      'brand.price_from':     'từ',
      'brand.shop_now':       'Mua ngay',
      'brand.sold_out':       'Hết hàng',
      'recipes.heading':      'Món nấu từ nguyên liệu này',
      /* Xem chú thích ở bảng EN — {n} do data-i18n-n điền, giữ nguyên chỗ đó. */
      'recipes.strip_sub':    '{n} công thức món Á — xem cách nấu và mua đủ nguyên liệu trong 1 click',
      'recipes.card_cta':     'Xem công thức →',
      'recipes.view_all':     'Xem tất cả công thức →',
      // Phase 5 — quiz chọn combo. Chữ dưới đây là NGUYÊN VĂN Boss viết trong
      // Artifacts/aef-quiz-preview.html, không diễn đạt lại.
      'quiz.heading':         'Combo nào hợp bạn?',
      'quiz.sub':             '4 câu hỏi nhanh — gợi ý combo chuẩn vị cho bữa nay',
      'quiz.intro':           'Trả lời 4 câu, mình gợi ý ngay combo hợp gu bạn nhất — kèm giá và link mua.',
      'quiz.start':           'Bắt đầu 🎯',
      'quiz.step':            'Câu {n}/4',
      'quiz.back':            '← Quay lại',
      'quiz.result_tag':      'Combo hợp bạn nhất',
      'quiz.save':            'Tiết kiệm',
      'quiz.add':             'Thêm vào giỏ',
      'quiz.adding':          'Đang thêm…',
      'quiz.added':           'Đã thêm ✓',
      'quiz.view':            'Xem combo',
      'quiz.again':           'Làm lại quiz ↺',
      'quiz.oos_title':       'Combo hợp gu bạn đang tạm hết hàng',
      'quiz.oos_sub':         'Mình không gợi ý món không mua được. Đây là combo còn hàng hôm nay.',
      'quiz.instock':         'Còn hàng hôm nay',
      'quiz.browse':          'Xem tất cả combo',
      'quiz.q1':              'Hôm nay bạn thèm kiểu gì?',
      'quiz.q1a1':            'Tô nước nóng hổi (phở/bún)',
      'quiz.q1a2':            'Mì sợi đậm đà',
      'quiz.q1a3':            'Cơm nóng, nấu món',
      'quiz.q1a4':            'Cà phê & đồ uống',
      'quiz.q1a5':            'Ăn vặt nhâm nhi',
      'quiz.q2':              'Khẩu vị cay của bạn?',
      'quiz.q2a1':            'Càng cay càng đã',
      'quiz.q2a2':            'Vừa phải / nhẹ nhàng',
      'quiz.q3':              'Bạn thích nấu kiểu nào?',
      'quiz.q3a1':            'Tự nấu bài bản',
      'quiz.q3a2':            'Nhanh gọn, ăn liền',
      'quiz.q4':              'Bữa này ăn cùng ai?',
      'quiz.q4a1':            'Một mình / 1–2 người',
      'quiz.q4a2':            'Cả nhóm / gia đình'
    }
  };

  /* ten.* — tên DỮ LIỆU (tiêu đề danh mục/trang/blog do Boss đặt trong Shopify)
     mà KHÔNG khoá menu nào viết đúng từng chữ, dù menu có trỏ tới đúng chỗ đó.
     Chỉ applyTenDuLieuI18n đọc nhóm này (không gắn data-i18n).
       [0] = chữ EN — đúng tên dữ liệu (để tra ngược),
       [1] = khoá menu trỏ tới CÙNG chỗ — bản VI MƯỢN nguyên chữ của khoá ấy.
     26/9/2026 (vòng 53, nợ ④a): bản trước chép tay bản VI vào I18N.vi ('ten.instant':
     'Đồ ăn liền'…) — nguồn thứ hai của cùng một chữ: Boss đổi chữ menu là crumb/H1
     đứng chữ cũ, không ai báo. Nay chữ VI chỉ sống ở khoá menu.
       · "Contact"   = page.title của /pages/contact; chân trang gọi trang ấy là
                       footer.link_contact ("Contact us").
       · "Instant"   = collection /collections/instant; menu = dept.instant.
       · "Seasoning" = collection /collections/seasoning; menu = dept.seasoning.
         (hai danh mục đông PDP nhất: crumb PDP chỉ về danh mục thật — pdp#1 —
          nên thiếu hai dòng này thì 491 PDP của khách VI đứng chữ Anh ở crumb.)
       · "Shop All Asian Groceries" = tên trang kho tổng /collections/all (danh mục
                       ẢO — tên do snippets/aef-ten-kho-tong.liquid đặt, không có trong
                       Admin); link dẫn tới đó là search.all_products ("All products").
                       Crumb và H1 của trang cùng đọc dòng này (28/9, seo-kt).
       · "Top Best Sellers" = /collections/top-50-best-sellers; menu = nav.bestsellers
                       ("Bestsellers" — khác tên dữ liệu chữ "Top …").
       · "🍜 Vietnam Food Market | A Taste of Tradition" = /collections/vietnam-food-market;
                       menu = dept.vietnam. Tên dữ liệu là câu tiếp thị dài, khách VI
                       đọc tên ngắn của menu. Hai dòng này Boss chốt 24/10/2026 ("Bán
                       chạy" / "Chợ Việt" — mượn chữ menu), trước đó nằm ở MIEN_E.
     Khoá menu thiếu bản VI ⇒ dòng đó không dịch (hỏng an toàn: giữ EN).
     Người gác: scripts/test-ten-du-lieu-crumb-h1-doi-tieng.js (mệnh đề E · F);
     dòng ten.kho_tong: scripts/test-h1-kho-tong-co-nghia.js (K3). */
  var TEN_DU_LIEU_MUON = {
    'ten.contact':   ['Contact',   'footer.link_contact'],
    'ten.instant':   ['Instant',   'dept.instant'],
    'ten.seasoning': ['Seasoning', 'dept.seasoning'],
    'ten.kho_tong':  ['Shop All Asian Groceries', 'search.all_products'],
    'ten.bestsellers':    ['Top Best Sellers', 'nav.bestsellers'],
    'ten.vietnam_market': ['🍜 Vietnam Food Market | A Taste of Tradition', 'dept.vietnam']
  };
  Object.keys(TEN_DU_LIEU_MUON).forEach(function (k) {
    var muon = I18N.vi[TEN_DU_LIEU_MUON[k][1]];
    I18N.en[k] = TEN_DU_LIEU_MUON[k][0];
    if (typeof muon === 'string' && muon) I18N.vi[k] = muon;
  });

  // Tier copy is NOT in the user-facing dict above (it's runtime-computed),
  // so keep it here. Both langs maintained side-by-side.
  var TIER_COPY = {
    en: {
      tier1_same: '🚚 Same-day delivery',
      tier1_next: '🚚 Tomorrow',
      tier2:      '✓ Next-day delivery',
      tier3:      '📦 2-day delivery',
      tier4:      '📦 3-5 day delivery',
      tier5:      '📦 5-7 day delivery',
      /* vòng 48, 14/9/2026 (fsb-zip-2) — câu dành cho ZIP quân đội APO/FPO/DPO.
         Cố ý KHÔNG có con số ngày và KHÔNG có dãy ngày: xem chú thích dài ở
         APO_PREFIX_RE (~dòng 1533). Ngắn hơn câu tier4 kèm ngày đang hiện
         (28 ký tự so với 41) nên không làm rộng thêm viên trên header.
         Từ 15/9 dùng cho lãnh thổ (resolveZip, tier ''), từ 9/10 cho tier3/4/5 khi
         giỏ có món mà số ngày của Shopify không dùng được (gói khongSo, buildPromise). */
      overseas:   '📦 Delivery date at checkout',
      /* 28/9/2026 — ZIP của vùng KHÔNG GIAO (zone-detection.js `giao: false`). Đọc
         từ I18N, không chép: một câu cho viên, thanh free-ship và trang same-day. */
      khong_giao: I18N.en['zone.khong_giao'],
      err_short:  'Enter 5-digit ZIP',
      err_nonus:  'US ZIP codes only',
      err_unknown:'ZIP not found',
      err_load:   'Cannot load data — try again',
      success:    'Saved'
    },
    vi: {
      tier1_same: '🚚 Giao trong ngày',
      tier1_next: '🚚 Giao ngày mai',
      tier2:      '✓ Giao ngày mai',
      tier3:      '📦 Giao 2 ngày',
      tier4:      '📦 Giao 3-5 ngày',
      tier5:      '📦 Giao 5-7 ngày',
      overseas:   '📦 Ngày giao tính ở bước thanh toán',
      khong_giao: I18N.vi['zone.khong_giao'],
      err_short:  'Nhập ZIP 5 số',
      err_nonus:  'Chỉ ship trong US',
      err_unknown:'ZIP không tìm thấy',
      err_load:   'Không tải được dữ liệu',
      success:    'Đã lưu'
    }
  };

  function getCurrentLang() {
    try { var v = window.localStorage.getItem(STORAGE_LANG); return v === 'vi' ? 'vi' : 'en'; }
    catch (e) { return DEFAULT_LANG; }
  }
  function setLang(lang) {
    if (lang !== 'en' && lang !== 'vi') return;
    try { window.localStorage.setItem(STORAGE_LANG, lang); } catch (e) {}
    applyTranslations();
    document.documentElement.setAttribute('lang', lang);
    document.dispatchEvent(new CustomEvent('aef:lang-changed', { detail: { lang: lang } }));
  }
  // Known postal = explicit hand-typed ZIP (priority) → live window.AE_ZONE →
  // cached ae_zone_v1. Lets the header pill + cart-drawer deliv line survive
  // re-renders once located (ticket_QA_batch #1). Returns a 5-digit string or null.
  function cachedPostal() {
    try { var z = window.localStorage.getItem('ae_zip_code'); if (z && /^\d{5}$/.test(z)) return z; } catch (e) {}
    try { if (window.AE_ZONE && /^\d{5}$/.test(String(window.AE_ZONE.postal || ''))) return String(window.AE_ZONE.postal); } catch (e) {}
    try { var c = JSON.parse(window.localStorage.getItem('ae_zone_v1') || 'null'); if (c && /^\d{5}$/.test(String(c.postal || ''))) return String(c.postal); } catch (e) {}
    return null;
  }

  /* ------------------------------------------------------- ngưỡng theo vùng ---
   * Ngưỡng free-ship KHÔNG phải một con số: $59 (DFW/TX-OK) · $69 (standard) ·
   * $79 (far: CA/NY/WA) · remote (AK/HI/PR) không có ngưỡng, USPS tính theo cân.
   * Mọi câu quảng cáo có số tiền vì thế phải nói theo vùng NGƯỜI ĐANG XEM. Số
   * thật: CA 148 đơn · NY 80 · TX chỉ 79 — dán cứng "$59" là hứa sai với đa số.
   *
   * Chuỗi trong dict mang token {zone_amount}; hàm này thay token NGAY TRONG writer
   * sẵn có (applyTranslations / applyAnnouncementI18n) thay vì ghi thêm từ một
   * listener khác lên cùng node — đúng Pattern 1 anti-regression: một node, một
   * người ghi. Vùng remote không có ngưỡng nên đổi hẳn sang khoá `<key>_remote`
   * (cùng lối `md.freeship_usps` mà aef-marketdeals.js đang dùng) — không bịa số.
   * -------------------------------------------------------------------------- */
  function zoneAmount() {
    var z = window.AE_ZONE;
    if (!z || z.threshold == null) return null;
    return '$' + Math.round(z.threshold / 100);
  }
  /* 28/9/2026 (vòng 53, đợt 4) — vùng KHÔNG GIAO: cờ `giao: false` của zone-detection.js. */
  function laVungKhongGiao() {
    var z = window.AE_ZONE;
    return !!(z && z.giao === false);
  }
  function isRemoteZone() {
    var z = window.AE_ZONE;
    /* 28/9/2026 — vùng KHÔNG GIAO (`giao === false`) cũng không có ngưỡng: đi chung
       đường `_remote` / zone.no_threshold (trước đó các mã ấy nằm ở 'remote') — tuyệt
       đối không để fillAmount điền ngưỡng mặc định $79 cho họ. */
    return !!(z && (z.zone === 'remote' || z.giao === false));
  }
  /* 🎁 assets/aef-qua-tang.js hỏi đúng hàm này: vùng không có ngưỡng thì cũng không có quà. */
  window.aefLaVungXa = isRemoteZone;
  /* Chưa biết vùng (khách vừa vào, resolve chưa xong) → ĐỌC hằng số của
   * zone-detection.js, đừng tự dán số.
   *
   * 🔴 18/8 — sửa lại lý lẽ cũ, vì nó ngược. Chú thích trước đây chọn $59
   * (ngưỡng THẤP nhất) với lập luận "hụt xuống rồi sửa lên thì khách chỉ thấy
   * số to hơn thật trong tích tắc". Đọc kỹ thì đúng chiều ngược lại: bắt đầu ở
   * $59 rồi nhảy lên $79 là khách thấy số RẺ hơn thật trước, rồi bị rút lại.
   * Bắt đầu ở $79 rồi hạ xuống $59 mới là chiều an toàn — không bao giờ hứa rẻ
   * hơn thực tế, và người được hạ giá thì vui.
   *
   * Và đây không phải chuyện tích tắc: khách CHƯA nhập ZIP thì resolve() phải
   * đi qua /cart.js → cache → Shopify.country → ipapi.co (mạng, có thể vài
   * trăm ms tới vài giây, có thể hỏng hẳn rồi rơi về fallback). Suốt quãng đó
   * con số đệm là thứ duy nhất khách đọc được.
   *
   * Cùng lúc, zone-detection.js đã chốt FALLBACK_ZONE = us_far = $79 cho đúng
   * tình huống "không có tín hiệu gì". Hai file trả lời KHÁC NHAU cho cùng một
   * câu hỏi là lỗi, bất kể chọn số nào. Giờ chỉ còn một nơi giữ số. */
  function nguongMacDinh() {
    var f = window.AE_ZONE_FALLBACK;
    if (f && typeof f.threshold === 'number') return '$' + Math.round(f.threshold / 100);
    return '$79'; // zone-detection.js chưa nạp — vẫn phải là ngưỡng CAO nhất
  }
  function fillAmount(text) {
    if (typeof text !== 'string' || text.indexOf('{zone_amount}') < 0) return text;
    return text.replace(/\{zone_amount\}/g, zoneAmount() || nguongMacDinh());
  }
  /* Tên token là {zone_amount}, KHÔNG phải {amount}.
   * Từ điển này đã có sẵn 'fsb.add_progress' = "Add {amount} to cart for {label}",
   * ở đó {amount} nghĩa là SỐ TIỀN CÒN THIẾU để đạt free-ship — hoàn toàn khác
   * nghĩa "ngưỡng của vùng". Hiện tại hai đường tiêu thụ tách nhau (thanh free-ship
   * đọc dict bằng hàm t() riêng, không qua [data-i18n]) nên chưa va nhau, nhưng để
   * cùng một tên là chờ ngày ai đó gắn data-i18n="fsb.add_progress" lên một thẻ và
   * biến "Add $21.53" thành "Add $59". Đặt tên khác là hết đường va.
   */
  function dictText(dict, key) {
    if (!isRemoteZone()) return dict[key];
    /* 28/9/2026 — vùng KHÔNG GIAO (USVI · Guam · Bắc Marianas · Samoa · APO/FPO/DPO): mọi câu
       hứa ngưỡng ({zone_amount}) lẫn bản `_remote` của nó ("Shipping calculated at checkout")
       đều hứa một chuyến giao không tồn tại ⇒ nói câu 'zone.khong_giao'. Câu không dính tới
       tiền ship thì giữ nguyên. Người gác: scripts/test-vung-khong-giao-mot-nguon.js CA 6. */
    if (laVungKhongGiao()) {
      var g = dict[key];
      if ((typeof g === 'string' && g.indexOf('{zone_amount}') >= 0) || dict[key + '_remote'] != null) {
        return dict['zone.khong_giao'] != null ? dict['zone.khong_giao'] : g;
      }
      return g;
    }
    if (dict[key + '_remote'] != null) return dict[key + '_remote'];
    // AK/HI/PR KHÔNG có ngưỡng free-ship. Nếu câu vẫn còn token mà không có bản
    // _remote thì fillAmount sẽ điền ngưỡng mặc định ($79) — hứa một mức miễn phí
    // ship không hề tồn tại ở đó. Thà nói câu chung chung còn hơn bịa số.
    var v = dict[key];
    if (typeof v === 'string' && v.indexOf('{zone_amount}') >= 0) {
      return dict['zone.no_threshold'] != null ? dict['zone.no_threshold'] : v;
    }
    return v;
  }

  /* ── Lối vào TÀI KHOẢN phải mang ngôn ngữ khách đang chọn ───────────────
   * vòng 53 (25/9/2026) — mã i18n#1, trùng delivery-account-checkout#5.
   *
   * Mọi nút đăng nhập của theme lấy href từ `routes.account_login_url`
   * (sections/header.liquid:44 🖥+📱 · main-cart-items.liquid:86 giỏ rỗng ·
   * aef-reorder.liquid:183). Liquid dựng nó LÚC RENDER theo request.locale,
   * mà storefront chỉ chạy `en` (/vi = 404) ⇒ href ĐÓNG BĂNG `?locale=en`,
   * cùng họ với `| t`. Nút VI chỉ viết lại chữ, không đụng href ⇒ khách VI
   * bấm "Đăng nhập / Đăng ký" rơi vào trang đăng nhập Shopify tiếng Anh.
   * Tệ hơn: `locale=en` tường minh còn ĐÈ cả trình duyệt tiếng Việt.
   *
   * Đo 25/9 trên LIVE (ba lượt độc lập, tách hũ cookie): trang đăng nhập
   * Customer Accounts NHẬN `locale=vi` → <html lang="vi-US">, gói chữ vi.*.js
   * ("Đăng nhập", "Tiếp tục"); đối chứng `locale=fr` / `zz` → rơi về en-US.
   * Link "Tài khoản" ở chân trang (mục menu `https://shopify.com/<id>/account`)
   * thêm `?locale=vi` cũng ra vi-US. Trang đăng nhập trỏ về gốc cửa hàng,
   * không có tiền tố /vi.
   *
   * Cách làm — chỉ đổi đúng tham số `locale`, trên đúng ba dạng link:
   *   · Khách EN chưa từng bật VI: KHÔNG đụng href — giữ nguyên bản server.
   *   · Bật VI: nhớ href gốc vào data-aef-href-en, rồi đặt locale=vi (giữ
   *     region_country và mọi tham số khác).
   *   · Đổi lại EN: trả ĐÚNG href gốc. Không tự gắn locale=en lên link chân
   *     trang vốn không có — gắn vào là đè Accept-Language của máy tiếng Việt.
   * Chạy ở mọi chỗ applyTranslations chạy (boot · setLang · aef:cards-injected
   * · syncFromZone · aef-reorder reveal) ⇒ đổi ngôn ngữ giữa chừng thì href
   * lật theo. Một người ghi href cho các link này: chính hàm dưới.
   *
   * ⛔ KHÔNG gắn locale vào `/account` của storefront (href của khách ĐÃ đăng
   *    nhập, routes.account_url): đo rồi, storefront BỎ tham số đó và vẫn 302
   *    sang locale=en. Nhánh ấy còn nợ — cần một tài khoản thật để đo.
   * ⛔ Đừng chép cứng shop id — nhận link bằng host + đường dẫn.
   * Người gác: scripts/test-dang-nhap-theo-ngon-ngu.js
   */
  function laLinkTaiKhoan(u) {
    if (u.pathname.indexOf('/customer_authentication/') === 0) return true;
    var host = String(location.hostname || '').replace(/^www\./, '');
    if (host && u.hostname === 'account.' + host) return true;
    return u.hostname === 'shopify.com' && /^\/\d+\/account(?:\/|$)/.test(u.pathname);
  }
  function hrefTiengViet(goc) {
    var u = new URL(goc, location.href);
    if (!laLinkTaiKhoan(u)) return null;
    u.searchParams.set('locale', 'vi');
    return u.href;
  }
  function applyAccountLinkLang(lang) {
    document.querySelectorAll('a[href*="/customer_authentication/"], a[href*="account."], a[href*="shopify.com/"]').forEach(function (a) {
      try {
        var cur = a.getAttribute('href');
        var goc = a.getAttribute('data-aef-href-en');
        // Ai đó đã viết lại href sau lượt trước ⇒ bản gốc đã cũ, lấy href hiện tại.
        if (goc != null && cur !== hrefTiengViet(goc)) goc = null;
        if (lang !== 'vi') {
          if (goc != null) a.setAttribute('href', goc);
          a.removeAttribute('data-aef-href-en');
          return;
        }
        var goc2 = goc != null ? goc : cur;
        var vi = hrefTiengViet(goc2);
        if (vi == null) return;
        a.setAttribute('data-aef-href-en', goc2);
        if (cur !== vi) a.setAttribute('href', vi);
      } catch (e) {}
    });
  }

  function applyTranslations() {
    var lang = getCurrentLang();
    var dict = I18N[lang] || I18N.en;
    var hasZip = !!cachedPostal();
    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      var key = el.getAttribute('data-i18n');
      // Don't let the generic translator clobber the located ZIP value nodes — once a
      // postal is known the widget owns their text. ticket_QA_batch #1: aef:cards-injected
      // (lazy homepage rows) + lang-change re-ran this and wiped the pill back to
      // "Enter ZIP" ~minutes after locating. No ZIP yet → dict placeholder is correct.
      if (hasZip && (el.hasAttribute('data-aef-dw-edit') || el.hasAttribute('data-aef-dw-promise'))) return;
      var val = dictText(dict, key);
      /* data-i18n-n: chèn MỘT con số vào chỗ {n} của câu trong từ điển.
         Có nó thì mới dịch được những câu mà TRẬT TỰ TỪ khác nhau giữa hai thứ
         tiếng: "15% OFF" ↔ "GIẢM 15%". Trước đây nhãn giảm giá trên thẻ đành để
         nguyên tiếng Anh vì con số nằm giữa câu. */
      if (val != null) {
        var n = el.getAttribute('data-i18n-n');
        if (n != null) val = val.replace(/\{n\}/g, n);
        el.textContent = fillAmount(val);
      }
    });
    // Cả ba biến thể dưới đây cũng đi qua dictText + fillAmount như [data-i18n].
    // Hiện chưa khoá nào của chúng mang {zone_amount}, nhưng để lệch nhau thì ngày
    // ai đó viết một placeholder hay aria-label có ngưỡng vùng, nó sẽ in thẳng chữ
    // "{zone_amount}" ra cho khách đọc — hỏng lặng lẽ và rất khó lần ra.
    document.querySelectorAll('[data-i18n-placeholder]').forEach(function (el) {
      var v = dictText(dict, el.getAttribute('data-i18n-placeholder'));
      if (v != null) el.placeholder = fillAmount(v);
    });
    document.querySelectorAll('[data-i18n-aria-label]').forEach(function (el) {
      var v = dictText(dict, el.getAttribute('data-i18n-aria-label'));
      if (v == null) return;
      /* data-i18n-n — thêm 25/9/2026 (vòng 53, i18n#7) cho "Page {n}" của phân
         trang và "Load image {n}" của ảnh thu nhỏ PDP. Thiếu nhánh này thì khách
         VI nghe thẳng chữ "{n}". Truyền HÀM cho replace: số lấy từ thuộc tính,
         không để một dấu $ nào trong đó thành mẫu thay thế. */
      var n = el.getAttribute('data-i18n-n');
      if (n != null) v = v.replace(/\{n\}/g, function () { return n; });
      el.setAttribute('aria-label', fillAmount(v));
    });
    /* data-i18n-title — thêm 20/8/2026, vòng 24.
       Chỗ đầu tiên cần nó: nút "+" bị khoá ở trang /cart mang
       `title="Max reached (N)"` gõ cứng tiếng Anh. Đó là dòng giải thích VÌ SAO
       nút không bấm được — khách đọc không hiểu thì tưởng trang hỏng.
       Có đọc `data-i18n-n` như [data-i18n]: câu này mang một con số, mà nếu quên
       thay thì khách đọc thẳng chữ "{n}" — đúng kiểu hỏng lặng lẽ mà ghi chú
       ngay trên đã cảnh báo cho {zone_amount}. */
    document.querySelectorAll('[data-i18n-title]').forEach(function (el) {
      var v = dictText(dict, el.getAttribute('data-i18n-title'));
      if (v == null) return;
      var n = el.getAttribute('data-i18n-n');
      if (n != null) v = v.replace(/{n}/g, n);
      el.setAttribute('title', fillAmount(v));
    });
    // data-i18n-html: like data-i18n but sets innerHTML, for dict values that
    // carry markup (e.g. the /cart tax note with its inline shipping-policy
    // link). Values are author-controlled in the dict above — never user input.
    document.querySelectorAll('[data-i18n-html]').forEach(function (el) {
      var v = dictText(dict, el.getAttribute('data-i18n-html'));
      if (v != null) el.innerHTML = fillAmount(v);
    });
    document.querySelectorAll('[data-aef-lang-current]').forEach(function (el) {
      el.textContent = lang === 'vi' ? 'VI' : 'EN';
    });
    applyAccountLinkLang(lang);
    applyAnnouncementI18n(lang);
    applyOptionNameI18n(lang);
    applySubAppI18n(lang);
    applyHeroI18n(lang);
    applyRowTitleI18n(lang);
    applyTenDuLieuI18n(lang);
  }

  /* Tên DỮ LIỆU ở vệt breadcrumb + H1 (vòng 53, i18n#5, 25/9/2026).
     collection.title · page.title · blog.title là chữ Boss đặt trong Shopify,
     Liquid in thẳng ra, không có khoá cố định. Mà CHÍNH những cái tên ấy menu,
     tab món ăn, chân trang đã dịch bằng khoá (cuisine.* · dept.* · nav.* ·
     footer.link_*) ⇒ trên điện thoại khách VI thấy tab "Việt Nam" đang sáng
     ngay trên H1 "Vietnamese"; crumb bài công thức ghi "Recipes" dưới chân
     trang ghi "Công thức nấu ăn".
     Cách làm: tra NGƯỢC trong chính I18N.en — tên nào trùng giá trị EN của một
     khoá thuộc các nhóm dưới thì hiện bản VI của khoá ấy. Không chép giá trị
     ra bảng thứ hai: đổi chữ menu là crumb/H1 đổi theo.
     ⛔ ĐỪNG gắn data-i18n theo handle: applyTranslations ghi dict[key] ở CẢ
        chiều EN ⇒ danh mục "On Sale" thành "🔥 Deals", "Instant" thành
        "Instant Meals", và Boss đổi tên danh mục thì khách EN vẫn đọc tên cũ.
     Chiều EN LUÔN trả đúng chữ gốc. Tên lạ / tên Boss mới đổi / tên khớp nhiều
     khoá mà bản VI khác nhau ⇒ giữ nguyên EN (hỏng an toàn).
     So khớp bỏ qua hoa-thường và khoảng trắng thừa: dữ liệu thật có
     "HouseHold", "On Sale" (menu viết "Household", "On sale").
     Móc: thuộc tính data-aef-ten-du-lieu trên thẻ CHỈ chứa chữ tên (không con). */
  var TEN_DU_LIEU_NHOM = ['cuisine.', 'dept.', 'nav.', 'footer.link_', 'ten.'];
  var tenDuLieuBang = null;
  function chuanTenDuLieu(s) { return String(s).replace(/\s+/g, ' ').trim().toLowerCase(); }
  function tenDuLieuVi(goc) {
    var co = Object.prototype.hasOwnProperty;
    if (!tenDuLieuBang) {
      tenDuLieuBang = Object.create(null);
      Object.keys(I18N.en).forEach(function (k) {
        var hop = false;
        for (var i = 0; i < TEN_DU_LIEU_NHOM.length; i++) if (k.indexOf(TEN_DU_LIEU_NHOM[i]) === 0) hop = true;
        if (!hop) return;
        var en = I18N.en[k], vi = I18N.vi[k];
        if (typeof en !== 'string' || typeof vi !== 'string' || !vi) return;
        var t = chuanTenDuLieu(en);
        if (!t) return;
        if (!co.call(tenDuLieuBang, t)) tenDuLieuBang[t] = vi;
        else if (tenDuLieuBang[t] !== vi) tenDuLieuBang[t] = null; // hai khoá cãi nhau ⇒ không dịch
      });
    }
    var t2 = chuanTenDuLieu(goc);
    return co.call(tenDuLieuBang, t2) ? tenDuLieuBang[t2] : null;
  }
  function applyTenDuLieuI18n(lang) {
    var vi = (lang || getCurrentLang()) === 'vi';
    document.querySelectorAll('[data-aef-ten-du-lieu]').forEach(function (el) {
      if (el.children.length) return; // thẻ có con: ghi textContent là xoá con
      if (el.dataset.aefTenGoc == null) el.dataset.aefTenGoc = el.textContent.trim();
      var goc = el.dataset.aefTenGoc;
      var ra = (vi && tenDuLieuVi(goc)) || goc;
      if (el.textContent !== ra) el.textContent = ra;
    });
  }

  // Tiêu đề mỗi dãy sản phẩm ở trang chủ (sections/best-product.liquid →
  // section.settings.ms_title). Là chữ merchant tự nhập trong theme editor nên
  // không có khoá dict cố định — tra theo đúng chuỗi EN, y hệt marquee và hero.
  // Trước đây bốn cái tiêu đề TO NHẤT trang chủ đứng nguyên tiếng Anh trong khi
  // "Xem tất cả", "Thêm vào giỏ", "Dành cho bạn" quanh nó đã dịch hết.
  // Tiêu đề nào Boss sửa mà chưa có trong bảng thì giữ EN — hỏng an toàn.
  var ROW_TITLE_VI = {
    '⭐ Customer Favorites — Top-Rated by Shoppers': '⭐ Khách yêu thích nhất — đánh giá cao nhất',
    '🦢 Only at A&E — exclusive brands':             '🦢 Chỉ có tại A&E — thương hiệu độc quyền',
    '🆕 New Arrivals — fresh stock every week':      '🆕 Hàng mới về — bổ sung mỗi tuần',
    '🏆 Bestsellers — most loved this week':         '🏆 Bán chạy nhất — khách chuộng tuần này',
    '🔥 Everyday deals':                             '🔥 Ưu đãi mỗi ngày',
    '🔥 Hot Deals':                                  '🔥 Ưu đãi HOT',
    // Tiêu đề dãy deals của trang đích /pages/same-day-dfw (templates/page.lp-sameday.json,
    // section deals · ms_title) — 18/10/2026. Khoá chép TỪNG BYTE từ template (có dấu nháy
    // thẳng nên khoá viết bằng nháy kép).
    "🔥 Hot Deals — shop today's on-sale items": '🔥 Ưu đãi HOT — món đang giảm giá hôm nay',
    // Ô promo bên phải hero (sections/aef-hero-video.liquid, chế độ split).
    // Cùng hoàn cảnh với ms_title: chữ Boss gõ trong theme editor, không có
    // khoá dict cố định, nên dùng chung bảng tra này thay vì mở đường thứ hai.
    "This week's deals":                             'Ưu đãi tuần này',
    'Only at A&E':                                   'Chỉ có tại A&E',
    'Shop now':                                      'Mua ngay',
    'Shop Swan Brand':                               'Xem Swan Brand',
    // Ba tiêu đề trang Liên hệ (sections/contact-form.liquid: heading ·
    // mobile_title · address_title, giá trị ở templates/page.contact.json).
    // Cùng hoàn cảnh: chữ Boss gõ trong editor. Khoá phải trùng TỪNG BYTE với
    // chữ đang in. Bản VI tránh chữ "gọi" — số này chỉ nhận tin nhắn (Boss 17/8).
    'Send us a message':                             'Gửi tin nhắn cho chúng tôi',
    'Text us':                                       'Nhắn tin cho chúng tôi',
    'Location':                                      'Địa chỉ'
  };
  function applyRowTitleI18n(lang) {
    var vi = (lang || getCurrentLang()) === 'vi';
    document.querySelectorAll('.aef-row-title-i18n').forEach(function (el) {
      if (!el.dataset.aefEnText) el.dataset.aefEnText = el.textContent.trim();
      var en = el.dataset.aefEnText;
      el.textContent = vi && ROW_TITLE_VI[en] ? ROW_TITLE_VI[en] : en;
    });
  }
  // Dãy lazy (assets/lazy-sections.js) bơm HTML vào SAU khi applyTranslations
  // chạy lần đầu, nên phải gọi lại được từ ngoài.
  window.applyRowTitleI18n = applyRowTitleI18n;

  // /cart line-item option labels (ticket_BUG_cart_page_i18n): the <dt> shows
  // the merchant-set option NAME ({{ option.name }}), so it has no stable dict
  // key — map by exact EN text like the marquee. Cache original EN per node so
  // VI→EN restores; unknown option names stay EN (safe fallback).
  var OPT_NAME_VI = {
    'Size': 'Kích cỡ', 'Pack': 'Quy cách', 'Flavor': 'Hương vị',
    'Color': 'Màu', 'Style': 'Kiểu', 'Material': 'Chất liệu',
    'Scent': 'Mùi', 'Weight': 'Trọng lượng', 'Title': 'Phân loại'
  };
  function applyOptionNameI18n(lang) {
    var vi = lang === 'vi';
    document.querySelectorAll('[data-i18n-optname]').forEach(function (el) {
      if (!el.dataset.aefEnText) el.dataset.aefEnText = el.textContent.trim();
      var en = el.dataset.aefEnText;
      el.textContent = vi && OPT_NAME_VI[en] ? OPT_NAME_VI[en] : en;
    });
  }

  /* Khối app Shopify Subscriptions trên PDP (templates/product.json, app block) —
     24/10/2026, vòng 53 đợt 5d, SN1-app-goi-dinh-ky. App vẽ HTML thường (light DOM)
     ngay dưới nút mua: tên nhóm gói + tên gói (DỮ LIỆU selling plan Boss đặt trong
     app, nhóm phủ 214 SP) và vài câu cố định của app. Không có khoá để gắn data-i18n
     ⇒ tra theo ĐÚNG chữ EN, y khuôn ROW_TITLE_VI / OPT_NAME_VI.
     CHỈ đổi chữ hiện + phần tên trong aria-label của ô chọn ("<tên>. Product price
     <giá>"); KHÔNG đụng name / value / data-* của input hay ô ẩn selling_plan
     (app-block.js đọc chúng để gửi gói lên /cart/add — HARD GATE giỏ).
     Boss đổi tên gói ⇒ bảng không khớp ⇒ giữ nguyên EN (hỏng an toàn).
     So khớp bỏ khoảng trắng thừa (tên gói in xuống dòng + thụt lề). Khách EN: không
     ghi gì cả. Chạy trong applyTranslations (boot + mỗi lần đổi tiếng) và sau mọi sự
     kiện change / variant:change (đổi biến thể — app có thể vẽ lại khối).
     🔴 30/10/2026 (/code-review 287d9d08 #1) — app VẼ LẠI chữ/aria-label tại chỗ (đổi biến thể
     $8→$10: aria "<tên>. Product price $10"). Bản đầu nhớ bản EN MỘT lần ⇒ lượt dịch sau ghi đè
     bằng giá cũ, bấm EN cũng về câu cũ. Nay nhớ thêm thứ MÌNH ghi lần cuối (data-aef-sub-ghi /
     data-aef-sub-aria-ghi): chữ hiện tại khác thứ đó ⇒ app vừa vẽ lại ⇒ lấy chữ hiện tại làm gốc.
     Người gác: scripts/test-goi-dinh-ky-song-ngu.js (S8). */
  var SUB_APP_VI = {
    'One-time purchase':                    'Mua một lần',
    'Get 5% off – auto-delivered monthly':  'Giảm 5% – tự giao hằng tháng',
    'Deliver every month, 5% off':          'Giao mỗi tháng, giảm 5%',
    'Auto-renews, skip or cancel anytime.': 'Tự động gia hạn — bỏ qua hoặc huỷ bất cứ lúc nào.',
    'Subscription':                         'Định kỳ',
    'To add to cart, go to the product page and select a purchase option': 'Để thêm vào giỏ, hãy mở trang sản phẩm và chọn cách mua'
  };
  var SUB_APP_GIA = { en: '. Product price ', vi: '. Giá sản phẩm ' };
  var SUB_APP_GOC = '.shopify_subscriptions_app_container, #shopify_subscriptions_app_block_error_message';
  function chuanSub(s) { return String(s).replace(/\s+/g, ' ').trim(); }
  function applySubAppI18n(lang) {
    var vi = (lang || getCurrentLang()) === 'vi';
    var co = Object.prototype.hasOwnProperty;
    document.querySelectorAll(SUB_APP_GOC).forEach(function (goc) {
      var ds = [goc].concat(Array.prototype.slice.call(goc.querySelectorAll('*')));
      ds.forEach(function (el) {
        if (el.children.length || /^(INPUT|SCRIPT|STYLE|LINK)$/.test(el.tagName)) return; // chỉ thẻ CHỈ chứa chữ
        var en = el.getAttribute('data-aef-sub-en');
        var cur = chuanSub(el.textContent);
        if (en != null && cur !== chuanSub(el.getAttribute('data-aef-sub-ghi') || '')) {
          el.removeAttribute('data-aef-sub-en'); en = null;   // app vẽ lại chữ ⇒ chữ hiện tại là gốc
        }
        if (en == null) {
          if (!vi) return;
          en = cur;
          if (!co.call(SUB_APP_VI, en)) return;
          el.setAttribute('data-aef-sub-en', en);
        }
        var ra = vi ? SUB_APP_VI[en] : en;
        if (cur !== ra) el.textContent = ra;
        el.setAttribute('data-aef-sub-ghi', ra);
      });
      goc.querySelectorAll('input[aria-label]').forEach(function (inp) {
        var a = inp.getAttribute('data-aef-sub-aria-en');
        if (a != null && inp.getAttribute('aria-label') !== inp.getAttribute('data-aef-sub-aria-ghi')) {
          inp.removeAttribute('data-aef-sub-aria-en'); a = null;   // app vẽ lại aria (giá mới) ⇒ câu hiện tại là gốc
        }
        if (a == null) {
          if (!vi) return;
          a = inp.getAttribute('aria-label');
          var i0 = a.indexOf(SUB_APP_GIA.en);
          if (!co.call(SUB_APP_VI, chuanSub(i0 >= 0 ? a.slice(0, i0) : a))) return; // tên lạ ⇒ giữ cả câu EN
          inp.setAttribute('data-aef-sub-aria-en', a);
        }
        var ra = a;
        if (vi) {
          var i = a.indexOf(SUB_APP_GIA.en);
          ra = SUB_APP_VI[chuanSub(i >= 0 ? a.slice(0, i) : a)] + (i >= 0 ? SUB_APP_GIA.vi + a.slice(i + SUB_APP_GIA.en.length) : '');
        }
        if (inp.getAttribute('aria-label') !== ra) inp.setAttribute('aria-label', ra);
        inp.setAttribute('data-aef-sub-aria-ghi', ra);
      });
    });
  }
  function henSubApp() {
    if (document.querySelector(SUB_APP_GOC)) setTimeout(function () { applySubAppI18n(); }, 0);
  }
  document.addEventListener('variant:change', henSubApp);
  document.addEventListener('on:variant:change', henSubApp);
  document.addEventListener('change', henSubApp, true);

  // #1 Announcement marquee (ticket_BUG_vi_i18n_gaps): items come from
  // merchant-set block.settings.text (EN) with no stable key, so they can't use
  // data-i18n. Map by exact EN textContent → VI; cache the original EN per node
  // so switching VI→EN restores it; unknown/future strings stay EN (safe
  // fallback). Runs from applyTranslations → load + every lang switch.
  var ANNOUNCE_VI = {
    '🚚 Free shipping on orders {zone_amount}+ — shipped nationwide': '🚚 Miễn phí ship cho đơn từ {zone_amount} — giao khắp nước Mỹ',
    // Giữ lại chuỗi DFW cũ: theme editor có thể còn bản cũ trong section settings
    // của theme khác, và Boss có thể sửa tay lại. Mất khoá = lòi tiếng Anh khi bấm VI.
    '🚚 Free shipping on orders $59+ in DFW & TX-OK': '🚚 Miễn phí giao cho đơn từ $59 (DFW & TX-OK)',
    '🎁 New customers — $10 OFF first order $100+':   '🎁 Khách mới — giảm $10 cho đơn đầu từ $100+',
    '🔥 Authentic Asian groceries — daily fresh':     '🔥 Hàng Á chính gốc — tươi mới mỗi ngày',
    '🥢 New arrivals every week':                     '🥢 Hàng mới về mỗi tuần',
    '⚡ Processed same business day — order before 2 PM CT': '⚡ Xử lý đơn cùng ngày làm việc — đặt trước 2 giờ chiều (giờ miền Trung)',
    '💸 Hot deals — shop the on-sale collection':     '💸 Ưu đãi hot — xem mục đang giảm giá'
  };
  // AK/HI/PR không có ngưỡng free-ship (USPS tính theo cân) nên câu "đơn từ $X"
  // không áp dụng — đổi hẳn câu, không nhét một con số cho có.
  var ANNOUNCE_REMOTE = {
    '🚚 Free shipping on orders {zone_amount}+ — shipped nationwide': {
      en: '🚚 Nationwide delivery — shipping calculated at checkout',
      vi: '🚚 Giao khắp nước Mỹ — phí ship tính ở bước thanh toán'
    }
  };
  function applyAnnouncementI18n(lang) {
    var vi = lang === 'vi';
    document.querySelectorAll('.aef-marquee__item, .aef-marquee__link').forEach(function (el) {
      // translate only leaf text holders: a __link, or an __item with no __link child
      if (el.classList.contains('aef-marquee__item') && el.querySelector('.aef-marquee__link')) return;
      // Nguồn EN phải là chuỗi GỐC còn nguyên token {zone_amount} (announcement-bar.liquid
      // để ở data-aef-ann-raw), không phải textContent đã thay số. Cache textContent
      // sẽ đóng băng "$59" vào node vĩnh viễn: đổi ZIP sang California không đổi được
      // nữa, và đó đúng là con số sai với hơn nửa số đơn.
      if (!el.dataset.aefEnText) {
        el.dataset.aefEnText = (el.getAttribute('data-aef-ann-raw') || el.textContent).trim();
      }
      var en = el.dataset.aefEnText;
      var out = vi && ANNOUNCE_VI[en] ? ANNOUNCE_VI[en] : en;
      if (isRemoteZone() && ANNOUNCE_REMOTE[en]) {
        /* Vùng không giao: câu băng thông báo về ship đổi sang 'zone.khong_giao' (đọc I18N,
           không chép) — "Nationwide delivery — shipping calculated at checkout" là hứa giao. */
        out = laVungKhongGiao()
          ? '🚚 ' + ((I18N[vi ? 'vi' : 'en'] || I18N.en)['zone.khong_giao'] || I18N.en['zone.khong_giao'])
          : ANNOUNCE_REMOTE[en][vi ? 'vi' : 'en'];
      }
      el.textContent = fillAmount(out);
    });
  }

  // Homepage HERO (sections/aef-hero.liquid, ticket_hero_redesign_styleA): text is
  // schema-editable EN; this swaps each [.aef-hero-i18n] node to VI on flip — SAME
  // cache-original pattern as the marquee. Edited settings with no VI entry stay EN
  // (graceful). Map keyed by the DEFAULT EN copy (trimmed, matches dataset cache).
  var HERO_VI = {
    'Same-day delivery in DFW': 'Giao trong ngày tại DFW',
    'Authentic Asian groceries,': 'Thực phẩm Á chính gốc,',
    'delivered same-day': 'giao ngay trong ngày',
    /* mảnh SAU của H1 trang same-day (sections/lp-sameday.liquid, ô headline_post) — 18/10/2026 */
    'within 20 miles of our Arlington TX fulfillment center': 'cho địa chỉ trong vòng 20 dặm quanh kho Arlington TX',
    'within 20 miles of DFW': 'trong bán kính 20 dặm quanh DFW',
    'Vietnamese, Korean, Chinese, Japanese & Thai — fresh every day. Order before 12 PM CT for same-day delivery within 20 miles of our Arlington, TX fulfillment center; Local Delivery the next business day within 30 miles.':
      'Việt, Hàn, Trung, Nhật & Thái — tươi mới mỗi ngày. Đặt trước 12 giờ trưa CT để được giao trong ngày trong bán kính 20 dặm quanh kho Arlington TX; trong 30 dặm thì giao nội vùng vào ngày làm việc kế tiếp.',
    'Shop hot deals →': 'Xem ưu đãi hot →',
    'Browse all products': 'Xem tất cả sản phẩm',
    '🚚 Same-day in DFW': '🚚 Giao trong ngày tại DFW',
    '✅ 100% authentic': '✅ 100% chính gốc',
    '📦 Free shipping $79+': '📦 Miễn phí ship từ $79',
    /* cuisine flag-CARD names (hero v3 renders PLAIN names, no emoji) — keys must match
       the rendered text or VI swap no-ops. Was keyed by the old emoji-tile labels
       ('🍜 Vietnamese') → cards stayed English in VI (bug found in QA sweep 2026-06-12). */
    'Vietnamese': 'Việt Nam',
    'Korean': 'Hàn Quốc',
    'Chinese': 'Trung Quốc',
    'Japanese': 'Nhật Bản',
    'All': 'Tất cả', 'Thai': 'Thái', 'Noodles': 'Mì & Bún', 'Beverages': 'Đồ uống',
    'Coffee': 'Cà phê', 'Candy': 'Kẹo', 'Household': 'Gia dụng'
  };
  function applyHeroI18n(lang) {
    var vi = (lang || getCurrentLang()) === 'vi';
    document.querySelectorAll('.aef-hero-i18n').forEach(function (el) {
      if (!el.dataset.aefEnText) el.dataset.aefEnText = el.textContent.trim();
      var en = el.dataset.aefEnText;
      el.textContent = vi && HERO_VI[en] ? HERO_VI[en] : en;
    });
  }
  // exposed so the section's inline script can localize immediately if ae_lang
  // is already 'vi' at first paint (before boot()'s applyTranslations runs)
  window.applyHeroI18n = applyHeroI18n;
  // Public i18n bridge (BUG minmax 2026-06-06): lets sibling scripts
  // (product-form.js add-clamp, cart.js qty-clamp) show user-facing messages
  // in the CURRENT ae_lang without duplicating the dict. EN fallback, then the
  // key itself. Read-only — never writes DOM.
  window.aefT = function (key) {
    var dict = I18N[getCurrentLang()] || I18N.en;
    if (dict[key] != null) return dict[key];
    return I18N.en[key] != null ? I18N.en[key] : key;
  };
  /* 🔴 6/9/2026, vòng 43 — CẦU CÓ ĐƯỜNG LÙI THẬT.
   *
   * aefT ở trên trả về CHÍNH CHUỖI KHOÁ khi thiếu — và chuỗi đó TRUTHY. Nên khuôn
   * đang dùng khắp nơi
   *     (window.aefT && window.aefT(k)) || fb
   * không bao giờ rơi được về `fb` một khi widget đã nạp: mất khoá là khách đọc
   * "reorder.add" hay "drawer.gift_err" NGAY TRÊN NÚT trong giỏ, không log, không
   * lỗi, không ai báo. Chữ vô nghĩa trên nút làm khách tưởng trang hỏng và bỏ giỏ —
   * tệ hơn hẳn nút đứng nguyên tiếng Anh.
   *
   * ⛔ ĐỪNG chữa bằng cách cho aefT trả null: có lời gọi KHÔNG có dự phòng bao
   * ngoài (aef-cart-drawer.js `el.textContent = zip || (window.aefT ? window.aefT('drawer.zip_unset') : …)`),
   * null vào textContent là in ra chữ "null" cho khách đọc. Nên: giữ nguyên hàm cũ,
   * thêm hàm MỚI.
   *
   * Bên gọi đổi sang:  var t = function (k, fb) { return window.aefTFb ? window.aefTFb(k, fb) : fb; };
   * GIỮ vế kiểm tra sự tồn tại — file này nạp `defer`, nhiều khối inline chạy TRƯỚC
   * nó, và đó mới là ca mà câu dự phòng đang thật sự phục vụ hằng ngày.
   *
   * 🔴 HÔM NAY CHƯA CÓ AI GỌI aefTFb. Commit này CHỈ dựng cái cầu; lợi ích
   * ("mất khoá thì khách đọc câu tiếng Anh") CHƯA TỚI được khách chỗ nào cả.
   * Đừng đọc dòng xanh của người gác thành "xong" —
   * `node scripts/test-cau-dich-co-duong-lui-that.js` in ra số nợ còn lại mỗi lượt.
   *
   * KIỂM KÊ THẬT (đo 7/9/2026 bằng mệnh đề 4 của người gác, KHÔNG đếm tay).
   * Bản khai đầu tiên nói "6 hàm trợ giúp ở aef-cart-drawer.js + hai chỗ lẻ" — SAI:
   * số thật là 44 CHỖ TRONG 17 TỆP NGUỒN (đã loại 3 bản gộp sinh tự động), cộng 7
   * chỗ đã tự vá tại chỗ bằng bản sao của chính mảnh logic này. Ai tin con số 8 rồi
   * đi làm nốt sẽ bỏ lại 36 chỗ.
   *
   * VÀ NÓ CÓ BA KHUÔN, KHÔNG PHẢI MỘT — sed theo khuôn [A] bỏ sót 17 chỗ:
   *   [A] (window.aefT && window.aefT(k)) || fb                      27 chỗ
   *   [B] (window.aefT ? window.aefT(k) : X) …                       14 chỗ
   *       ⚠️ sections/aef-fbt.liquid nằm ở khuôn này:
   *          (window.aefT ? window.aefT('fbt.added') : null) || 'Added ✓'
   *       phải xử RIÊNG, chuỗi tìm-thay của khuôn [A] không chạm tới nó.
   *   [C] (typeof window.aefT === 'function' && window.aefT(k)) || fb  3 chỗ
   *       assets/aef-moq-relax.js · assets/predictive-search.js · layout/theme.liquid.
   *       Chỗ theme.liquid là nhãn "Min order:" của aefTienToiThieu — 955 SP có
   *       custom.min_qty, mất khoá ở đó là in "card.min_hint" ngay cạnh số tiền.
   *
   * CHUYỂN LÀM HAI COMMIT RIÊNG, ĐỪNG GỘP VÀO ĐÂY:
   *   (a) .liquid + assets/*.js KHÔNG thuộc bản gộp — rẻ, không cần builder;
   *   (b) assets/aef-cart-drawer.js SAU CÙNG: nó nằm trong aef-app.js nên bắt buộc
   *       chạy scripts/build-js-bundles.js RỒI mới push, cộng đủ 6 bước chống hồi
   *       quy giỏ. */
  window.aefTFb = function (key, fb) {
    var v = window.aefT(key);
    return (!v || v === key) ? fb : v;
  };
  // Zone label/sub → dict-key maps (review 2026-06-10): zone-detection.js emits
  // EN literals; the FSB snippet localizes them via these maps. They live HERE,
  // next to the I18N dict they index into, so adding a zone label + its
  // translation stays a one-file change (free-shipping-bar.liquid reads these
  // with an EN-literal fallback when the widget is absent).
  window.aefZoneLabelKey = {
    'FREE shipping':        'fsb.label_free',
    'FREE local delivery':  'fsb.label_local',
    'USPS calculated rate': 'fsb.label_usps'
  };
  window.aefZoneSubKey = { 'Same-day delivery': 'fsb.sub_sameday' };
  // Exposed so section-injected DOM (e.g. the cart drawer re-fetch) can
  // re-localise its data-i18n nodes after swapping innerHTML.
  window.applyTranslations = applyTranslations;

  function wireLangSwitchers() {
    document.querySelectorAll('[data-aef-lang]').forEach(function (root) {
      if (root._aefLangInit) return;
      root._aefLangInit = true;
      var trigger = root.querySelector('[data-aef-lang-trigger]');
      var menu    = root.querySelector('[data-aef-lang-menu]');
      if (!trigger || !menu) return;
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = menu.hidden === false;
        menu.hidden = open;
        trigger.setAttribute('aria-expanded', String(!open));
      });
      root.querySelectorAll('[data-aef-lang-set]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setLang(btn.getAttribute('data-aef-lang-set'));
          menu.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        });
      });
      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) {
          menu.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !menu.hidden) {
          menu.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });
    });
  }

  // ═══════════════════════════════════════════════════════════════════
  // Delivery widget — backend logic (UNCHANGED from build #2)
  // ═══════════════════════════════════════════════════════════════════
  var ORIGIN_ZIP = '76010';
  var STORAGE_ZIP = 'ae_zip_code';
  var TZ = 'America/Chicago';

  /* ⚠️ ĐỪNG DỌN `maxMiles`, `FAR_PREFIX_RE` và `haversineMiles` — chúng KHÔNG
     phải mã chết. Từ 13/8/2026 việc tra tier chạy bằng bảng làm sẵn, nên ba thứ
     này không còn được gọi lúc chạy; nhưng chúng là BẢN ĐẶC TẢ mà
     scripts/build-zip-tiers.js đọc thẳng ra (bằng regex) để sinh bảng đó. Xoá
     hoặc sửa số ở đây = đổi luật giao hàng ⇒ phải chạy lại:
         node scripts/build-zip-tiers.js
     Script sẽ dừng và báo lỗi to nếu không bóc được hằng số, nên sai sót không
     lọt im lặng. Các trường còn lại (cutoffHour/transitMin/transitMax/sameDay)
     vẫn dùng lúc chạy trong buildPromise(). */
  var TIER_DEFS = {
    tier1: { maxMiles:  20, cutoffHour: 12, transitMin: 0, transitMax: 0, sameDay: true  },
    tier2: { maxMiles: 400, cutoffHour: 14, transitMin: 1, transitMax: 1, sameDay: false },
    tier3: { maxMiles: 700, cutoffHour: 14, transitMin: 2, transitMax: 2, sameDay: false },
    tier4: { maxMiles:  Infinity, cutoffHour: 14, transitMin: 3, transitMax: 5, sameDay: false },
    tier5: { maxMiles:  Infinity, cutoffHour: 14, transitMin: 5, transitMax: 7, sameDay: false }
  };
  /* 25/8/2026 — MỞ RA CHO FILE KHÁC ĐỌC, chỉ để ĐỌC.
     assets/aef-marketdeals.js (dải khuyến mãi trang chủ) trước đây tự ghi cứng
     "2 giờ chiều" làm giờ chốt giao trong ngày, trong khi giờ chốt thật của
     tier1 là 12 giờ trưa. Hai nơi giữ cùng một con số thì sớm muộn cũng lệch —
     và lần này đã lệch 2 tiếng, mỗi ngày, trên trang chủ.
     Nay chỉ còn MỘT bảng. File nào cần thì đọc window.AEF_TIER_DEFS; không đọc
     được thì phải IM, không được đoán. */
  window.AEF_TIER_DEFS = TIER_DEFS;
  /* 16/10/2026 (vòng 53, làn giao-hang — Boss "thì fix chứ sao") — VÒNG XE NHÀ tier2.
     Local Delivery của Shopify (Admin → Shipping and delivery → Local delivery) giao trong bán kính
     maxMiles quanh kho Arlington, TX (Boss chốt 30 mi ngày 27/9; trang chính sách theme
     + chính sách Shopify in "within 30 miles of Arlington"). Admin API KHÔNG phơi bán kính đó, nên đây
     là BẢN ĐẶC TẢ như maxMiles của TIER_DEFS: scripts/build-zip-tiers.js bóc nó bằng regex rồi sinh
     danh sách `local_t2` (ZIP tier2 có tâm GeoNames cách ORIGIN_ZIP ≤ maxMiles − bienMiles) vào
     assets/zip-tiers.json. bienMiles = trừ hao: tâm ZIP ≠ địa chỉ khách, tâm ZIP của ORIGIN_ZIP ≠ địa chỉ kho — ZIP
     ở dải biên bị hứa CHẬM hơn (số Standard) chứ không bao giờ nhanh hơn. Đổi số ở đây ⇒ chạy lại
     node scripts/build-zip-tiers.js. Người gác: scripts/test-vong-xe-nha-mot-nguon.js (số này = bán
     kính in trên trang chính sách; danh sách = sinh lại từ số này). */
  var LOCAL_DELIVERY = { maxMiles: 30, bienMiles: 4 };
  //   028-029 RI, 030-038 NH, 039-049 ME, 050-059 VT, 967-968 HI, 980-994 WA, 995-999 AK
  var FAR_PREFIX_RE = /^(02[89]|03\d|04\d|05\d|967|968|98\d|99\d)/;

  /* ═══ vòng 48, 14/9/2026 — ZIP QUÂN ĐỘI: CÓ TIER, NHƯNG KHÔNG ĐƯỢC HỨA NGÀY
     (phát hiện fsb-zip-2)

     ⚠️ ĐỪNG nhét mấy dải này vào FAR_PREFIX_RE ngay trên. FAR_PREFIX_RE là BẢN
     ĐẶC TẢ mà scripts/build-zip-tiers.js bóc ra bằng regex để sinh bảng; đụng
     vào nó là phải sinh lại assets/zip-tiers.json. Hằng số dưới đây chỉ sống
     LÚC CHẠY, trong chính viên thuốc này, nên bảng không phải đổi một byte.

     BỆNH: bảng tier tính bằng haversine từ kho gốc (lúc ấy 76060; số dặm dưới đo từ đó), mà toạ độ GeoNames của
     ZIP quân đội là toạ độ NƯỚC NGOÀI THẬT —
         09021 = [49.4292, 7.6969]    Kaiserslautern, Đức   5.141 dặm
         96201 = [34.7167, 128.5833]  Hàn Quốc              6.916 dặm
         96522 = [22.2783, 114.1747]  Hong Kong             8.114 dặm
         34030 = [-22.9114, -43.1737] Rio de Janeiro        5.237 dặm
         96550 = [-21.9306, 114.1209] Tây Úc               10.385 dặm (xa nhất)
     Vượt 700 dặm ⇒ rơi vào tier4 (maxMiles Infinity — cái rổ hứng MỌI thứ xa
     hơn tier3), tức được hứa "3-5 day delivery" KÈM NGÀY CỤ THỂ, y hệt Los
     Angeles. Đếm trên chính assets/zip-tiers.json đang phục vụ:
         09xxx 346 mã · 962xx-966xx 125 · 340xx 7 · 969xx 2  =  480 mã,
     TOÀN BỘ mang ký tự '4'.

     Thư APO/FPO/DPO đi theo chuyến hàng TUẦN qua một cổng quân sự (New York /
     San Francisco / Miami) rồi mới sang tay quân bưu — không có ngày nào đoán
     được từ khoảng cách đường chim bay. Đẩy sang tier5 ("5-7 ngày") cũng vẫn
     là con số bịa, chỉ bịa chậm hơn. Nên ở đây KHÔNG hứa ngày nào cả.

     DẢI (USPS Publication 28 §38) — không dải nào trùng ZIP dân sự lục địa:
         090-098  APO/FPO AE  (Âu / Trung Đông / Phi)
         340      DPO/APO/FPO AA (Mỹ Latinh) — FL dùng 320-339, 341-342, 344,
                  346-347, 349 nên 340 KHÔNG cướp mã nào của Florida
         962-966  APO/FPO AP  (Thái Bình Dương)
         969      Guam / Bắc Marianas + FPO AP
     967-968 (Hawaii) và 995-999 (Alaska) KHÔNG nằm đây: hàng ship tới đó được
     thật, FAR_PREFIX_RE đã xếp chúng vào tier5 và giữ nguyên như cũ.
     00601 (PR) · 00802 (VI) · 96910 (Guam) · 96950 (Saipan) không có trong
     GeoNames nên bảng trả '0' ⇒ đã đi nhánh err_unknown từ trước, không đụng. */
  var APO_PREFIX_RE = /^(09\d|340|96[2-6]|969)/;
  function laZipQuanDoi(zip) { return APO_PREFIX_RE.test(String(zip)); }
  /* 28/9/2026 — phơi ra (thuần đọc) cho ô kiểm ZIP của sections/lp-sameday.liquid: "ZIP này là
     địa chỉ quân đội ⇒ không hứa ngày" chỉ có MỘT định nghĩa (dải này). */
  window.aefZipQuanDoi = laZipQuanDoi;

  var WEEKDAY_VI = ['Chủ Nhật','Thứ Hai','Thứ Ba','Thứ Tư','Thứ Năm','Thứ Sáu','Thứ Bảy'];
  var WEEKDAY_EN = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var THANG_EN = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  function haversineMiles(lat1, lng1, lat2, lng2) {
    var R = 3958.8, toRad = Math.PI / 180;
    var dLat = (lat2 - lat1) * toRad, dLng = (lng2 - lng1) * toRad;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(a)));
  }

  /* Bảng tra ZIP → tier, làm sẵn lúc build bằng scripts/build-zip-tiers.js.

     Chỗ này TRƯỚC ĐÂY tải assets/zip-centroids.json — 1,07 MB toạ độ của 41.488
     ZIP, 358 KB qua đường truyền, trên MỌI trang — rồi chạy haversine để ra tier.
     Kho đứng yên và ngưỡng tier cố định, nên phép tính đó là một hàm hằng: tính
     sẵn được. Bảng kết quả nặng 12,6 KB qua đường truyền thay cho 358 KB.

     Chuỗi có đúng 100.000 ký tự; chỉ số = ZIP dạng số; ký tự = tier '1'..'5';
     '0' = ZIP không có trong dữ liệu GeoNames → vẫn đi nhánh err_unknown y hệt
     hồi getCentroid() trả null. (Đó là lý do KHÔNG mã hoá theo dải: dải chỉ tốn
     2,4 KB nhưng sẽ trả tier cho cả ZIP không tồn tại, tức là hứa giao hàng tới
     một địa chỉ không có thật.) */
  var zipTierPromise = null;
  /* Vòng xe nhà tier2 (LOCAL_DELIVERY) — đọc từ `local_t2` của CÙNG bảng. Thiếu / sai dạng ⇒ rỗng:
     mọi tier2 đi số Standard của Shopify (hứa chậm hơn, không bao giờ nhanh hơn). */
  var zipVongXeNha = {};
  function loadZipTiers(jsonUrl) {
    if (zipTierPromise) return zipTierPromise;
    zipTierPromise = fetch(jsonUrl, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('ZIP tiers ' + r.status); return r.json(); })
      .then(function (p) {
        if (!p || typeof p.t !== 'string' || p.t.length !== 100000) {
          throw new Error('ZIP tiers: bảng sai dạng');
        }
        /* Chốt chặn lệch phiên bản: bảng được sinh cho MỘT ZIP kho cụ thể. Nếu
           ORIGIN_ZIP ở trên đổi mà quên chạy lại script thì mọi lời hứa giao
           hàng sẽ tính từ kho cũ mà không ai biết. Cảnh báo to, nhưng vẫn dùng
           bảng — mất lời hứa hoàn toàn còn tệ hơn lời hứa hơi cũ. */
        if (p._meta && p._meta.origin_zip && p._meta.origin_zip !== ORIGIN_ZIP) {
          console.warn('[aef-delivery] bảng zip-tiers sinh cho kho ' + p._meta.origin_zip +
            ' nhưng ORIGIN_ZIP đang là ' + ORIGIN_ZIP +
            ' — chạy lại: node scripts/build-zip-tiers.js');
        }
        zipVongXeNha = {};
        if (Array.isArray(p.local_t2)) {
          p.local_t2.forEach(function (z) { if (/^\d{5}$/.test(String(z))) zipVongXeNha[String(z)] = true; });
        } else {
          console.warn('[aef-delivery] bảng zip-tiers thiếu local_t2 — tier2 đi số Standard; chạy lại: node scripts/build-zip-tiers.js');
        }
        return p.t;
      })
      .catch(function (err) { console.error('[aef-delivery]', err); zipTierPromise = null; return null; });
    return zipTierPromise;
  }
  /* Trả 'tier1'..'tier5', hoặc null khi ZIP không có trong dữ liệu. */
  function getTierFromTable(table, zip) {
    if (!table) return null;
    var n = Number(zip);
    if (!(n >= 0 && n < 100000)) return null;
    var code = table.charCodeAt(n) - 48;
    return code >= 1 && code <= 5 ? 'tier' + code : null;
  }

  /* ----- ngày lễ + hai lịch làm việc -----
     24/10/2026 (vòng 53, đợt 5f, làn dot5f-giao — Boss chốt, đừng hỏi lại):
       "làm liên tục 24/7 chỉ là UPS hoặc USPS không tới lấy hàng thôi" · "giao hết trừ lễ và chủ nhật thôi"
       ⇒ NGÀY LỄ = ngày UPS/USPS không tới lấy hàng = 11 lễ liên bang (CÓ Juneteenth 19/6), KHÔNG có thứ
       Sáu sau Thanksgiving. Nghỉ bù theo đúng lịch vận hành của hai hãng — HAI HÃNG CÙNG MỘT LUẬT:
         · lễ rơi CHỦ NHẬT ⇒ nghỉ thêm THỨ HAI kế (USPS memo 18/6/2021 "observed on Monday, July 5th";
           UPS 2022 Holiday Operations Schedule "Christmas Day (Observed) Monday 26-Dec-22 Closed").
         · lễ rơi THỨ BẢY ⇒ chỉ nghỉ đúng thứ Bảy, thứ Sáu trước VẪN lấy hàng (USPS memo 22/6/2026
           "observed on Saturday, July 4, 2026" + "Friday, July 3 … regular delivery and collections";
           UPS 2026 schedule "Independence Day (Observed) Friday 3-Jul-26 Open"). Luật "lễ T7 ⇒ nghỉ thứ
           Sáu" của OPM / ELM 518.21 là lịch NGHỈ PHÉP nhân viên, không phải lịch lấy hàng.
         · Black Friday: UPS 2026 "Day after Thanksgiving Friday 27-Nov-26 Open", USPS làm bình thường.
       Hai hãng chỉ khác ở TẬP lễ (UPS 2026 vẫn chạy Presidents/Juneteenth/Columbus/Veterans) — Boss chốt
       11 lễ = đúng tập USPS đóng cửa. 24/12 và 31/12 UPS không lấy Ground nhưng USPS vẫn lấy ⇒ không nghỉ.
       Nguồn đầy đủ: W/_luu-2310/dot5f-giao/nguon/NGUON-LICH-HANG.md + BAO-CAO.md.
     MỘT bảng lễ, HAI lịch theo thứ (LICH_NGHI_THU):
       'noi_vung' — xe nhà (tier1 ≤ 20 dặm giao trong ngày + tier2 trong vòng xe nhà local_t2): làm T2–T7,
                    nghỉ Chủ nhật + lễ. Đặt thứ Sáu ⇒ 20–30 dặm giao thứ Bảy; thứ Bảy trước 12h ⇒ trong ngày.
       'hang'     — gửi UPS/USPS (mọi ZIP còn lại): ngày gửi T2–T6, nghỉ T7 + CN + lễ; ngày đi đường của
                    hãng đếm như cũ (ngày làm việc của hãng, bỏ T7/CN/lễ).
     ⚠️ holidaysForYear chỉ được gọi nthWeekday/lastWeekday (người gác bóc ba hàm này chạy trong vm).
     Người gác: scripts/test-lich-giao-noi-vung-va-hang.js · scripts/test-lp-sameday-khong-hua-bua.js PHẦN A. */
  function nthWeekday(year, month, weekday, n) {
    var d = new Date(Date.UTC(year, month, 1));
    var offset = (weekday - d.getUTCDay() + 7) % 7;
    return new Date(Date.UTC(year, month, 1 + offset + (n - 1) * 7));
  }
  function lastWeekday(year, month, weekday) {
    var lastDay = new Date(Date.UTC(year, month + 1, 0));
    var offset = (lastDay.getUTCDay() - weekday + 7) % 7;
    return new Date(Date.UTC(year, month, lastDay.getUTCDate() - offset));
  }
  function ymdUTC(d) {
    return d.getUTCFullYear() + '-' +
      String(d.getUTCMonth() + 1).padStart(2, '0') + '-' +
      String(d.getUTCDate()).padStart(2, '0');
  }
  function holidaysForYear(year) {
    var le = [
      new Date(Date.UTC(year, 0, 1)),     // New Year's Day
      nthWeekday(year, 0, 1, 3),          // Martin Luther King Jr. Day — thứ Hai thứ 3 tháng 1
      nthWeekday(year, 1, 1, 3),          // Presidents' Day — thứ Hai thứ 3 tháng 2
      lastWeekday(year, 4, 1),            // Memorial Day — thứ Hai cuối tháng 5
      new Date(Date.UTC(year, 5, 19)),    // Juneteenth
      new Date(Date.UTC(year, 6, 4)),     // Independence Day
      nthWeekday(year, 8, 1, 1),          // Labor Day — thứ Hai đầu tháng 9
      nthWeekday(year, 9, 1, 2),          // Columbus Day — thứ Hai thứ 2 tháng 10
      new Date(Date.UTC(year, 10, 11)),   // Veterans Day
      nthWeekday(year, 10, 4, 4),         // Thanksgiving — thứ Năm thứ 4 tháng 11 (thứ Sáu sau đó KHÔNG nghỉ)
      new Date(Date.UTC(year, 11, 25))    // Christmas Day
    ];
    var ra = [];
    for (var i = 0; i < le.length; i++) {
      ra.push(le[i]);
      /* lễ rơi Chủ nhật ⇒ hai hãng nghỉ bù thứ Hai kế; lễ rơi thứ Bảy ⇒ KHÔNG lùi sang thứ Sáu */
      if (le[i].getUTCDay() === 0) ra.push(new Date(Date.UTC(le[i].getUTCFullYear(), le[i].getUTCMonth(), le[i].getUTCDate() + 1)));
    }
    return ra;
  }
  var holidaySet = null;
  function ensureHolidays(forYear) {
    if (holidaySet && holidaySet.year === forYear) return holidaySet.set;
    var s = {};
    holidaysForYear(forYear).concat(holidaysForYear(forYear + 1))
      .forEach(function (d) { s[ymdUTC(d)] = true; });
    holidaySet = { year: forYear, set: s };
    return s;
  }
  function isHoliday(d) { return !!ensureHolidays(d.getUTCFullYear())[ymdUTC(d)]; }
  /* Thứ nghỉ cố định của từng lịch (0 = Chủ nhật, 6 = thứ Bảy) — xem khối chú thích "ngày lễ + hai lịch". */
  var LICH_NGHI_THU = { noi_vung: [0], hang: [0, 6] };
  /* Loại lịch lạ / thiếu ⇒ lịch HÃNG (ít ngày làm hơn): quên truyền loại thì hứa CHẬM hơn, không bao giờ nhanh hơn. */
  function nghiTheoThu(w, loai) { return (LICH_NGHI_THU[loai] || LICH_NGHI_THU.hang).indexOf(w) >= 0; }
  function laNgayLam(d, loai) { return !nghiTheoThu(d.getUTCDay(), loai) && !isHoliday(d); }
  /* Xe nhà (tier1 + tier2 trong vòng xe nhà) đi lịch nội vùng; mọi ZIP khác gửi hãng. */
  function loaiLich(tier, zip) {
    return (tier === 'tier1' || (tier === 'tier2' && trongVongXeNha(zip))) ? 'noi_vung' : 'hang';
  }
  function addDaysUTC(d, n) { return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + n)); }
  function nextBusinessDay(d, loai) {
    var cur = addDaysUTC(d, 1);
    while (!laNgayLam(cur, loai)) cur = addDaysUTC(cur, 1);
    return cur;
  }
  function addBusinessDays(d, n, loai) {
    var cur = d;
    for (var i = 0; i < n; i++) cur = nextBusinessDay(cur, loai);
    return cur;
  }

  function nowInTexas() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short'
    });
    var parts = {};
    fmt.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var wk = { Sun:0, Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6 };
    var h = parseInt(parts.hour, 10); if (h === 24) h = 0;
    return {
      year:  parseInt(parts.year, 10),
      month: parseInt(parts.month, 10) - 1,
      day:   parseInt(parts.day, 10),
      hour:  h,
      minute:parseInt(parts.minute, 10),
      weekday: wk[parts.weekday]
    };
  }
  /* loai: 'noi_vung' | 'hang' — ngày xuất kho (xe nhà đi giao / hãng tới lấy) theo đúng lịch của loại đó. */
  function getShipDate(tier, txNow, loai) {
    var today = new Date(Date.UTC(txNow.year, txNow.month, txNow.day));
    var def = TIER_DEFS[tier];
    var past = txNow.hour >= def.cutoffHour;
    var ok = laNgayLam(today, loai) && !past;
    return ok ? today : nextBusinessDay(today, loai);
  }
  function getDeliveryDates(tier, shipDate, loai) {
    var def = TIER_DEFS[tier];
    if (def.sameDay) return { min: shipDate, max: shipDate };
    var mn = addBusinessDays(shipDate, def.transitMin, loai);
    var mx = def.transitMax > def.transitMin ? addBusinessDays(shipDate, def.transitMax, loai) : mn;
    return { min: mn, max: mx };
  }

  /* 23/10/2026 (vòng 53, đợt 5b, LU4-17) — "HÔM NAY CÒN ĐI KỊP KHÔNG" VỀ MỘT NGUỒN, chỉ để ĐỌC.
     Ô kiểm ZIP của sections/lp-sameday.liquid tự xem thứ + giờ nhưng KHÔNG có bảng ngày lễ ⇒ vào
     Veterans Day 11/11 và Thanksgiving 26/11 lúc 10:00 CT nó nói "✅ … it arrives today" trong khi
     viên header CÙNG trang nói "Tomorrow · Thu 12/11" / "Mon 30/11" (người soi đo LIVE, 18/10).
     Nay ô ZIP hỏi đúng phép tính viên dùng: getShipDate() (thứ · giờ chốt TIER_DEFS · isHoliday)
     trên nowInTexas() — không chép bảng lễ sang trang khác.
     Trả 'con-kip' (hôm nay còn đi kịp) · 'nghi' (hôm nay nghỉ theo lịch của loại giao: nội vùng nghỉ
     CN + lễ; gửi hãng nghỉ T7 + CN + lễ) · 'qua-gio' (ngày làm việc, đã qua giờ chốt) · null (tier lạ /
     đồng hồ hỏng — bên gọi đừng hứa gì). `zip` chỉ cần cho tier2 (trong vòng xe nhà hay gửi hãng);
     tier1 luôn là nội vùng. Không đụng DOM, localStorage hay sự kiện.
     Người gác: scripts/test-lp-sameday-khong-hua-bua.js PHẦN A · scripts/test-lich-giao-noi-vung-va-hang.js. */
  window.AEF_giaoHomNay = function (tier, zip) {
    try {
      var t = tier || 'tier1';
      if (!TIER_DEFS[t]) return null;
      var now = nowInTexas();
      if (isNaN(now.year) || isNaN(now.day) || !(now.hour >= 0 && now.hour <= 23) || now.weekday === undefined) return null;
      var today = new Date(Date.UTC(now.year, now.month, now.day));
      var loai = loaiLich(t, zip);
      if (ymdUTC(getShipDate(t, now, loai)) === ymdUTC(today)) return 'con-kip';
      if (!laNgayLam(today, loai)) return 'nghi';
      return 'qua-gio';
    } catch (e) { return null; }
  };

  // ----- formatting -----
  /* 01/11/2026: khách Mỹ đọc "Thu 5/11" thành tháng 5. EN ghi tháng bằng chữ, VI giữ ngày/tháng.
     Bóc ngày ở phía người gác: scripts/lib/ngay-tren-vien.js. */
  function fmtDate(d, lang) {
    if (lang === 'vi') return WEEKDAY_VI[d.getUTCDay()] + ' ' + d.getUTCDate() + '/' + (d.getUTCMonth() + 1);
    return WEEKDAY_EN[d.getUTCDay()] + ', ' + THANG_EN[d.getUTCMonth()] + ' ' + d.getUTCDate();
  }
  function fmtRange(a, b, lang) {
    if (ymdUTC(a) === ymdUTC(b)) return fmtDate(a, lang);
    return fmtDate(a, lang) + ' – ' + fmtDate(b, lang);
  }

  // True iff `target` is the literal calendar day after `today` (UTC compare).
  function isLiteralNextDay(today, target) {
    return ymdUTC(addDaysUTC(today, 1)) === ymdUTC(target);
  }

  /* ═══════════════════════════════════════════════════════════════════════════
     vòng 48, 14/9/2026 — "MẤY NGÀY THÌ TỚI" VỀ MỘT NGUỒN (nửa còn lại của bản
     vá 5/9, xem snippets/free-shipping-bar.liquid:272-282)

     Trước hôm nay, trên CÙNG một màn hình khách đọc được hai con số khác nhau:
         viên này                          ← TIER_DEFS, một bảng tự tính bằng
           [data-aef-dw-promise]             khoảng cách từ kho ORIGIN_ZIP
         thanh free-ship ngay dưới         ← delivery_days của
           (snippets/free-shipping-bar)      /cart/shipping_rates.json, tức bảng
                                             giá THẬT dùng ở checkout
                                             (từ 27/9/2026: metafield shop
                                             custom.delivery_days do cron đo)
     Dựng lại được bằng jsdom, ZIP 90001 (tier4), khách không gõ gì:
         AEF_RATE_DAYS 5-8  → viên "📦 3-5 day delivery · Fri 18/9 – Tue 22/9"
         AEF_RATE_DAYS 12-20→ viên "📦 3-5 day delivery · Fri 18/9 – Tue 22/9"
     Kéo hãng vận chuyển từ 5 ngày lên 20 ngày mà viên KHÔNG nhích một ký tự.
     tier4 là rổ lớn nhất của bảng: 27.434/41.488 mã ZIP (66,1%); cộng tier3
     (6.974) và tier5 (2.292) là 36.700/41.488 = 88,5%.

     BA điều phải làm cho đúng, đã trả giá mới biết:

     ① VÁ BA NHÁNH, KHÔNG PHẢI HAI. Chú thích FSB khai rõ "từ tier3 trở đi
        Shopify mới là bản gốc; TIER_DEFS chỉ đáng tin cho tier1/tier2 (xe của
        tiệm)". tier3 cũng mù y hệt. tier1/tier2 giữ nguyên — đó là xe nhà.

     ② NHÃN CŨNG MANG SỐ. Câu viên gồm HAI mảnh: copy.tier4 = '📦 3-5 day
        delivery' (chuỗi GÕ CỨNG, dòng ~1071) rồi mới tới dãy ngày. Chỉ thay dãy
        ngày là đẻ ra "📦 3-5 day delivery · Thu 17/9 – Tue 22/9" — tự chọi với
        chính mình trong CÙNG một câu, tệ hơn hiện trạng. Nên nhãn SINH RA từ
        đúng cặp min/max đang vẽ (nhanSoNgay). Cho cặp của TIER_DEFS thì nó tái
        tạo NGUYÊN VĂN cả 6 chuỗi tier3/4/5 × en/vi — có người gác giữ mệnh đề
        đó: scripts/test-vien-giao-hang-doc-hang-van-chuyen.js.

     ③ ĐƠN VỊ NGÀY KHÁC NHAU. (16/10/2026, làn giao-hang: ĐOẠN NÀY LÀ LỊCH SỬ — nay số của Shopify đọc là
        NGÀY LÀM VIỆC, xem DON_VI_NGAY_HANG ở khối "CHỈ XE NHÀ" ngay dưới; thanh free-ship in "· ~N business
        days" cùng đơn vị.) Bản 14/9: TIER_DEFS.transitMin/Max đếm NGÀY LÀM VIỆC (đi qua
        addBusinessDays: bỏ T7/CN + 11 ngày lễ liên bang). delivery_days của
        Shopify (khi ấy hiểu) là ngày theo LỊCH. Đổ thẳng số của hãng vào addBusinessDays là
        đẻ ra NGUỒN THỨ BA sai kiểu mới — 8 ngày lịch hoá 8 ngày làm việc ≈ 11-12
        ngày lịch. Nhánh này vì thế cộng bằng addDaysUTC, và cộng từ HÔM NAY chứ
        không từ ngày xuất kho: như vậy nhãn "N ngày" và dãy ngày khớp nhau đúng
        từng ngày, và cùng cách đọc với câu "· ~N days" của thanh free-ship.
        Nhánh rơi về TIER_DEFS giữ nguyên addBusinessDays như cũ.

     GIỚI HẠN CÒN LẠI, ghi ra để lượt sau đừng tưởng đã kín: congBoNgay() nằm
     sau fetchRate(), mà fetchRate thoát sớm khi giỏ RỖNG (FSB:294 `!count`).
     Giỏ rỗng ⇒ không có AEF_RATE_DAYS ⇒ viên vẫn rơi về TIER_DEFS (như LIVE).
     Giỏ CÓ món mà số ngày không dùng được (metafield thiếu/cũ/tạm dừng…) ⇒ từ
     9/10/2026 có gói khongSo ⇒ câu không số, không rơi về TIER_DEFS. Và số của
     hãng là số của gói RẺ NHẤT (FSB chọn `cents < best.price`), chưa chắc là
     gói khách bấm ở checkout. Vẫn đúng hơn bảng khoảng cách, nhưng đừng gọi nó
     là sự thật tuyệt đối.
     ═══════════════════════════════════════════════════════════════════════════ */
  function nhanSoNgay(min, max, lang) {
    if (lang === 'vi') {
      return min === max ? '📦 Giao ' + max + ' ngày' : '📦 Giao ' + min + '-' + max + ' ngày';
    }
    return min === max ? '📦 ' + max + '-day delivery' : '📦 ' + min + '-' + max + ' day delivery';
  }
  /* Đọc cầu nối do free-shipping-bar.liquid:283-293 phơi ra. Trả null khi gói
     không có, không phải của ZIP đang tính, hoặc mang số vô lý — lúc đó người
     gọi rơi về TIER_DEFS. Đọc window mỗi lượt VẼ (không chỉ lúc nghe sự kiện)
     vì viên thường vẽ TRƯỚC khi giá về.
     🔴 9/10/2026 (vòng 53, đợt 3) — gói KHÔNG SỐ ({ khongSo: true }, assets/aef-fsb.js
     congBoNgay): giỏ có món, Shopify đã có giá cho ĐÚNG ZIP này mà số ngày của
     metafield không dùng được (thiếu · cũ · tạm dừng · không trùng tên · giá theo
     hãng). Trả { khongSo: true } để buildPromise nói câu không số — KHÔNG rơi về
     TIER_DEFS: bảng khoảng cách hứa nhanh hơn Shopify (Denver "2-day" khi hãng nói
     5-8). Đừng đọc .min/.max của gói này: chúng là null. */
  function ngayTheoHangVanChuyen(zip) {
    var goi = window.AEF_RATE_DAYS;
    if (!goi || String(goi.postal || '') !== String(zip)) return null;
    /* 16/10/2026 — `local`: phương thức rẻ nhất của gói là Local Delivery (xe nhà) — buildPromise bỏ
       qua gói đó cho ZIP ngoài vòng xe nhà (xem khối "CHỈ XE NHÀ"). */
    var laLocal = goi.local === true;
    if (goi.khongSo === true) return { khongSo: true, local: laLocal };
    var mn = Math.round(Number(goi.min)), mx = Math.round(Number(goi.max));
    if (!isFinite(mn) || !isFinite(mx)) return null;
    if (mn < 1 || mx < mn || mx > 30) return null;
    return { min: mn, max: mx, local: laLocal };
  }

  /* ═══════════════════════════════════════════════════════════════════════════
     10/10/2026 (vòng 53, làn giao-hang — phương án Boss "ok chữ giao hàng": thôi hứa NHANH
     hơn Shopify). Ba thay đổi, cùng một luật: CHỈ XE NHÀ mới đọc TIER_DEFS.

     ① XE NHÀ = tier1 (≤ 20 dặm, giao trong ngày) + tier2 TRONG VÒNG XE NHÀ (LOCAL_DELIVERY ở trên —
        danh sách `local_t2` của assets/zip-tiers.json). Danh sách TĨNH theo ZIP ⇒ một ZIP nói MỘT câu
        ở mọi trạng thái giỏ. (Bản 10/10 chờ Shopify chào Local Delivery qua giỏ phụ ⇒ 72 ZIP tier2
        trong 30 dặm thấy "3-5 day" lúc giỏ rỗng rồi lật "Next-day" lúc có món — Boss 16/10: "thì fix
        chứ sao".) tier2 ngoài vòng (20–400 dặm: Houston, Austin, OKC, Little Rock, Jackson MS…, và dải
        biên 26–30 dặm) đi Standard Shipping 3–5 ngày — trước đây viên / PDP / ngăn giỏ vẫn hứa
        "✓ Next-day delivery" trong khi thanh free-ship cùng ngăn giỏ nói "~5 days" (BAO-CAO-R1 F1: 97
        ZIP mới + 1.627 ZIP có sẵn ngoài TX/OK). Nay tier2 ngoài vòng đi ĐÚNG đường tier3/4/5; gói mà
        phương thức rẻ nhất là Local Delivery (không có số ngày trong metafield ⇒ gói KHÔNG SỐ) bị bỏ
        qua cho các ZIP đó — đọc số theo bang — để dải biên không lật "3-5 day" → câu không số.
     ② GIỎ RỖNG (chưa có gói AEF_RATE_DAYS) ⇒ số theo BANG của metafield custom.delivery_days
        (window.aefSoNgayTheoBang — đúng docBangNgay() của thanh free-ship), không rơi về bảng
        khoảng cách (F2: 213 ZIP tier3 "2-day" khi checkout nói 3–5). Không đọc được (thiếu ·
        cũ · tạm dừng · nhiều phương thức khác số · aef-fsb.js chưa nạp) ⇒ câu KHÔNG SỐ.
     ③ ĐƠN VỊ NGÀY = DON_VI_NGAY_HANG — MỘT chỗ đổi. Shopify ghi transit time của giá tĩnh bằng
        NGÀY LÀM VIỆC ("Economy (5 to 8 business days)", help.shopify.com/en/manual/fulfillment/
        setup/shipping-rates/transit-time; 5–8 của US Far trùng đúng mục Economy đó) và "transit
        time doesn't account for order processing time". Bản 14/9 cộng NGÀY LỊCH từ HÔM NAY ⇒
        đặt thứ Sáu thì "3–5 ngày" thành thứ Hai–thứ Tư, sớm hơn checkout. Nay: 'lam_viec' ⇒ cộng
        addBusinessDays từ NGÀY XUẤT KHO (getShipDate — giờ chốt 14h CT, bỏ T7/CN + lễ liên
        bang); 'lich' ⇒ cách cũ (addDaysUTC từ hôm nay). Chữ "business days / ngày làm việc" của
        ô kiểm ZIP đọc khoá 'ship.don_vi_ngay' của I18N; trang chính sách in cùng chữ — đổi hằng này thì
        đổi khoá đó (người gác test-chu-chinh-sach-khop-so-ngay.js CA 1 đòi khớp).
     Người gác: scripts/test-vien-giao-hang-mat-so-ngay-khong-hua-nhanh.js (chuỗi metafield → thanh →
     viên → PDP → ngăn giỏ; ca L không lật) · scripts/test-vien-giao-hang-doc-hang-van-chuyen.js ·
     scripts/test-vong-xe-nha-mot-nguon.js · scripts/test-zip-quan-doi-khong-hua-ngay.js (CA 3).
     ═══════════════════════════════════════════════════════════════════════════ */
  var DON_VI_NGAY_HANG = 'lam_viec';   // 'lam_viec' (ngày làm việc) | 'lich' (ngày lịch)
  window.AEF_DON_VI_NGAY_HANG = DON_VI_NGAY_HANG;
  function trongVongXeNha(zip) { return zipVongXeNha[String(zip)] === true; }
  /* Giỏ rỗng: số theo bang của ZIP (bang hỏi zone-detection.js — aeZoneForZip, thuần đọc). */
  function ngayTheoBangCuaZip(zip) {
    try {
      if (typeof window.aefSoNgayTheoBang !== 'function' || typeof window.aeZoneForZip !== 'function') return { khongSo: true };
      var v = window.aeZoneForZip(zip);
      var n = window.aefSoNgayTheoBang(v && v.state);
      if (!n || n.khongSo) return { khongSo: true };
      var mn = Math.round(Number(n.min)), mx = Math.round(Number(n.max));
      if (!isFinite(mn) || !isFinite(mx) || mn < 1 || mx < mn || mx > 30) return { khongSo: true };
      return { min: mn, max: mx };
    } catch (e) { return { khongSo: true }; }
  }
  /* Ngày tới sớm nhất / muộn nhất cho cặp số của Shopify, theo đúng đơn vị ③. */
  /* Số của Shopify là số của HÃNG ⇒ luôn lịch 'hang' (gửi T2–T6, đi đường bỏ T7/CN/lễ) — kể cả tier2. */
  function dayNgayHang(tier, txNow, mn, mx) {
    var today = new Date(Date.UTC(txNow.year, txNow.month, txNow.day));
    if (DON_VI_NGAY_HANG === 'lich') return { min: addDaysUTC(today, mn), max: addDaysUTC(today, mx) };
    var ship = getShipDate(tier, txNow, 'hang');
    return { min: addBusinessDays(ship, mn, 'hang'), max: addBusinessDays(ship, mx, 'hang') };
  }

  function buildPromise(tier, zip, txNow, lang) {
    /* 24/10/2026 — xe nhà đi lịch nội vùng (T2–T7), gửi hãng đi lịch hãng (T2–T6): loaiLich(). */
    var loai = loaiLich(tier, zip);
    var ship = getShipDate(tier, txNow, loai);
    var deliv = getDeliveryDates(tier, ship, loai);
    var today = new Date(Date.UTC(txNow.year, txNow.month, txNow.day));
    var sameDay = ymdUTC(ship) === ymdUTC(today) && tier === 'tier1';
    var copy = TIER_COPY[lang] || TIER_COPY.en;
    /* ① Xe nhà (tier1, tier2 trong vòng xe nhà local_t2) đọc TIER_DEFS; mọi tier khác đọc số của Shopify. */
    var xeNha = loai === 'noi_vung';
    var hang = null;
    if (!xeNha) {
      var hvc = ngayTheoHangVanChuyen(zip);
      /* ① gói của Local Delivery (xe nhà) không nói gì về Standard Shipping của ZIP ngoài vòng. */
      if (hvc && hvc.local) hvc = null;
      /* ② chưa có gói của ZIP này ⇒ số theo bang (ZIP quân đội: im — xem khối dưới). */
      if (!hvc && !laZipQuanDoi(zip)) hvc = ngayTheoBangCuaZip(zip);
      if (hvc && hvc.khongSo) {
        /* 9/10/2026 — Shopify có giá mà không có số ngày dùng được: câu KHÔNG SỐ,
           cùng chuỗi với ZIP quân đội / lãnh thổ (copy.overseas), không dãy ngày. */
        hang = copy.overseas;
      } else if (hvc) {
        var dn = dayNgayHang(tier, txNow, hvc.min, hvc.max);
        hang = nhanSoNgay(hvc.min, hvc.max, lang) + ' · ' + fmtRange(dn.min, dn.max, lang);
      }
    }
    /* vòng 48, 14/9/2026 (fsb-zip-2) — 480 mã ZIP quân đội: IM về ngày.
       Đặt SAU khối `hang` là cố ý, không phải tiện tay: nếu
       số ngày THẬT (AEF_RATE_DAYS — từ 27/9/2026 là metafield custom.delivery_days,
       trước đó /cart/shipping_rates.json) có một gói cho địa chỉ này thì đó là
       bảng giá dùng ở checkout — con số tiệm thật sự cam kết, giữ lấy. Chỉ
       chặn nhánh rơi về TIER_DEFS, vì với 480 mã này nó ĐOÁN bằng khoảng cách
       đường chim bay tới Đức/Hàn/Nhật/Brazil và sai theo định nghĩa.
       Vẫn trả `tier` cũ (không bịa tier mới) để [data-tier] trên gốc widget và
       CSS theo tier không đổi hành vi; chỉ CÂU CHỮ khách đọc là đổi. */
    if (!hang && laZipQuanDoi(zip)) {
      return { promise: copy.overseas, zip: zip, tier: tier };
    }
    var p;
    if (hang) {
      /* ① tier2 ngoài Local Delivery + tier3/4/5: số của Shopify (gói / theo bang) hoặc câu không số. */
      p = hang;
    } else if (tier === 'tier1' && sameDay) {
      p = copy.tier1_same;
    } else if (tier === 'tier1') {
      // BUG-W (2026-05-21): "Tomorrow"/"ngày mai" must drop on a day the shop is
      // closed by weekday even though Monday is the literal next calendar day from
      // Sunday — the customer gets "Monday delivery". Gate the qualifier on
      // (literal-next-day) AND (today is not a weekly closed day).
      // 24/10/2026: lịch nội vùng chỉ nghỉ Chủ nhật — đặt thứ Sáu sau 12h ⇒ "Tomorrow · Sat";
      // thứ Bảy không bao giờ khớp literal-next-day (Chủ nhật không giao) nên cổng không đổi gì ở đó.
      if (isLiteralNextDay(today, deliv.min) && !nghiTheoThu(txNow.weekday, loai)) {
        p = copy.tier1_next + ' · ' + fmtDate(deliv.min, lang);
      } else {
        p = '🚚 ' + fmtDate(deliv.min, lang);
      }
    } else if (tier === 'tier2') {
      // BUG-W (2026-05-21): tier2 "✓ Next-day delivery" only when delivery genuinely
      // lands on the literal calendar next day from today. 24/10/2026: tier2 tới
      // đây chỉ khi trong vòng xe nhà ⇒ lịch nội vùng T2–T7: đặt thứ Sáu trước 14h
      // ⇒ giao thứ Bảy ("✓ Next-day delivery · Sat"); đặt thứ Bảy ⇒ thứ Hai (CN nghỉ).
      if (isLiteralNextDay(today, deliv.min) && !nghiTheoThu(txNow.weekday, loai)) {
        p = copy.tier2 + ' · ' + fmtDate(deliv.min, lang);
      } else {
        p = '✓ ' + fmtDate(deliv.min, lang);
      }
    } else {
      /* tier3/4/5 tới đây chỉ khi không có `hang` — không còn đường nào về bảng khoảng cách
         (TIER_COPY.tier3/4/5 chỉ còn là MẪU CHỮ mà nhanSoNgay phải tái tạo — người gác CA 6). */
      p = copy.overseas;
    }
    return { promise: p, zip: zip, tier: tier };
  }

  // ═══════════════════════════════════════════════════════════════════
  // Render
  // ═══════════════════════════════════════════════════════════════════
  function render(root, state) {
    var lang = getCurrentLang();
    var promiseEls = root.querySelectorAll('[data-aef-dw-promise]');
    var editEls    = root.querySelectorAll('[data-aef-dw-edit]');
    if (!promiseEls.length) return;
    /* 🔴 9/10/2026 (vòng 53, đợt 3) — XIN VẼ LẠI ĐÚNG TRẠNG THÁI VỪA XIN THÌ THÔI.
       Mỗi lượt render() làm viên mờ về 0 trong 80 ms rồi hiện lại (is-fading,
       ae-delivery-widget.css) — kể cả khi chữ y nguyên. Từ khi aef-fsb.js phơi gói KHÔNG
       SỐ (congBoNgay), ZIP tier1/2 mà phương thức rẻ nhất không có số ngày (Local Delivery)
       cũng nhận aef:rate-days ⇒ thêm một cú mờ-rồi-hiện mỗi lần tải trang có món, chữ không
       đổi (đo jsdom: 2 lần so với 1 lúc giỏ rỗng; LIVE không phát gói cho ZIP đó).
       So với trạng thái XIN VẼ gần nhất, KHÔNG so với chữ đang hiện: lượt trước còn chờ 80 ms
       thì chữ trên DOM vẫn là chữ cũ — so DOM sẽ bỏ nhầm một lượt mới hơn.
       Người gác: D2 của scripts/test-vien-giao-hang-mat-so-ngay-khong-hua-nhanh.js */
    var vetVe = lang + '|' + (state.zip ? state.zip + '|' + state.promise + '|' + (state.tier || '') : '');
    if (root._aefVetVe === vetVe) return;
    root._aefVetVe = vetVe;

    promiseEls.forEach(function (el) { el.classList.add('is-fading'); });
    setTimeout(function () {
      if (state.zip) {
        promiseEls.forEach(function (el) { el.textContent = state.promise; });
        editEls.forEach(function (el) { el.textContent = state.zip; });
        root.setAttribute('data-tier', state.tier || '');
      } else {
        var dict = I18N[lang] || I18N.en;
        var placeholder = dict['delivery.placeholder'] || 'see delivery date';
        var defaultZip = dict['delivery.choose_zip'] || 'Enter ZIP';
        promiseEls.forEach(function (el) { el.textContent = placeholder; });
        editEls.forEach(function (el) { el.textContent = defaultZip; });
        root.removeAttribute('data-tier');
      }
      promiseEls.forEach(function (el) { el.classList.remove('is-fading'); });
    }, 80);
  }

  // ----- LocalStorage helpers -----
  function safeGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function safeSet(k, v) { try { window.localStorage.setItem(k, v); return true; } catch (e) { return false; } }

  // ----- Modal/sheet -----
  function openSheet(root) {
    var modal = root.querySelector('[data-aef-dw-modal]');
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    /* 20/8/2026 vòng 24 — công tắc nâng TẦNG XẾP đang nhốt bảng này.
       Bảng ZIP khai z-index 9100 nhưng nó nằm trong `.aef-sticky-wrap`
       (z-index 100), nên so với phần còn lại của trang nó chỉ đáng 100 và
       thanh mua nhanh PDP (z-index 998, nằm ở gốc trang) vẽ đè lên đúng dải
       ba nút gợi ý ZIP — bấm gợi ý là THÊM HÀNG VÀO GIỎ. Xem chú thích dài ở
       ae-delivery-widget.css, ngay dưới `.aef-dw-sheet`. */
    document.documentElement.classList.add('aef-dw-sheet-open');
    var input = modal.querySelector('input[type="text"]');
    input && setTimeout(function () { input.focus(); input.select(); }, 30);
    function onKey(e) { if (e.key === 'Escape') { closeSheet(root); document.removeEventListener('keydown', onKey); } }
    root._aefKeyHandler = onKey;
    document.addEventListener('keydown', onKey);
  }
  function closeSheet(root) {
    var modal = root.querySelector('[data-aef-dw-modal]');
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    // trả header về đúng tầng cũ — chỉ nâng trong lúc bảng đang mở
    document.documentElement.classList.remove('aef-dw-sheet-open');
    if (root._aefKeyHandler) { document.removeEventListener('keydown', root._aefKeyHandler); root._aefKeyHandler = null; }
    var pill = root.querySelector('[data-aef-dw-pill]');
    pill && pill.focus();
  }

  /* ═══════════════════════════════════════════════════════════════════════════
     VÙNG KHÔNG CÓ NGƯỠNG FREE-SHIP — hỏi zone-detection, không tự định nghĩa lại.

     Thuần ĐỌC: `window.aeZoneForZip` (assets/zone-detection.js) không ghi
     window.AE_ZONE, không phát `ae-zone-ready`, không đụng localStorage. Cố ý
     KHÔNG gọi `aeZoneResolve()` — hàm đó ĐỔI vùng đang áp cho khách và kéo theo
     thanh free-ship tính lại; hỏi một câu thì không được phép làm đổi trạng thái.

     Thứ tự nạp bảo đảm có mặt: zone-detection.js nằm trong aef-head.js, thẻ
     script defer ở <head> (layout/theme.liquid:386), còn file này là thẻ defer
     trong thân trang (sections/header.liquid) — defer chạy theo thứ tự xuất hiện.
     Vẫn bọc typeof + try: thiếu thì trả null và mọi thứ về đúng hành vi cũ. */
  function vungKhongNguong(zip) {
    try {
      if (typeof window.aeZoneForZip !== 'function') return null;
      var v = window.aeZoneForZip(zip);
      return v && v.zone === 'remote' ? v : null;
    } catch (e) { return null; }
  }
  /* 28/9/2026 (vòng 53, đợt 4) — VÙNG KHÔNG GIAO: hỏi cờ `giao` của zone-detection.js,
     không giữ danh sách mã nào ở đây. Mở lại một lãnh thổ = đổi STATE_ZONE bên đó;
     viên này tự đi lại đường cũ (lãnh thổ: vungKhongNguong → copy.overseas; ZIP quân
     đội: bảng tier + laZipQuanDoi → copy.overseas, không hứa ngày). Thiếu hàm ⇒ null
     ⇒ hành vi cũ. Người gác: scripts/test-vung-khong-giao-mot-nguon.js */
  function vungKhongGiao(zip) {
    try {
      if (typeof window.aeZoneForZip !== 'function') return null;
      var v = window.aeZoneForZip(zip);
      return v && v.giao === false ? v : null;
    } catch (e) { return null; }
  }

  function resolveZip(root, zip, opts) {
    var lang = getCurrentLang();
    var copy = TIER_COPY[lang] || TIER_COPY.en;
    var errorEl = root.querySelector('[data-aef-dw-error]');
    var jsonUrl = root.getAttribute('data-aef-dw-db');
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    if (!/^\d{5}$/.test(zip)) {
      if (zip.length > 0 && /[^0-9]/.test(zip)) showErr(errorEl, copy.err_nonus);
      else showErr(errorEl, copy.err_short);
      return;
    }
    loadZipTiers(jsonUrl).then(function (table) {
      /* Vùng không giao hỏi TRƯỚC bảng tier: bảng khoảng cách xếp ZIP quân đội vào tier4
         (toạ độ nước ngoài) và mù trước lãnh thổ ('0') — câu trả lời "không giao" không
         cần bảng, nên bảng hỏng cũng không được nuốt nó. */
      var khongGiao = vungKhongGiao(zip);
      if (!table && !khongGiao) { showErr(errorEl, copy.err_load); return; }
      var tier = khongGiao ? null : getTierFromTable(table, zip);
      /* 🔴 15/9/2026, vòng 49 (fsb-zip-1) — BẢNG TIER MÙ TRƯỚC LÃNH THỔ MỸ.

         zip-tiers.json sinh từ scripts/data/zip-centroids.json = GeoNames US.zip,
         và bộ dữ liệu đó có ĐÚNG 0 mã trong dải 00600-00999 (Puerto Rico + USVI)
         và 0 mã 969xx (Guam/Bắc Marianas) — đếm trên chính file, không đoán. Nên
         00901 · 00692 · 00801 · 96910 · 96950 đều trả ký tự '0' ⇒ tier null.

         Bản trước thoát ngay tại đây bằng err_unknown. Hậu quả KHÔNG dừng ở câu
         báo đỏ: dòng `safeSet(STORAGE_ZIP, zip)` bên dưới không bao giờ chạy, mà
         `ae_zip_code` chính là BƯỚC ƯU TIÊN 0 của zone-detection. Tức khách
         PR/VI/Guam không còn MỘT đường nào tự khai vùng của mình, và rơi xuống
         FALLBACK us_far — đọc "FREE shipping on orders $79+" trên mọi trang rồi
         tới checkout mới thấy USPS vẫn tính cước. Lời hứa tiệm không giữ được.

         Vá bằng cách hỏi người BIẾT: zone-detection xếp ZIP theo TIỀN TỐ nên nó
         trả lời được đúng những mã mà bảng khoảng cách mù. Chỉ nhận khi vùng là
         `remote` — vùng KHÔNG có ngưỡng free-ship và KHÔNG hứa ngày nào, nên
         nhận một mã lạ trong dải đó cũng không sinh ra lời hứa nào để gãy. Mọi
         ZIP khác vẫn đi err_unknown y như cũ.

         Câu khách đọc dùng lại `copy.overseas` ("Delivery date at checkout" /
         "Ngày giao tính ở bước thanh toán") của bản vá ZIP quân đội, không đẻ
         chuỗi thứ hai cùng nghĩa: cả hai nhóm đều là "giao được, nhưng ngày do
         USPS quyết". Phần TIỀN thì thanh free-ship nói — một khi ZIP đã được lưu
         và `aef:zone-changed` đã bắn, nó đọc đúng nhãn `USPS calculated rate`
         của vùng remote thay cho con số $79.

         `tier: ''` là cố ý: PDP (main-product.liquid) và đồng hồ same-day
         (aef-marketdeals.js) đều lấy [data-tier] làm điều kiện hiện lời hứa —
         không tier thì chúng IM, đúng thứ mình muốn cho vùng không đoán được
         ngày. Thà im còn hơn hứa bừa.

         Nhánh mới đi qua ĐÚNG cổng `if (!opts || !opts.silent)` như cũ, không mở
         đường ghi localStorage nào bên ngoài nó — chuỗi đệ quy mà chú thích
         "P0 freeze fix 2026-05-17" ngay dưới đây cảnh báo vẫn bị chặn nguyên vẹn. */
      var vungXa = (tier || khongGiao) ? null : vungKhongNguong(zip);
      if (!tier && !vungXa && !khongGiao) { showErr(errorEl, copy.err_unknown); return; }
      /* Không giao: `tier: ''` (PDP + đồng hồ same-day IM như vùng remote), câu riêng, vẫn
         LƯU ZIP + bắn aef:zone-changed như mọi ZIP hợp lệ — để thanh free-ship và mọi
         câu {zone_amount} đọc đúng vùng thay vì ngưỡng dự phòng $79. */
      var state = khongGiao
        ? { promise: copy.khong_giao, zip: zip, tier: '' }
        : tier
        ? buildPromise(tier, zip, nowInTexas(), lang)
        : { promise: copy.overseas, zip: zip, tier: '' };
      render(root, state);
      /* P0 freeze fix 2026-05-17: opts.silent = true skips the
         safeSet + cache-invalidate + aef:zone-changed dispatch chain.
         Auto-fill / cosmetic re-render paths (called from the
         ae-zone-ready listener) pass silent so they don't re-trigger
         zone-detection.resolve() and create an infinite loop:
           resolve → ae-zone-ready → syncFromZone → aeRecomputeDelivery
                  → resolveZip → safeSet + dispatch aef:zone-changed
                  → resolve → ae-zone-ready → … (page freezes)
         Explicit user-submit + lang-change paths leave silent unset,
         so they still write LS + invalidate cache + signal the cart
         popup / free-shipping bar to re-render (BUG-P behaviour). */
      if (!opts || !opts.silent) {
        safeSet(STORAGE_ZIP, zip);
        /* BUG-P: when the visitor changes ZIP via the widget, the cached
           `ae_zone_v1` entry (set by zone-detection.js) is now stale —
           its `postal` field still points at the previous location.
           Invalidate it explicitly and signal zone-detection to
           re-resolve in-page so the mini-cart popup + free-shipping bar
           pick up the correct threshold without a reload. */
        try { localStorage.removeItem('ae_zone_v1'); } catch (e) {}
        try {
          window.dispatchEvent(new CustomEvent('aef:zone-changed', { detail: { zip: zip } }));
        } catch (e) {
          /* CustomEvent constructor missing (very old browsers) — fall back */
          try {
            var evt = document.createEvent('Event');
            evt.initEvent('aef:zone-changed', true, true);
            window.dispatchEvent(evt);
          } catch (e2) {}
        }
      }
      if (opts && opts.successEl) {
        opts.successEl.hidden = false;
        opts.successEl.textContent = copy.success;
        setTimeout(function () {
          opts.successEl.hidden = true;
          opts.successEl.textContent = '';
          closeSheet(root);
        }, 1500);
      }
    });
  }
  function showErr(el, msg) { if (!el) return; el.hidden = false; el.textContent = msg; }

  function refreshFromStorage(root) {
    var zip = safeGet(STORAGE_ZIP);
    if (zip && /^\d{5}$/.test(zip)) {
      var input = root.querySelector('[data-aef-dw-form] input[type="text"]');
      input && (input.value = zip);
      resolveZip(root, zip, null); // hand-typed — unchanged (writes LS + dispatch)
      return;
    }
    // No hand-typed ZIP → fall back to the geolocation cache so an AUTO-located ZIP
    // survives re-renders (ticket_QA_batch #1: lang-change / re-init used to wipe it
    // to "Enter ZIP"). silent:true → no LS write, no aef:zone-changed dispatch, so the
    // _aefZoneReadyBusy / silent recursion guard is untouched. Only {zip:null} when
    // genuinely nothing is known.
    var cached = cachedPostal();
    if (cached) { resolveZip(root, cached, { silent: true }); return; }
    render(root, { zip: null });
  }

  // ----- init each widget instance -----
  function initOne(root) {
    if (root._aefInit) return;
    root._aefInit = true;

    // Wire every pill trigger in this root (mobile + desktop instances both)
    root.querySelectorAll('[data-aef-dw-pill]').forEach(function (pill) {
      pill.addEventListener('click', function (e) { e.preventDefault(); openSheet(root); });
    });

    root.querySelectorAll('[data-aef-dw-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeSheet(root); });
    });

    var form = root.querySelector('[data-aef-dw-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type="text"]');
        var success = root.querySelector('[data-aef-dw-success]');
        var zip = (input && input.value || '').trim();
        resolveZip(root, zip, { successEl: success });
      });
    }

    root.querySelectorAll('[data-aef-dw-suggest]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var zip = chip.getAttribute('data-zip') || (chip.textContent || '').trim().slice(0, 5);
        var input = root.querySelector('[data-aef-dw-form] input[type="text"]');
        var success = root.querySelector('[data-aef-dw-success]');
        if (input) input.value = zip;
        resolveZip(root, zip, { successEl: success });
      });
    });

    refreshFromStorage(root);
  }

  // ═══════════════════════════════════════════════════════════════════
  // NGĂN DANH MỤC CHO ĐIỆN THOẠI — người nghe cho nút ☰
  // ───────────────────────────────────────────────────────────────────
  // 2026-08-16: `.aef-hamburger` (sections/header.liquid:59) tồn tại từ lâu mà
  // KHÔNG ai nghe nó — grep toàn theme chỉ ra 3 luật CSS và đúng thẻ button đó.
  // Khách mobile bấm là không có gì xảy ra, trong khi 12 ngành hàng không có
  // lối vào nào khác (thanh tab mobile chỉ có 8 vùng ẩm thực).
  //
  // Ngăn này khai `aria-modal="true"`, nên PHẢI bẫy tiêu điểm cho đủ — vòng 9
  // và vòng 10 đều đã bắt được lỗi "khai aria-modal mà để Tab chạy ra sau lưng".
  // Không lặp lại: bẫy Tab hai chiều · Escape đóng · trả tiêu điểm về nút ☰ ·
  // khoá cuộn nền · đặt/gỡ `hidden` để phần tử biến mất khỏi cả cây trợ năng.
  // ═══════════════════════════════════════════════════════════════════
  function wireMobileMenu() {
    var root = document.querySelector('[data-aef-mmenu]');
    var burger = document.querySelector('.aef-hamburger');
    if (!root || !burger) return;
    var panel = root.querySelector('.aef-mmenu__panel');
    var lastFocus = null;
    var openState = false;

    function focusables() {
      return Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null || el === document.activeElement; }
      );
    }

    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var list = focusables();
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      // Bẫy HAI CHIỀU. Chỉ chặn chiều tiến là tiêu điểm vẫn lùi ra sau lưng
      // tấm che được — đúng lỗi đã vá ở `5858f51`.
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      /* 🔴 20/8/2026, vòng 24 — MỆNH ĐỀ THỨ BA: TIÊU ĐIỂM ĐANG Ở NGOÀI NGĂN.
         Hai mệnh đề trên chỉ đúng khi tiêu điểm đã nằm SẴN trong ngăn. Nếu nó đang ở
         ngoài — điều xảy ra thật khi ngăn mở bằng cú chạm (chạm không dời tiêu điểm),
         hoặc khi phần tử đang giữ tiêu điểm vừa bị gỡ khỏi trang — thì
         `activeElement` không phải `first` cũng không phải `last`, cả hai mệnh đề
         cùng trượt, không có `preventDefault`, và Tab đi tiếp vào trang phía sau.
         Trong khi `aria-modal="true"` đã hứa với trình đọc màn hình rằng phần còn lại
         của trang không tồn tại.
         Giỏ trượt đã có mệnh đề này từ vòng 16 (aef-cart-drawer.js:1469); ngăn ☰ ra
         đời sau và chép thiếu. Cùng họ với "người gác chỉ bảo vệ thứ nó được dạy nhìn". */
      else if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    }

    function open() {
      if (openState) return;
      openState = true;
      lastFocus = document.activeElement;
      root.hidden = false;
      // ép trình duyệt vẽ một nhịp trước khi gắn .is-open, nếu không thì
      // transform khởi đầu và trạng thái mở rơi vào cùng một frame ⇒ không trượt.
      void root.offsetWidth;
      root.classList.add('is-open');
      document.body.classList.add('aef-mmenu-open');
      burger.setAttribute('aria-expanded', 'true');
      var list = focusables();
      (list[0] || panel).focus();
      document.addEventListener('keydown', onKey, true);
    }

    function close() {
      if (!openState) return;
      openState = false;
      root.classList.remove('is-open');
      document.body.classList.remove('aef-mmenu-open');
      burger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKey, true);
      // chờ hết hoạt ảnh rồi mới `hidden`, nhưng trả tiêu điểm NGAY —
      // để chậm là trình đọc màn hình đọc mất một quãng trống.
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
      setTimeout(function () { if (!openState) root.hidden = true; }, 240);
    }

    burger.setAttribute('aria-expanded', 'false');
    /* 🔴 15/9/2026, vòng 49 — `aria-controls` PHẢI TRỎ VÀO CÁI NGĂN, KHÔNG PHẢI DÒNG CHỮ.
       Bản trước trỏ vào `aef-mmenu-title`. Id đó nằm trên `<span class="aef-mmenu__title">`
       bên sections/header.liquid, tức DÒNG CHỮ "Menu" bên trong ngăn — không phải cái ngăn.
       Trình đọc màn hình nào có lệnh "nhảy tới phần tử mà nút này điều khiển" sẽ thả khách
       xuống đúng chữ "Menu" rồi hết, thay vì vào 7 vùng ẩm thực + 12 ngành hàng.
       Thứ nút này thật sự đóng/mở là `root` — `<div class="aef-mmenu" data-aef-mmenu hidden>`
       — mà thẻ đó không mang id nào để trỏ tới.
       Đặt id NGAY TẠI ĐÂY chứ không bên header.liquid: chính vì id nằm một file còn câu trỏ
       nằm file khác mà suốt thời gian qua không ai thấy chúng lệch nhau. Hai dòng đứng cạnh
       nhau thì không thể trôi khỏi nhau. Và `aria-controls` vốn cũng chỉ tồn tại khi JS này
       chạy, nên id sinh ở đây không muộn hơn nó một nhịp nào. */
    if (!root.id) root.id = 'aef-mmenu';
    burger.setAttribute('aria-controls', root.id);
    if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
    burger.addEventListener('click', function (e) { e.preventDefault(); openState ? close() : open(); });
    root.querySelectorAll('[data-aef-mmenu-close]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
    // bấm một mục là điều hướng thật — đóng ngăn để lượt quay lại không thấy nó mở
    root.querySelectorAll('a[href]').forEach(function (a) { a.addEventListener('click', close); });
  }

  // ═══════════════════════════════════════════════════════════════════
  // Boot
  // ═══════════════════════════════════════════════════════════════════
  function boot() {
    applyTranslations();
    document.documentElement.setAttribute('lang', getCurrentLang());
    wireLangSwitchers();
    wireMobileMenu();
    document.querySelectorAll('[data-aef-delivery]').forEach(initOne);

    /* 🔴 24/8/2026 — BỘ DỊCH PHẢI BÁO LÀ NÓ ĐÃ SẴN SÀNG.

       `applyTranslations()` chỉ lo được đám node mang `data-i18n` sẵn trong
       HTML. Nhưng có những khối TỰ VẼ CHỮ bằng `window.aefT(...)` — chúng
       không có `data-i18n` nào để quét, chúng gọi hàm dịch rồi tự ghi.

       File này nạp bằng `defer`, còn mấy khối kia là script INLINE trong thân
       trang nên chạy TRƯỚC. Lúc chúng vẽ, `window.aefT` chưa tồn tại ⇒ rơi về
       chuỗi tiếng Anh dự phòng. Rồi không có gì gọi chúng vẽ lại.

       Trước nay chỉ có `aef:lang-changed`, mà sự kiện đó chỉ bắn trong
       `setLang()` — tức CHỈ KHI KHÁCH BẤM NÚT đổi ngôn ngữ. Khách đã chọn
       tiếng Việt từ phiên trước thì `ae_lang` đã là 'vi' ngay lúc tải, không
       ai bấm gì cả, và chữ nằm nguyên tiếng Anh cho tới khi họ đụng vào nút.

       Đo được: thanh miễn phí giao hàng ở /cart và trong NGĂN GIỎ (tức trên
       MỌI trang) hiện "Add $74.02 to cart for free shipping" trong khi từ điển
       có sẵn "Mua thêm {amount} để được {label}" và `ae_lang` = 'vi'.

       ⛔ KHÔNG bắn `aef:lang-changed` ở đây cho tiện. 13 nơi đang nghe sự kiện
       đó, trong đó `mini-cart-popup.js:487` gọi `refreshFromServer()` — bắn lúc
       tải là thêm một lượt gọi mạng trên mọi trang, cho mọi khách. Sự kiện mới
       nói đúng một chuyện đã xảy ra: hàm dịch nay đã dùng được. */
    try { document.dispatchEvent(new CustomEvent('aef:i18n-ready', { detail: { lang: getCurrentLang() } })); } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-render delivery widget when lang changes (state preserved in localStorage)
  document.addEventListener('aef:lang-changed', function () {
    document.querySelectorAll('[data-aef-delivery]').forEach(refreshFromStorage);
  });

  /* vòng 48, 14/9/2026 — giá của hãng vận chuyển về SAU khi viên đã vẽ ⇒ vẽ lại.
     Viên nằm ở header nên gần như luôn vẽ xong trước khi thanh free-ship có số
     (từ 27/9/2026: giỏ phụ Storefront + metafield; trước đó /cart/shipping_rates.json); không nghe sự kiện thì con số mới phải đợi tới lần tải trang sau.

     ⛔ KHÔNG gọi refreshFromStorage ở đây. Nhánh "khách đã tự gõ ZIP" của nó chạy
     resolveZip(root, zip, null) — tức GHI localStorage + xoá ae_zone_v1 + bắn
     `aef:zone-changed`; thanh free-ship nghe `aef:zone-changed` để hỏi giá lại,
     hỏi xong lại bắn `aef:rate-days` ⇒ vòng lặp vô tận, đúng họ lỗi đóng băng
     trang đã ghi ở khối "P0 freeze fix 2026-05-17" trong resolveZip. Ở đây LUÔN
     đi đường silent: chỉ vẽ lại, không ghi gì, không bắn gì.

     Vân tay để không nhấp nháy: cùng ZIP + cùng cặp ngày + cùng ngôn ngữ thì bỏ
     qua. congBoNgay() bắn lại mỗi lần giỏ đổi bậc tiền, mà số ngày thường không
     đổi theo tiền — không chặn thì viên fade 80ms mỗi lần khách thêm một món. */
  var _vetRateDays = '';
  document.addEventListener('aef:rate-days', function () {
    var goi = window.AEF_RATE_DAYS || {};
    var vet = String(goi.postal) + '|' + goi.min + '|' + goi.max + '|' + (goi.khongSo === true ? 'khong-so' : '') + '|' + getCurrentLang();
    if (vet === _vetRateDays) return;
    _vetRateDays = vet;
    var zip = cachedPostal();
    if (!zip) return;
    document.querySelectorAll('[data-aef-delivery]').forEach(function (root) {
      resolveZip(root, zip, { silent: true });
    });
  });

  /* 01/11/2026 — GIỎ RỖNG KẸT CÂU KHÔNG SỐ. Tệp này nạp trong header, aef-fsb.js nằm trong
     aef-app.js nạp sau, nên lượt vẽ đầu chưa có window.aefSoNgayTheoBang và ngayTheoBangCuaZip trả
     khongSo. Giỏ có món thì aef:rate-days vẽ lại, giỏ rỗng không ai bắn nó. aef-fsb.js bắn
     aef:phi-ship ở dòng cuối tệp, nên nghe đúng một lần là đủ. Vẫn đi đường silent, cùng lý do khối trên. */
  document.addEventListener('aef:phi-ship', function veLaiSauKhiCoSoTheoBang() {
    document.removeEventListener('aef:phi-ship', veLaiSauKhiCoSoTheoBang);
    var zip = cachedPostal();
    if (!zip) return;
    document.querySelectorAll('[data-aef-delivery]').forEach(function (root) {
      resolveZip(root, zip, { silent: true });
    });
  });

  /* 01/11/2026 — LỜI HỨA PHẢI TÍNH LẠI KHI QUA GIỜ CHỐT. Khách để tab qua 12:00 (tier1) hoặc 14:00,
     hoặc quay lại bằng nút Back (bfcache), vẫn đọc câu tính từ lúc tải trang. Giờ chốt nằm đúng đầu
     giờ nên khoá theo GIỜ Texas: cùng giờ thì bỏ qua, viên không nháy mỗi lần đổi tab. */
  function khoaGioTexas() {
    try {
      var n = nowInTexas();
      return n.year + '-' + n.month + '-' + n.day + '-' + n.hour;
    } catch (e) { return ''; }
  }
  var _gioDaTinh = khoaGioTexas();
  function tinhLaiNeuQuaGio() {
    var k = khoaGioTexas();
    if (k === _gioDaTinh) return;
    _gioDaTinh = k;
    var zip = cachedPostal();
    if (!zip) return;
    document.querySelectorAll('[data-aef-delivery]').forEach(function (root) {
      resolveZip(root, zip, { silent: true });
    });
  }
  window.addEventListener('pageshow', tinhLaiNeuQuaGio);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') tinhLaiNeuQuaGio();
  });
  /* Tab mở liên tục qua giờ chốt không có sự kiện nào ở trên. Mỗi phút chỉ so một khoá giờ, không chạm DOM
     trừ khi vừa qua đầu giờ; tab ẩn thì thôi, lúc hiện lại đã có visibilitychange. */
  setInterval(function () {
    if (document.visibilityState === 'visible') tinhLaiNeuQuaGio();
  }, 60000);

  // Homepage Nhóm B1 (2026-06-06): lazy-injected best-product rows
  // (assets/lazy-sections.js) carry data-i18n nodes that boot()'s
  // applyTranslations never saw — re-apply on inject so VI users don't see
  // EN literals on late-rendered cards. Idempotent textContent writes.
  document.addEventListener('aef:cards-injected', function () { applyTranslations(); });

  // ═══════════════════════════════════════════════════════════════════
  // BUG-S — Sync ZIP picker UI from zone-detection (2026-05-17, polished)
  // ═══════════════════════════════════════════════════════════════════
  // Whenever zone-detection.js resolves a postal — via ipapi (first visit),
  // 30-day cache (return visit), cart shipping address (post-checkout), OR
  // explicit user input (priority-0 path via ae_zip_code) — keep the
  // picker UI in sync.
  //
  // Initial implementation (commit 5cb6936) added a source filter that
  // skipped source='user-zip' on the theory that the picker's own submit
  // handler would have already rendered the new ZIP locally. Boss observed
  // a real edge case where that filter caused a stale pill:
  //
  //   - Customer travelling (IP detected ZIP A = 76101 / DFW)
  //   - Wants to order for a relative at ZIP B = 32311 (FL)
  //   - Submits B via the picker
  //   - Pill kept showing A until full reload
  //
  // Two separate concerns were conflated:
  //   (a) "Should we save this postal to localStorage.ae_zip_code?" — NO,
  //       only the explicit submit handler does that; otherwise IP guess
  //       could overwrite a manual choice.
  //   (b) "Should the pill UI reflect this postal?" — ALWAYS YES, as long
  //       as we have a postal to show.
  //
  // The old code answered both with the same filter. Polish fix: source
  // filter only governs (a) (we still don't write LS here), but the UI
  // sync in (b) runs unconditionally whenever ze.postal exists.
  //
  // Race-safety: bot/fallback/non-us sources never carry a postal, so the
  // early `!ze.postal` return covers them implicitly.
  // P0 freeze fix 2026-05-17: pass {silent: true} so the auto-fill path
  // doesn't trigger resolveZip's BUG-P dispatch chain. Without this, every
  // ae-zone-ready fires aeRecomputeDelivery → resolveZip → safeSet +
  // aef:zone-changed → zone-detection re-resolves → ae-zone-ready → …
  // infinite recursion → browser "Page Unresponsive".
  window.aeRecomputeDelivery = function (zip) {
    if (!zip || !/^\d{5}$/.test(String(zip))) return;
    document.querySelectorAll('[data-aef-delivery]').forEach(function (root) {
      try { resolveZip(root, String(zip), { silent: true }); } catch (e) {}
    });
  };

  // P0 freeze fix 2026-05-17: synchronous re-entry guard. Belt-and-suspenders
  // alongside resolveZip's silent flag — covers any other future code path
  // that might re-fire ae-zone-ready synchronously while we're already
  // inside the listener.
  var _aefZoneReadyBusy = false;

  function syncFromZone() {
    if (_aefZoneReadyBusy) return;
    _aefZoneReadyBusy = true;
    try {
      var ze = window.AE_ZONE;
      if (!ze) return;
      // Vùng vừa resolve xong → nói lại mọi câu có {zone_amount} theo đúng ngưỡng vùng.
      // Chạy TRƯỚC lối thoát !ze.postal vì zone vẫn xác định được khi không có ZIP
      // (suy theo bang/IP). applyTranslations chỉ ghi text, không dispatch sự kiện
      // zone nào, nên không nhóm lại chuỗi đệ quy đã gây "Page Unresponsive" 17/05;
      // vẫn nằm trong cờ _aefZoneReadyBusy cho chắc.
      try { applyTranslations(); } catch (e) {}
      if (!ze.postal) return;
      // (b) Cosmetic sync — runs for every source that carries a postal.
      // render() in resolveZip will also touch [data-aef-dw-edit] on its
      // own 80 ms timeout; setting textContent here first gives the user
      // an instant visual update (no fade gap) and is idempotent with the
      // later render() write.
      var sel = '[data-aef-dw-edit], [data-aef-zip-display],'
              + ' .aef-delivery-trigger-zip, .aef-delivery-zip-text,'
              + ' .aef-mobile-delivery-zip';
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = ze.postal;
      });
      // Recompute the delivery date for every widget instance via the
      // silent path — no LS write, no aef:zone-changed dispatch, just
      // render. Breaks the recursion at its source.
      window.aeRecomputeDelivery(ze.postal);
    } catch (e) {} finally {
      _aefZoneReadyBusy = false;
    }
  }

  // Subscribe for the normal case (event fires after widget boot).
  document.addEventListener('ae-zone-ready', syncFromZone);
  // Race-safe: if zone-detection's resolve() already completed before this
  // listener attached (cache-hit synchronous path), pick up window.AE_ZONE
  // on the spot.
  syncFromZone();
})();
